var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/components/Filters/Filters.tsx
import { Box as Box4, HStack, Text as Text4 } from "@chakra-ui/react";

// src/components/Filters/ClearButton.tsx
import { Button } from "@chakra-ui/react";
import { GreyGrey100 } from "@sequencehq/design-tokens";
import { useSearchParams } from "react-router-dom";
import { Fragment, jsx } from "react/jsx-runtime";
var ClearButton = ({
  tableConfig
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const showClearButton = tableConfig.filters?.some((filter) => {
    const filterValue = searchParams.get(filter.paramName) ?? filter.initialValue;
    return filterValue !== filter.initialValue;
  });
  return /* @__PURE__ */ jsx(Fragment, { children: showClearButton && /* @__PURE__ */ jsx(
    Button,
    {
      variant: "secondary",
      size: "sm",
      color: GreyGrey100,
      textStyle: "lato13Bold",
      px: 4,
      py: 2,
      onClick: () => {
        Array.from(searchParams.keys()).filter((key) => key !== "sortBy").forEach((filterKey) => searchParams.delete(filterKey));
        setSearchParams(searchParams);
      },
      children: "Clear filters"
    }
  ) });
};
var ClearButton_default = ClearButton;

// src/components/MultiSelect/MultiSelect.tsx
import {
  Box,
  Checkbox,
  Flex,
  List,
  ListItem,
  Text,
  useMultiStyleConfig
} from "@chakra-ui/react";
import { borderColor } from "@sequencehq/core-theme";
import {
  GreyGrey40,
  GreyGrey60,
  IndigoIndigo50
} from "@sequencehq/design-tokens";
import { useMultipleSelection, useSelect } from "downshift";
import { ChevronDown, ChevronUp, X } from "react-feather";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var ToggleButtonButtonContent = ({
  selectedItems,
  isOpen,
  clearSelectedItems
}) => {
  let contentString = "";
  const hasSelection = selectedItems.length > 0;
  if (selectedItems.length === 0) {
    contentString = "All";
  } else if (selectedItems.length === 1) {
    contentString = `${selectedItems[0].label}`;
  } else {
    contentString = `${selectedItems.length} selected`;
  }
  return /* @__PURE__ */ jsxs(Flex, { justify: "space-between", align: "center", children: [
    /* @__PURE__ */ jsx2(Text, { textStyle: "lato14Regular", children: contentString }),
    " ",
    /* @__PURE__ */ jsx2(Box, { as: "span", ml: "12px", children: hasSelection ? /* @__PURE__ */ jsx2(
      X,
      {
        size: "16px",
        onClick: (event) => {
          event.stopPropagation();
          clearSelectedItems();
        }
      }
    ) : isOpen ? /* @__PURE__ */ jsx2(ChevronUp, { size: "16px" }) : /* @__PURE__ */ jsx2(ChevronDown, { size: "16px" }) })
  ] });
};
var MultiSelect = ({
  options,
  selected,
  onChange,
  format,
  label,
  size
}) => {
  const {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    selectedItems
  } = useMultipleSelection({
    selectedItems: selected,
    itemToString: (item) => item.label,
    onSelectedItemsChange: (changes) => {
      onChange(changes.selectedItems ?? []);
    }
  });
  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    highlightedIndex,
    getItemProps
  } = useSelect({
    items: options,
    selectedItem: null,
    stateReducer: (state, { changes, type }) => {
      switch (type) {
        case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick: {
          return {
            ...changes,
            highlightedIndex: state.highlightedIndex,
            isOpen: true
          };
        }
        case useSelect.stateChangeTypes.FunctionSelectItem: {
          return {
            ...changes,
            isOpen: true
          };
        }
      }
      return changes;
    },
    onStateChange: (state) => {
      switch (state.type) {
        case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick: {
          const { selectedItem } = state;
          if (selectedItem) {
            selectedItems.some((item) => item.value === selectedItem.value) ? removeSelectedItem(selectedItem) : addSelectedItem(selectedItem);
          }
          break;
        }
        default:
          break;
      }
    }
  });
  const styles = useMultiStyleConfig("MultiSelect");
  return /* @__PURE__ */ jsxs(Box, { position: "relative", zIndex: 4, children: [
    /* @__PURE__ */ jsx2(Text, { textStyle: "lato13Bold", children: label }),
    /* @__PURE__ */ jsx2(Box, { h: "8px" }),
    /* @__PURE__ */ jsx2(
      Box,
      {
        minW: "100px",
        w: size === "lg" ? "225px" : "auto",
        p: "8px 12px",
        outline: "2px solid",
        border: `1px solid ${GreyGrey40}`,
        borderRadius: "6px",
        cursor: "pointer",
        h: "32px",
        _focusWithin: {
          outlineColor: IndigoIndigo50,
          borderColor: "transparent"
        },
        __css: styles.toggleButton,
        ...{
          borderColor,
          outlineColor: "transparent"
        },
        ...getToggleButtonProps(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          getDropdownProps({ preventKeyAction: isOpen })
        ),
        children: /* @__PURE__ */ jsx2(
          ToggleButtonButtonContent,
          {
            selectedItems: selected,
            getSelectedItemProps,
            isOpen,
            clearSelectedItems: () => onChange([])
          }
        )
      }
    ),
    /* @__PURE__ */ jsx2(
      List,
      {
        ...getMenuProps(),
        position: "absolute",
        left: 0,
        __css: styles.list,
        visibility: isOpen ? "visible" : "collapse",
        zIndex: 100,
        mt: "8px",
        pb: "0px",
        children: isOpen && /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsx2(Box, { p: "12px 16px", children: /* @__PURE__ */ jsx2(Text, { textStyle: "lato12Bold", color: GreyGrey60, children: "FILTER ON" }) }),
          options.map((option, index) => /* @__PURE__ */ jsx2(
            ListItem,
            {
              backgroundColor: highlightedIndex === index ? "green.10" : "transparent",
              alignItems: "center",
              display: "flex",
              pl: "16px",
              pr: "12px",
              pt: "6px",
              pb: index === options.length - 1 ? "10px" : "6px",
              ...getItemProps({
                item: option,
                index,
                onClick: (event) => event.preventDefault()
              }),
              children: /* @__PURE__ */ jsx2(
                Checkbox,
                {
                  isChecked: selected.some((item) => item.value === option.value),
                  width: "100%",
                  pl: 3,
                  children: /* @__PURE__ */ jsx2(Text, { textStyle: "lato14Regular", children: format(option.value, option.label) })
                }
              )
            },
            option.value
          ))
        ] })
      }
    )
  ] });
};

// src/components/Filters/MultiSelectFilter.tsx
import { useSearchParams as useSearchParams2 } from "react-router-dom";
import { jsx as jsx3 } from "react/jsx-runtime";
var MultiSelectFilter = ({
  paramName,
  options,
  format,
  label,
  size
}) => {
  const [searchParams, setSearchParams] = useSearchParams2();
  const value = searchParams.get(paramName) ?? "";
  const selected = value.split(",").map((str) => options.find((option) => option.value === str)).filter((option) => Boolean(option));
  const onChange = (values) => {
    setSearchParams((previous) => {
      if (values.length) {
        previous.set(paramName, values.map((option) => option.value).join(","));
      } else {
        previous.delete(paramName);
      }
      return previous;
    });
  };
  return /* @__PURE__ */ jsx3(
    MultiSelect,
    {
      options,
      onChange,
      selected,
      format,
      label,
      size
    }
  );
};
var MultiSelectFilter_default = MultiSelectFilter;

// src/components/Input/Input.tsx
import {
  Input as ChakraInput,
  InputGroup,
  InputLeftAddon,
  InputLeftElement,
  InputRightAddon,
  InputRightElement
} from "@chakra-ui/react";
import {
  borderColor as borderColor2,
  errorBoxShadow,
  focusedBoxShadow,
  inputBorderRadius,
  standardBorder
} from "@sequencehq/core-theme";
import { RedRed60, IndigoIndigo50 as IndigoIndigo502 } from "@sequencehq/design-tokens";
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var Input = ({
  leftAddon,
  rightAddon,
  leftElement,
  rightElement,
  width,
  inputRef,
  isInvalid,
  ...props
}) => /* @__PURE__ */ jsxs2(
  InputGroup,
  {
    width,
    variant: "input-in-group",
    role: "group",
    border: standardBorder,
    borderColor: isInvalid ? RedRed60 : borderColor2,
    borderRadius: inputBorderRadius,
    ...isInvalid ? { boxShadow: errorBoxShadow } : {},
    _focusWithin: {
      borderColor: IndigoIndigo502,
      boxShadow: focusedBoxShadow
    },
    children: [
      leftAddon && /* @__PURE__ */ jsx4(InputLeftAddon, { borderRight: standardBorder, children: leftAddon }),
      leftElement && /* @__PURE__ */ jsx4(InputLeftElement, { children: leftElement }),
      /* @__PURE__ */ jsx4(
        ChakraInput,
        {
          ref: inputRef,
          ...props,
          variant: "input-in-group",
          ...leftAddon ? { borderLeft: standardBorder } : {},
          ...rightAddon ? { borderRight: standardBorder } : {}
        }
      ),
      rightAddon && /* @__PURE__ */ jsx4(InputRightAddon, { borderLeft: standardBorder, children: rightAddon }),
      rightElement && /* @__PURE__ */ jsx4(InputRightElement, { children: rightElement })
    ]
  }
);

// src/components/Filters/SearchFilter.tsx
import { Search } from "react-feather";
import { useSearchParams as useSearchParams3 } from "react-router-dom";
import { jsx as jsx5 } from "react/jsx-runtime";
var SearchFilter = ({ paramName, initialValue }) => {
  const [searchParams, setSearchParams] = useSearchParams3();
  const value = searchParams.get(paramName) ?? initialValue;
  return /* @__PURE__ */ jsx5(
    Input,
    {
      variant: "sequence-form",
      width: "200px",
      leftElement: /* @__PURE__ */ jsx5(Search, { width: "16", height: "16" }),
      ml: 6,
      py: 2,
      pl: 2,
      value,
      onChange: (event) => {
        setSearchParams((previous) => {
          if (!event.target.value) {
            previous.delete(paramName);
            return previous;
          }
          return {
            ...previous,
            [paramName]: event.target.value
          };
        });
      }
    }
  );
};
var SearchFilter_default = SearchFilter;

// src/components/Filters/TabFilter.tsx
import { Tab, TabList, Tabs } from "@chakra-ui/react";
import { useSearchParams as useSearchParams4 } from "react-router-dom";
import { jsx as jsx6 } from "react/jsx-runtime";
var TabFilter = ({
  paramName,
  options,
  initialValue
}) => {
  const [searchParams, setSearchParams] = useSearchParams4();
  const value = searchParams.get(paramName) ?? initialValue;
  const valueIndex = options.findIndex((option) => option.value === value);
  return /* @__PURE__ */ jsx6(
    Tabs,
    {
      variant: "soft-rounded",
      index: valueIndex === -1 ? 0 : valueIndex,
      onChange: (index) => {
        setSearchParams((previous) => ({
          ...previous,
          [paramName]: options[index].value
        }));
      },
      children: /* @__PURE__ */ jsx6(TabList, { children: options.map((option) => /* @__PURE__ */ jsx6(Tab, { children: option.label }, option.label)) })
    }
  );
};
var TabFilter_default = TabFilter;

// src/components/Filters/TextFilter.tsx
import { Box as Box2, Input as ChakraInput2, Text as Text2 } from "@chakra-ui/react";

// src/lib/addOrRemoveValue/addOrRemoveValue.ts
var addOrRemoveValue = (previousValues, key, value) => {
  if (!value) {
    const { [key]: _, ...rest } = previousValues;
    return rest;
  }
  return {
    ...previousValues,
    [key]: value
  };
};

// src/components/Filters/TextFilter.tsx
import { useSearchParams as useSearchParams5 } from "react-router-dom";
import { jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
var TextFilter = ({
  paramName,
  initialValue,
  label,
  value,
  placeholder
}) => {
  const [, setSearchParams] = useSearchParams5();
  return /* @__PURE__ */ jsxs3("label", { children: [
    /* @__PURE__ */ jsx7(Text2, { textStyle: "lato13Bold", children: label }),
    /* @__PURE__ */ jsx7(Box2, { h: "8px" }),
    /* @__PURE__ */ jsx7(
      ChakraInput2,
      {
        fontSize: "14px",
        lineHeight: "16px",
        h: "32px",
        px: "12px",
        py: "8px",
        w: "200px",
        value: value ?? initialValue,
        onChange: (event) => {
          setSearchParams((previousFilters) => {
            const updatedParams = addOrRemoveValue(
              Object.fromEntries(previousFilters) || {},
              paramName,
              event.target.value
            );
            return new URLSearchParams(updatedParams);
          });
        },
        placeholder
      }
    )
  ] });
};
var TextFilter_default = TextFilter;

// src/components/DateSelect/DateSelect.tsx
import { useSelect as useSelect2, useMultipleSelection as useMultipleSelection2 } from "downshift";
import { useMemo, useState } from "react";
import {
  Box as Box3,
  Checkbox as Checkbox2,
  Divider,
  Flex as Flex2,
  List as List2,
  ListItem as ListItem2,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text as Text3,
  useMultiStyleConfig as useMultiStyleConfig2
} from "@chakra-ui/react";
import {
  IndigoIndigo50 as IndigoIndigo503,
  GreyGrey40 as GreyGrey402,
  GreyGrey60 as GreyGrey602
} from "@sequencehq/design-tokens";
import { borderColor as borderColor3 } from "@sequencehq/core-theme";
import { useDayzed } from "dayzed";
import { CalendarView } from "@sequencehq/forms";
import { format as dateFormat } from "@sequencehq/utils/dates";
import { ChevronDown as ChevronDown2, ChevronUp as ChevronUp2, X as X2 } from "react-feather";
import { dayzedAdapter } from "@sequencehq/core-components";
import { Fragment as Fragment2, jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var ToggleButtonButtonContent2 = ({
  selectedItem,
  selectedDate,
  isOpen,
  clearSelectedItem
}) => {
  let contentString;
  if (selectedItem) {
    if (selectedItem.value === "custom" && selectedDate) {
      contentString = `${dateFormat(selectedDate, "d MMM yyyy")}`;
    } else {
      contentString = `${selectedItem.label}`;
    }
  } else {
    contentString = "All";
  }
  return /* @__PURE__ */ jsxs4(Flex2, { justify: "space-between", align: "center", children: [
    /* @__PURE__ */ jsx8(Text3, { textStyle: "lato14Regular", children: contentString }),
    " ",
    /* @__PURE__ */ jsx8(Box3, { as: "span", ml: "12px", children: selectedItem ? /* @__PURE__ */ jsx8(
      X2,
      {
        size: "16px",
        onClick: (event) => {
          event.stopPropagation();
          clearSelectedItem();
        }
      }
    ) : isOpen ? /* @__PURE__ */ jsx8(ChevronUp2, { size: "16px" }) : /* @__PURE__ */ jsx8(ChevronDown2, { size: "16px" }) })
  ] });
};
var DateSelect = ({
  options,
  format,
  label,
  selected,
  selectedDate,
  setDateParam
}) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const { getDropdownProps } = useMultipleSelection2();
  const customOption = useMemo(
    () => ({
      label: "Custom...",
      value: "custom"
    }),
    []
  );
  const selectItems = useMemo(
    () => [...options, customOption],
    [options, customOption]
  );
  const customOptionIndex = useMemo(
    () => selectItems.findIndex(({ value }) => value === customOption.value),
    [selectItems, customOption.value]
  );
  let selectedOptionItem = selected;
  if (selectedOptionItem === null && selectedDate) {
    selectedOptionItem = customOption;
  }
  const {
    closeMenu,
    isOpen,
    getMenuProps,
    highlightedIndex,
    getItemProps,
    getToggleButtonProps,
    selectedItem
  } = useSelect2({
    items: selectItems,
    selectedItem: selectedOptionItem,
    onSelectedItemChange: ({ selectedItem: newSelectedItem }) => {
      if (newSelectedItem && newSelectedItem.value !== "custom") {
        const dateInUtc = new Date(newSelectedItem.value);
        setDateParam(dateInUtc);
      }
    },
    stateReducer: (state, { changes, type }) => {
      let keepOpen = false;
      switch (type) {
        case useSelect2.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect2.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case useSelect2.stateChangeTypes.ItemClick:
          if (state.highlightedIndex === customOptionIndex) {
            setShowCalendar(true);
            keepOpen = true;
          } else {
            setShowCalendar(false);
          }
          return {
            ...changes,
            highlightedIndex: state.highlightedIndex,
            isOpen: keepOpen
          };
      }
      return changes;
    }
  });
  const { calendars, getDateProps, getBackProps, getForwardProps } = useDayzed({
    selected: selectedDate ? dayzedAdapter.toDayzed(selectedDate) : void 0,
    date: dayzedAdapter.toDayzed(/* @__PURE__ */ new Date()),
    monthsToDisplay: 1,
    firstDayOfWeek: 1,
    onDateSelected: ({ date }) => {
      setDateParam(dayzedAdapter.fromDayzed(date));
      setShowCalendar(false);
      closeMenu();
    }
  });
  const styles = useMultiStyleConfig2("MultiSelect");
  return /* @__PURE__ */ jsxs4(Box3, { position: "relative", children: [
    /* @__PURE__ */ jsx8(Text3, { textStyle: "lato13Bold", children: label }),
    /* @__PURE__ */ jsx8(Box3, { h: "8px" }),
    /* @__PURE__ */ jsx8(
      Box3,
      {
        minW: label === "Customer" ? "225px" : "100px",
        p: "8px 12px",
        outline: "2px solid",
        border: `1px solid ${GreyGrey402}`,
        borderRadius: "6px",
        cursor: "pointer",
        h: "32px",
        _focusWithin: {
          outlineColor: IndigoIndigo503,
          borderColor: "transparent"
        },
        __css: styles.toggleButton,
        ...{
          borderColor: borderColor3,
          outlineColor: "transparent"
        },
        ...getToggleButtonProps(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          getDropdownProps({ preventKeyAction: isOpen })
        ),
        children: /* @__PURE__ */ jsx8(
          ToggleButtonButtonContent2,
          {
            selectedItem,
            selectedDate,
            isOpen,
            clearSelectedItem: () => setDateParam(null)
          }
        )
      }
    ),
    /* @__PURE__ */ jsx8(
      List2,
      {
        ...getMenuProps(),
        position: "absolute",
        left: 0,
        __css: styles.list,
        visibility: isOpen ? "visible" : "collapse",
        zIndex: 100,
        mt: "8px",
        pb: "0px",
        children: isOpen && /* @__PURE__ */ jsxs4(Fragment2, { children: [
          /* @__PURE__ */ jsxs4(Box3, { children: [
            /* @__PURE__ */ jsx8(Box3, { py: "12px", px: "16px", children: /* @__PURE__ */ jsx8(Text3, { textStyle: "lato12Bold", color: GreyGrey602, children: "FILTER ON" }) }),
            options.map((option, index) => {
              const isChecked = selectedItem?.value === option.value;
              return /* @__PURE__ */ jsx8(
                ListItem2,
                {
                  backgroundColor: highlightedIndex === index ? "green.10" : "transparent",
                  alignItems: "center",
                  display: "flex",
                  pl: "16px",
                  pr: "12px",
                  pt: "12px",
                  pb: index === options.length - 1 ? "16px" : "12px",
                  ...getItemProps({
                    item: option,
                    index,
                    onClick: (event) => event.preventDefault()
                  }),
                  children: /* @__PURE__ */ jsx8(Checkbox2, { isChecked, width: "100%", children: /* @__PURE__ */ jsx8(Text3, { textStyle: "lato14Regular", children: format(option.value, option.label) }) })
                },
                index
              );
            })
          ] }),
          /* @__PURE__ */ jsx8(Divider, { variant: "subtle" }),
          /* @__PURE__ */ jsx8(Box3, { children: /* @__PURE__ */ jsxs4(
            Popover,
            {
              isOpen: showCalendar,
              placement: "bottom-start",
              onClose: () => setShowCalendar(false),
              children: [
                /* @__PURE__ */ jsx8(PopoverTrigger, { children: /* @__PURE__ */ jsx8(
                  ListItem2,
                  {
                    backgroundColor: highlightedIndex === customOptionIndex ? "green.10" : "transparent",
                    padding: "16px 16px 12px 16px",
                    alignItems: "center",
                    display: "flex",
                    cursor: "pointer",
                    onClick: () => setShowCalendar(true),
                    ...getItemProps({
                      item: customOption,
                      index: customOptionIndex,
                      onClick: (event) => event.preventDefault()
                    }),
                    children: /* @__PURE__ */ jsx8(Text3, { textStyle: "lato14Regular", children: "Custom..." })
                  },
                  "custom"
                ) }),
                /* @__PURE__ */ jsx8(PopoverContent, { children: /* @__PURE__ */ jsx8(PopoverBody, { children: /* @__PURE__ */ jsx8(
                  CalendarView,
                  {
                    calendar: calendars[0],
                    getDateProps,
                    getBackProps,
                    getForwardProps,
                    selectedDate: selectedDate ?? /* @__PURE__ */ new Date(),
                    type: "single"
                  }
                ) }) })
              ]
            }
          ) })
        ] })
      }
    )
  ] });
};

// src/components/Filters/DateSelectFilter.tsx
import { useSearchParams as useSearchParams6 } from "react-router-dom";
import { isSameDay } from "@sequencehq/utils/dates";
import { jsx as jsx9 } from "react/jsx-runtime";
var DateSelectFilter = ({
  paramName,
  options,
  format,
  label,
  stringifyDate
}) => {
  const [searchParams, setSearchParams] = useSearchParams6();
  const paramValue = searchParams.get(paramName);
  const paramValueAsDate = new Date(paramValue ?? "");
  const selected = options.find(
    ({ value }) => isSameDay(new Date(value), paramValueAsDate)
  );
  let selectedDate = selected?.value ? new Date(selected.value) : null;
  if (!!paramValue && selectedDate === null) {
    selectedDate = new Date(paramValue);
  }
  return /* @__PURE__ */ jsx9(
    DateSelect,
    {
      options,
      format,
      paramName,
      label,
      selected: selected ?? null,
      selectedDate,
      setDateParam: (date) => {
        setSearchParams((previous) => {
          let updatedFilters;
          if (date === null) {
            previous.delete(paramName);
            updatedFilters = previous;
          } else {
            updatedFilters = addOrRemoveValue(
              Object.fromEntries(previous) || {},
              paramName,
              stringifyDate(date)
            );
          }
          return new URLSearchParams(updatedFilters);
        });
      }
    }
  );
};
var DateSelectFilter_default = DateSelectFilter;

// src/components/Filters/Filters.tsx
import { useSearchParams as useSearchParams7 } from "react-router-dom";
import { Fragment as Fragment3, jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
var Filters = ({
  tableConfig
}) => {
  const [searchParams] = useSearchParams7();
  if (!tableConfig.filters) {
    return null;
  }
  return /* @__PURE__ */ jsxs5(Fragment3, { children: [
    /* @__PURE__ */ jsxs5(
      HStack,
      {
        justifyContent: "flex-start",
        alignItems: "flex-end",
        spacing: 4,
        px: 6,
        pt: 6,
        children: [
          tableConfig.filters.map(
            (config) => {
              const paramValue = searchParams.get(config.paramName);
              const value = paramValue ?? config.initialValue;
              switch (config.type) {
                case "search":
                  return /* @__PURE__ */ jsx10(
                    SearchFilter_default,
                    {
                      paramName: config.paramName,
                      initialValue: config.initialValue
                    },
                    config.paramName
                  );
                case "tabs":
                  return /* @__PURE__ */ jsx10(
                    TabFilter_default,
                    {
                      options: config.options,
                      paramName: config.paramName,
                      initialValue: config.initialValue
                    },
                    config.paramName
                  );
                case "multiSelect":
                  return /* @__PURE__ */ jsx10(
                    MultiSelectFilter_default,
                    {
                      options: config.options,
                      format: config.format,
                      paramName: config.paramName,
                      label: config.label,
                      size: config.size
                    },
                    config.paramName
                  );
                case "text":
                  return /* @__PURE__ */ jsx10(
                    TextFilter_default,
                    {
                      paramName: config.paramName,
                      initialValue: searchParams.get(config.paramName) ?? config.initialValue,
                      label: config.label,
                      value,
                      placeholder: config.placeholder
                    },
                    config.paramName
                  );
                case "date":
                  return /* @__PURE__ */ jsx10(
                    DateSelectFilter_default,
                    {
                      options: config.options,
                      format: config.format,
                      paramName: config.paramName,
                      label: config.label,
                      stringifyDate: config.stringifyDate
                    },
                    config.paramName
                  );
                case "boolean":
                  return /* @__PURE__ */ jsx10(
                    MultiSelectFilter_default,
                    {
                      options: [
                        { label: config.trueLabel, value: "true" },
                        { label: config.falseLabel, value: "false" }
                      ],
                      format: (item) => /* @__PURE__ */ jsx10(Text4, { children: item }),
                      paramName: config.paramName,
                      label: config.label
                    },
                    config.paramName
                  );
              }
            }
          ),
          /* @__PURE__ */ jsx10(ClearButton_default, { tableConfig })
        ]
      }
    ),
    /* @__PURE__ */ jsx10(Box4, { minHeight: "24px" })
  ] });
};
var Filters_default = Filters;

// src/components/VirtualTable/useVirtualTable.tsx
import { useVirtualizer } from "@tanstack/react-virtual";

// src/components/VirtualTable/useFilterState.ts
import { useMemo as useMemo2 } from "react";
import { useSearchParams as useSearchParams8 } from "react-router-dom";
var scrubFilters = (tableConfig, searchParams) => {
  const filterConfig = tableConfig.filters ?? [];
  const filterValues = filterConfig.reduce(
    (acc, filter) => {
      const filterValue = searchParams.get(filter.paramName);
      return filterValue ? { ...acc, [filter.paramName]: filterValue } : acc;
    },
    {}
  );
  return filterValues;
};
var useFilterState = (tableConfig) => {
  const [searchParams] = useSearchParams8();
  return useMemo2(
    () => scrubFilters(tableConfig, searchParams),
    [searchParams.toString(), tableConfig]
  );
};

// src/components/VirtualTable/types.ts
var SORT_BY_KEY = "sortBy";

// src/components/VirtualTable/useSortState.ts
import { useMemo as useMemo3 } from "react";
import { useSearchParams as useSearchParams9 } from "react-router-dom";
var useSortState = () => {
  const [searchParams] = useSearchParams9();
  const sortBy = searchParams.get(SORT_BY_KEY);
  return useMemo3(() => {
    if (!sortBy) {
      return void 0;
    }
    if (sortBy.endsWith("_desc")) {
      return {
        sortBy: sortBy.replace("_desc", ""),
        sortOrder: "DESC"
      };
    }
    if (sortBy.endsWith("_asc")) {
      return {
        sortBy: sortBy.replace("_asc", ""),
        sortOrder: "ASC"
      };
    }
    return void 0;
  }, [sortBy]);
};

// src/components/constants.ts
var VIRTUAL_TABLE_FETCH_LIMIT = 50;
var HEIGHT = 48;
var OVERSCAN = 50;
var INCREASED_TABLE_FETCH_LIMIT = 100;

// src/components/VirtualTable/useVirtualTable.tsx
import { useCallback, useEffect, useMemo as useMemo4, useRef, useState as useState2 } from "react";
import * as Sentry from "@sentry/react";
import { dequal } from "dequal";
var filterStateToBoolean = (filterState) => {
  return Boolean(filterState && Object.keys(filterState).length);
};
var useVirtualTable = ({
  propFilters,
  tableConfig,
  useLazyQuery,
  resetKey,
  initialResultSize,
  limitResults
}) => {
  const parentRef = useRef(null);
  const [rows, setRows] = useState2([]);
  const [totalResultSize, setTotalResultSize] = useState2();
  const [offset, setOffset] = useState2();
  const filterState = useFilterState(tableConfig);
  const sortState = useSortState();
  const [hasFilters, setHasFilters] = useState2(
    filterStateToBoolean(filterState)
  );
  const [hasInitiallyFetched, setHasInitiallyFetched] = useState2(false);
  const [triggerLazyQuery, lazyRes] = useLazyQuery();
  const rowVirtualizer = useVirtualizer({
    count: totalResultSize ?? initialResultSize,
    getScrollElement: () => parentRef.current,
    estimateSize: () => tableConfig.rowHeight ?? HEIGHT,
    overscan: OVERSCAN,
    getItemKey: (index) => rows[index] ? rows[index].id : `LOADING-${index}`
  });
  const lastItem = rowVirtualizer.getVirtualItems().slice().pop();
  const fetchNeeded = !lastItem || lastItem?.index + 5 > rows.length;
  const params = useMemo4(() => {
    return {
      queryArgs: {
        ...filterState,
        ...propFilters,
        ...sortState,
        limit: limitResults || VIRTUAL_TABLE_FETCH_LIMIT
      },
      filterState
    };
  }, [filterState, propFilters, sortState]);
  useEffect(() => {
    setOffset(void 0);
  }, [JSON.stringify(params), resetKey]);
  const processResponse = useCallback(
    (parsedData) => {
      if (!parsedData) {
        return;
      }
      const { pagination, items } = parsedData;
      setOffset(pagination.after ?? "FINISHED");
      if (pagination.totalResultSize === void 0) {
        setRows((currentRows) => currentRows.concat(items));
      } else {
        setHasFilters(filterStateToBoolean(params.filterState));
        setRows(items);
        if (limitResults) {
          setTotalResultSize(items.length);
        } else {
          setTotalResultSize(pagination.totalResultSize);
        }
      }
    },
    [params.filterState]
  );
  useEffect(() => {
    const parsedData = lazyRes.data?.value();
    if (!dequal(parsedData?.items, rows)) {
      processResponse(parsedData);
    }
  }, [lazyRes]);
  useEffect(() => {
    if (rows.length === 0) {
      const parsedData = lazyRes.data?.value();
      processResponse(parsedData);
    }
  }, [lazyRes, rows.length]);
  useEffect(() => {
    if (!!limitResults && hasInitiallyFetched) {
      return;
    }
    if (offset !== void 0 && (!fetchNeeded || offset === "FINISHED")) {
      return;
    }
    triggerLazyQuery({ ...params.queryArgs, after: offset }, true).then((queryRes) => {
      const parsedData = queryRes.data?.value();
      processResponse(parsedData);
      setHasInitiallyFetched(true);
    }).catch((error) => Sentry.captureException(error));
  }, [JSON.stringify(params), fetchNeeded, offset]);
  return {
    parentRef,
    rowVirtualizer,
    rows,
    totalResultSize,
    hasFilters
  };
};

// src/components/VirtualTable/Loading.tsx
import { Skeleton } from "@chakra-ui/react";
import { memo } from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
var Loading = memo(
  ({
    height = "24px",
    width = "100%"
  }) => /* @__PURE__ */ jsx11(
    Skeleton,
    {
      height,
      width,
      borderRadius: "12px",
      backgroundColor: "#F2F4F7",
      endColor: "gray.20",
      startColor: "gray.0",
      opacity: "unset"
    }
  )
);

// src/components/VirtualTable/VirtualTable.tsx
import { Box as Box6, Flex as Flex4, Table, Tbody, Td as Td2, Text as Text6, Tr as Tr3 } from "@chakra-ui/react";
import { useState as useState3 } from "react";
import { useNavigate } from "react-router-dom";
import { borderColor as borderColor5 } from "@sequencehq/core-theme";

// src/components/VirtualTable/VirtualTableHead.tsx
import { ChevronUpIcon, ChevronDownIcon } from "@sequencehq/core-components";
import { Box as Box5, Th, Thead, Tr, Text as Text5, Flex as Flex3 } from "@chakra-ui/react";
import { GreyGrey60 as GreyGrey603 } from "@sequencehq/design-tokens";
import { borderColor as borderColor4 } from "@sequencehq/core-theme";
import { useSearchParams as useSearchParams10 } from "react-router-dom";

// src/components/VirtualTable/getSortOrder.ts
var getSortOrder = (sortBy, sortName) => {
  if (!sortName) {
    return "NONE";
  }
  if (sortBy === `${sortName}_asc`) {
    return "ASC";
  }
  if (sortBy === `${sortName}_desc`) {
    return "DESC";
  }
  return "NONE";
};

// src/components/VirtualTable/VirtualTableHead.tsx
import { Fragment as Fragment4, jsx as jsx12, jsxs as jsxs6 } from "react/jsx-runtime";
var VirtualTableHead = (props) => {
  const { tableConfig } = props;
  const [searchParams, setSearchParams] = useSearchParams10();
  const sortBy = searchParams.get(SORT_BY_KEY);
  const handleSort = (sortName) => {
    if (!sortName) {
      return;
    }
    const sortDirection = getSortOrder(sortBy, sortName);
    setSearchParams(() => {
      const searchParamsObject = Object.fromEntries(searchParams);
      switch (sortDirection) {
        case "NONE": {
          return {
            ...searchParamsObject,
            [SORT_BY_KEY]: `${sortName}_asc`
          };
        }
        case "ASC": {
          return {
            ...searchParamsObject,
            [SORT_BY_KEY]: `${sortName}_desc`
          };
        }
        case "DESC": {
          const { [SORT_BY_KEY]: deleted, ...rest } = searchParamsObject;
          return rest;
        }
      }
    });
  };
  return /* @__PURE__ */ jsx12(Thead, { children: /* @__PURE__ */ jsxs6(Tr, { role: "row", children: [
    tableConfig.checkable && /* @__PURE__ */ jsx12(
      Th,
      {
        position: "sticky",
        left: 0,
        width: "40px",
        backgroundColor: "gray.0",
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: borderColor4
      }
    ),
    tableConfig.columns.map(
      ({
        heading,
        width: columnWidth = "200px",
        sortName,
        sticky,
        action,
        format
      }, index) => {
        const sortDirection = getSortOrder(sortBy, sortName);
        return /* @__PURE__ */ jsx12(
          Th,
          {
            width: columnWidth,
            ...sticky && {
              position: "sticky",
              right: 0
            },
            backgroundColor: "gray.0",
            cursor: sortName ? "pointer" : "default",
            _hover: {
              backgroundColor: sortName ? "gray.20" : ""
            },
            children: /* @__PURE__ */ jsxs6(
              Flex3,
              {
                width: "100%",
                height: "100%",
                padding: "12px",
                borderBottomWidth: "1px",
                borderBottomStyle: "solid",
                borderBottomColor: borderColor4,
                isolation: action ? "isolate" : "auto",
                onClick: () => {
                  handleSort(sortName);
                },
                alignItems: "center",
                justifyContent: format === "number" ? "flex-end" : "flex-start",
                children: [
                  format === "number" ? /* @__PURE__ */ jsxs6(Fragment4, { children: [
                    sortDirection === "ASC" ? /* @__PURE__ */ jsx12(
                      ChevronUpIcon,
                      {
                        color: GreyGrey603,
                        width: "8px",
                        height: "5px"
                      }
                    ) : null,
                    sortDirection === "DESC" ? /* @__PURE__ */ jsx12(
                      ChevronDownIcon,
                      {
                        color: GreyGrey603,
                        width: "8px",
                        height: "5px"
                      }
                    ) : null,
                    /* @__PURE__ */ jsx12(Box5, { width: "8px" })
                  ] }) : null,
                  /* @__PURE__ */ jsx12(Text5, { textStyle: "columnHeading", children: heading ?? "\xA0" }),
                  format !== "number" ? /* @__PURE__ */ jsxs6(Fragment4, { children: [
                    /* @__PURE__ */ jsx12(Box5, { width: "8px" }),
                    sortDirection === "ASC" ? /* @__PURE__ */ jsx12(
                      ChevronUpIcon,
                      {
                        color: GreyGrey603,
                        width: "8px",
                        height: "5px"
                      }
                    ) : null,
                    sortDirection === "DESC" ? /* @__PURE__ */ jsx12(
                      ChevronDownIcon,
                      {
                        color: GreyGrey603,
                        width: "8px",
                        height: "5px"
                      }
                    ) : null,
                    /* @__PURE__ */ jsx12(Box5, { width: 1 })
                  ] }) : null
                ]
              }
            )
          },
          heading ?? index
        );
      }
    )
  ] }) });
};

// src/components/VirtualTable/VirtualTableRow.tsx
import { Checkbox as Checkbox3, Td, Tr as Tr2 } from "@chakra-ui/react";
import { GreyGrey40 as GreyGrey403 } from "@sequencehq/design-tokens";
import { memo as memo2, useCallback as useCallback2 } from "react";
import { jsx as jsx13, jsxs as jsxs7 } from "react/jsx-runtime";
var VirtualTableRow = ({
  index,
  size,
  rows,
  navigate,
  tableConfig,
  handleSelect,
  selectedRows
}) => {
  const { rowPath, styles } = tableConfig;
  const isChecked = selectedRows[rows[index]?.id];
  const onChange = useCallback2(() => handleSelect(rows[index]?.id), []);
  return /* @__PURE__ */ jsxs7(
    Tr2,
    {
      role: "row",
      height: `${size}px`,
      "data-index": index,
      cursor: rowPath ? "pointer" : "default",
      borderRightWidth: "0px",
      onClick: () => {
        rowPath && rows[index] && navigate(rowPath(rows[index]));
      },
      borderColor: GreyGrey403,
      sx: {
        "&:hover td": {
          backgroundColor: styles?.rowHoverColor ?? "gray.10"
        },
        "&:active td": {
          backgroundColor: "gray.20"
        }
      },
      children: [
        tableConfig.checkable && /* @__PURE__ */ jsx13(CheckboxCell, { isChecked, onChange }),
        tableConfig.columns.map(
          ({
            heading,
            formatter,
            width: columnWidth = "200px",
            sticky,
            contentTextAlign = "left",
            format,
            action,
            px = 3,
            paddingLeft,
            paddingRight
          }, columnIndex) => /* @__PURE__ */ jsx13(
            Td,
            {
              width: columnWidth,
              py: "auto",
              px,
              paddingLeft,
              paddingRight,
              textAlign: format === "number" ? "right" : contentTextAlign,
              role: "group",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              isolation: action ? "isolate" : "auto",
              color: "gray.100",
              backgroundColor: action ? "white" : "transparent",
              onClick: action ? (e) => e.stopPropagation() : void 0,
              ...sticky && {
                position: "sticky",
                right: 0,
                zIndex: 1,
                _focusWithin: {
                  zIndex: 2
                }
              },
              children: rows[index] ? formatter(rows[index]) : /* @__PURE__ */ jsx13(Loading, {})
            },
            heading ?? columnIndex
          )
        )
      ]
    }
  );
};
var CheckboxCell = memo2(({ isChecked, onChange }) => /* @__PURE__ */ jsx13(
  Td,
  {
    position: "sticky",
    left: 0,
    zIndex: 1,
    _focusWithin: {
      zIndex: 2
    },
    textAlign: "center",
    px: 3,
    py: 4,
    display: "flex",
    alignItems: "center",
    isolation: "isolate",
    backgroundColor: "white",
    onClick: (e) => e.stopPropagation(),
    children: /* @__PURE__ */ jsx13(Checkbox3, { isChecked, onChange })
  }
));

// src/components/VirtualTable/VirtualTable.tsx
import { useQuery } from "@sequencehq/api";
import { Fragment as Fragment5, jsx as jsx14, jsxs as jsxs8 } from "react/jsx-runtime";
var adaptApiToVirtualTable = (apiFn) => {
  const [params, setParams] = useState3({});
  const query = useQuery(apiFn, params);
  const fetch = async (params2) => {
    setParams(params2);
    const res = await query.refetch();
    return {
      data: {
        value: () => res.data
      }
    };
  };
  return [
    fetch,
    {
      data: {
        value: () => query.data
      }
    }
  ];
};
var VirtualTable = (props) => {
  const { parentRef, rowVirtualizer, rows, totalResultSize, hasFilters } = useVirtualTable(props);
  const {
    tableConfig,
    noResultsMessage,
    insideContainer,
    width,
    emptyState,
    maxHeight,
    hideResultsCount,
    headerRow,
    footerRow
  } = props;
  const navigate = useNavigate();
  const virtualRows = rowVirtualizer.getVirtualItems();
  const [selectedRows, setSelectedRows] = useState3({});
  const handleSelect = (id) => {
    id && setSelectedRows((selected) => ({ ...selected, [id]: !selected[id] }));
  };
  const paddingTop = virtualRows.length > 0 ? virtualRows?.[0]?.start || 0 : 0;
  const paddingBottom = virtualRows.length > 0 ? rowVirtualizer.getTotalSize() - (virtualRows?.[virtualRows.length - 1]?.end || 0) : 0;
  const columnCount = tableConfig.columns.length + (tableConfig.checkable ? 1 : 0);
  const renderEmptyState = !hasFilters && emptyState && totalResultSize === 0;
  return /* @__PURE__ */ jsx14(
    Flex4,
    {
      flexDirection: "column",
      minHeight: "0",
      pt: tableConfig.styles?.pt ? tableConfig.styles.pt : tableConfig.filters ? 0 : "24px",
      width: width || "100%",
      height: "100%",
      maxHeight: maxHeight || `calc(100vh - ${tableConfig.shortenTableBy || "0px"})`,
      "data-testid": "virtualTable",
      children: renderEmptyState ? emptyState : /* @__PURE__ */ jsxs8(Fragment5, { children: [
        /* @__PURE__ */ jsx14(Filters_default, { tableConfig }),
        headerRow,
        /* @__PURE__ */ jsx14(
          Flex4,
          {
            px: tableConfig.styles?.px ? tableConfig.styles.px : "6",
            maxHeight: tableConfig.styles?.maxHeight ? tableConfig.styles.maxHeight : "100%",
            minHeight: "0",
            height: "100%",
            children: /* @__PURE__ */ jsxs8(
              Box6,
              {
                ref: parentRef,
                overflow: "auto",
                width: "100%",
                minHeight: tableConfig.rowHeight ?? HEIGHT,
                children: [
                  tableConfig.title && /* @__PURE__ */ jsx14(Text6, { textStyle: "header3", px: "3", children: tableConfig.title }),
                  /* @__PURE__ */ jsxs8(
                    Table,
                    {
                      variant: "virtual",
                      style: { tableLayout: "fixed" },
                      width: insideContainer ? "auto" : "100%",
                      minWidth: insideContainer ? "100%" : "auto",
                      children: [
                        !tableConfig.noHeader ? /* @__PURE__ */ jsx14(VirtualTableHead, { tableConfig }) : null,
                        /* @__PURE__ */ jsxs8(Tbody, { children: [
                          paddingTop > 0 && /* @__PURE__ */ jsx14("tr", { children: tableConfig.columns.map(
                            ({ width: columnWidth = "200px" }, index) => /* @__PURE__ */ jsx14(
                              "td",
                              {
                                style: { height: `${paddingTop}px` },
                                width: columnWidth
                              },
                              index
                            )
                          ) }),
                          totalResultSize === 0 && /* @__PURE__ */ jsx14(Tr3, { role: "row", children: /* @__PURE__ */ jsx14(Td2, { colSpan: columnCount, textAlign: "center", children: noResultsMessage ?? "No results found" }) }),
                          virtualRows.map(({ key, index, size }) => /* @__PURE__ */ jsx14(
                            VirtualTableRow,
                            {
                              rows,
                              size,
                              index,
                              navigate,
                              handleSelect,
                              tableConfig,
                              selectedRows
                            },
                            key
                          )),
                          paddingBottom > 0 && /* @__PURE__ */ jsx14("tr", { children: /* @__PURE__ */ jsx14(
                            "td",
                            {
                              style: { height: `${paddingBottom}px` },
                              colSpan: columnCount
                            }
                          ) })
                        ] })
                      ]
                    }
                  )
                ]
              }
            )
          }
        ),
        !tableConfig.bulkActions && !(hideResultsCount || false) && /* @__PURE__ */ jsx14(
          Flex4,
          {
            borderTopWidth: "1px",
            borderTopStyle: "solid",
            borderTopColor: borderColor5,
            px: tableConfig.styles?.px ? tableConfig.styles.px : "12px",
            py: "16px",
            mx: tableConfig.styles?.mx ? tableConfig.styles.mx : "24px",
            mb: "24px",
            justifyContent: "flex-start",
            children: /* @__PURE__ */ jsx14(Text6, { color: "gray.70", fontSize: "14px", lineHeight: "16px", children: totalResultSize === void 0 ? "Loading..." : `${totalResultSize} results` })
          }
        ),
        tableConfig.bulkActions && tableConfig.bulkActions(
          /* @__PURE__ */ jsx14(
            Flex4,
            {
              borderTopWidth: "1px",
              borderTopStyle: "solid",
              borderTopColor: borderColor5,
              px: "12px",
              py: "16px",
              mx: "24px",
              mb: "24px",
              justifyContent: "flex-start",
              children: /* @__PURE__ */ jsx14(Text6, { color: "gray.60", fontSize: "14px", lineHeight: "16px", children: totalResultSize === void 0 ? "Loading..." : `${totalResultSize} results` })
            }
          ),
          rows.filter((value) => selectedRows[value.id]),
          () => setSelectedRows({}),
          tableConfig
        ),
        footerRow
      ] })
    }
  );
};
var VirtualTable_default = VirtualTable;

// src/components/MagicTable/MagicTable.tsx
import { Box as Box20, Grid } from "@chakra-ui/react";
import { GreyGrey20 as GreyGrey203 } from "@sequencehq/design-tokens";
import {
  getCoreRowModel,
  getExpandedRowModel,
  useReactTable
} from "@tanstack/react-table";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarV3.tsx
import { Flex as Flex10 } from "@chakra-ui/react";
import { GreyGrey30 as GreyGrey304 } from "@sequencehq/design-tokens";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilters/ActiveFilterPill/ActiveFilterPill.tsx
import { useCallback as useCallback8, useEffect as useEffect6, useRef as useRef2 } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Button as Button3,
  Flex as Flex7,
  MenuList,
  Text as Text11,
  Menu,
  Portal,
  MenuItem as MenuItem3,
  useDisclosure
} from "@chakra-ui/react";
import {
  GreyGrey30 as GreyGrey302,
  GreyGrey40 as GreyGrey404,
  GreyGrey50 as GreyGrey502,
  GreyGrey60 as GreyGrey604,
  GreyGrey70,
  GreyGrey80 as GreyGrey802,
  GreyWhite,
  Lato13Bold as Lato13Bold3,
  Lato13Regular as Lato13Regular3
} from "@sequencehq/design-tokens";
import { CheckIcon as CheckIcon2, XMarkIcon } from "@heroicons/react/16/solid";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuSelectedFilter.tsx
import { match as match4 } from "ts-pattern";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuMultiSelect/MenuMultiSelect.tsx
import {
  MenuItem,
  Checkbox as Checkbox4,
  Spinner,
  Center,
  Box as Box7,
  MenuDivider,
  Text as Text7
} from "@chakra-ui/react";
import { GreyGrey50, Lato13Regular } from "@sequencehq/design-tokens";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuMultiSelect/useMenuMultiSelect.tsx
import { useCallback as useCallback6, useEffect as useEffect4, useMemo as useMemo7, useState as useState6 } from "react";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarV3Provider.tsx
import {
  createContext,
  useEffect as useEffect3,
  useMemo as useMemo5,
  useReducer,
  useState as useState4
} from "react";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarV3Provider.constants.ts
var INITIAL_DATA = {
  grouping: {
    groupableColumns: void 0,
    groupBy: void 0,
    onGroupBy: void 0
  },
  menuFilters: [],
  viewSettingsFilters: [],
  columnOrder: [],
  activeFilters: [],
  loading: false,
  customColumns: {
    available: [],
    selected: []
  },
  optionsCache: {}
};
var INITIAL_STATE = {
  data: INITIAL_DATA,
  queries: {
    canDisplayAddFiltersMenu: () => false,
    canChangeFilters: () => false,
    canClearAllFilters: () => ({ visible: false, enabled: false }),
    useSmallAddFilterButton: () => false,
    canAddCustomColumns: () => false,
    canSaveFilter: () => ({
      visible: false,
      enabled: false
    })
  },
  functions: {
    getTableState: () => {
    },
    getTableAllFlatColumns: () => [],
    setColumnOrder: () => {
    },
    clearAllFilters: () => {
    },
    removeFilter: () => {
    },
    toggleMultiSelectOption: () => {
    },
    bulkSetMultiSelectOptions: () => {
    },
    switchToggleOption: () => {
    },
    setTextFilter: () => {
    },
    setAddFilterMenuWidth: () => {
    },
    setDatePreset: () => {
    },
    addDateCustom: () => {
    },
    updateDateCustomOperator: () => {
    },
    updateDateCustomDate: () => {
    },
    addCustomColumn: () => {
    },
    removeCustomColumn: () => {
    },
    tidyEmptyFilters: () => {
    }
  },
  ui: {
    addFilterMenuWidth: "154px"
  }
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/OptionsCache/useOptionsCache.ts
import { useEffect as useEffect2 } from "react";
import * as Sentry2 from "@sentry/react";
var useOptionsCache = ({ menuFilters, dispatch }) => {
  useEffect2(() => {
    const initialiseCache = async () => {
      const filtersWithOptionsFunc = menuFilters.filter(
        (filter) => (filter.type === "multiSelect" || filter.type === "multiSelectAliased") && Boolean(filter.optionsFunc)
      );
      const initialisedCache = await Promise.all(
        filtersWithOptionsFunc.map(async (filter) => {
          if (filter.type !== "multiSelect" && filter.type !== "multiSelectAliased" || !filter.optionsFunc) {
            return {
              paramName: filter.paramName,
              options: []
            };
          }
          try {
            const options = await filter.optionsFunc();
            return { paramName: filter.paramName, options };
          } catch (e) {
            Sentry2.captureException(e);
            return {
              paramName: filter.paramName,
              options: []
            };
          }
        })
      );
      initialisedCache.map((cache) => {
        dispatch({
          type: "optionsCacheAdd",
          paramName: cache.paramName,
          options: cache.options
        });
      });
    };
    void initialiseCache();
  }, []);
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/OptionsCache/optionsCacheReducer.reducer.ts
import { match } from "ts-pattern";
var optionsCacheReducer = (state, action) => match(action).with({ type: "optionsCacheAdd" }, ({ paramName, options }) => ({
  ...state,
  [paramName]: options
})).exhaustive();

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilters/activeFiltersReducer.reducer.ts
import { match as match3 } from "ts-pattern";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilters/activeFiltersReducer.utils.ts
import { match as match2 } from "ts-pattern";
var updateDateCustomOperator = (activeFilters, index, operator) => {
  return activeFilters.map((activeFilter, activeFilterIndex) => {
    if (activeFilterIndex !== index || activeFilter.type !== "dateCustom") {
      return activeFilter;
    }
    return {
      ...activeFilter,
      operator
    };
  });
};
var getActiveFilterDateCustomOppositeIndex = (paramName, activeFilters, thisOperator) => {
  if (thisOperator === "EQUALS") {
    return void 0;
  }
  const oppositeOperator = match2(thisOperator).with("BEFORE", () => "AFTER").with("AFTER", () => "BEFORE").exhaustive();
  const index = activeFilters.findIndex(
    (activeFilter) => activeFilter.paramName === paramName && activeFilter.type === "dateCustom" && activeFilter.operator === oppositeOperator
  );
  if (index === -1) {
    return void 0;
  }
  return index;
};
var removeActiveFilterAtIndex = (activeFilters, index) => {
  return activeFilters.reduce((acc, curr, thisIndex) => {
    if (index === thisIndex) {
      return [...acc];
    }
    return [...acc, curr];
  }, []);
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilters/activeFiltersReducer.reducer.ts
var activeFiltersReducer = (state, action, menuFilters) => match3(action).with({ type: "clearAll" }, () => ({
  ...state,
  activeFilters: state.activeFilters.filter((activeFilter) => {
    const filter = menuFilters.find(
      (menuFilter) => menuFilter.paramName === activeFilter.paramName
    );
    return filter?.disabled;
  })
})).with({ type: "removeFilter" }, ({ paramName, dateCustomOperator }) => ({
  ...state,
  activeFilters: state.activeFilters.filter((activeFilter) => {
    if (dateCustomOperator) {
      const isCustomDateFilterWithOtherOperator = activeFilter.paramName === paramName && activeFilter.type === "dateCustom" && activeFilter.operator !== dateCustomOperator;
      return activeFilter.paramName !== paramName || isCustomDateFilterWithOtherOperator;
    }
    return activeFilter.paramName !== paramName;
  })
})).with({ type: "toggleMultiSelectOption" }, ({ paramName, value }) => {
  const thisFilter = state.activeFilters.find(
    (filter) => filter.paramName === paramName
  );
  if (!thisFilter) {
    return {
      ...state,
      activeFilters: [
        ...state.activeFilters,
        { paramName, type: "multiSelect", values: [value] }
      ]
    };
  }
  return {
    ...state,
    activeFilters: state.activeFilters.map((activeFilter) => {
      if (activeFilter.paramName !== paramName || activeFilter.type !== "multiSelect") {
        return activeFilter;
      }
      const hasValue = activeFilter.values.includes(value);
      return {
        paramName,
        type: "multiSelect",
        values: hasValue ? activeFilter.values.filter((v) => v !== value) : [...activeFilter.values, value]
      };
    })
  };
}).with({ type: "switchToggleOption" }, ({ paramName, value }) => {
  const thisFilter = state.activeFilters.find(
    (filter) => filter.paramName === paramName
  );
  const updatedActiveFilter = { paramName, type: "toggle", value };
  if (!thisFilter) {
    return {
      ...state,
      activeFilters: [...state.activeFilters, updatedActiveFilter]
    };
  }
  return {
    ...state,
    activeFilters: state.activeFilters.map((activeFilter) => {
      if (activeFilter.paramName !== paramName || activeFilter.type !== "toggle") {
        return activeFilter;
      }
      return updatedActiveFilter;
    })
  };
}).with({ type: "setTextFilter" }, ({ paramName, value }) => {
  const thisFilter = state.activeFilters.find(
    (filter) => filter.paramName === paramName
  );
  const updatedActiveFilter = { paramName, type: "text", value };
  if (!thisFilter) {
    return {
      ...state,
      activeFilters: [...state.activeFilters, updatedActiveFilter]
    };
  }
  return {
    ...state,
    activeFilters: state.activeFilters.map((activeFilter) => {
      if (activeFilter.paramName !== paramName) {
        return activeFilter;
      }
      return updatedActiveFilter;
    })
  };
}).with({ type: "bulkSetMultiSelect" }, ({ paramName, values }) => ({
  ...state,
  activeFilters: [
    ...state.activeFilters.filter(
      (activeFilter) => activeFilter.paramName !== paramName
    ),
    { paramName, type: "multiSelect", values }
  ]
})).with({ type: "setDatePreset" }, ({ paramName, preset, operator }) => {
  const existingActiveFilter = state.activeFilters.find(
    (activeFilter) => activeFilter.paramName === paramName && activeFilter.type === "datePreset"
  );
  const updatedActiveFilter = {
    type: "datePreset",
    paramName,
    preset,
    operator: operator ?? (preset === "TODAY" ? "EQUALS" : "LESS_THAN")
  };
  if (!existingActiveFilter) {
    return {
      ...state,
      activeFilters: [...state.activeFilters, updatedActiveFilter]
    };
  }
  return {
    ...state,
    activeFilters: state.activeFilters.map((activeFilter) => {
      if (activeFilter.paramName !== paramName || activeFilter.type !== "datePreset") {
        return activeFilter;
      }
      return updatedActiveFilter;
    })
  };
}).with({ type: "addDateCustom" }, ({ paramName, date }) => {
  const hasExistingPresetFilter = state.activeFilters.some(
    (activeFilter) => activeFilter.paramName === paramName && activeFilter.type === "datePreset",
    []
  );
  const existingCustomFilter = state.activeFilters.find(
    (activeFilter) => activeFilter.paramName === paramName && activeFilter.type === "dateCustom"
  );
  const operatorToUse = (() => {
    if (!existingCustomFilter) {
      return "EQUALS";
    }
    return match3(existingCustomFilter.operator).with("BEFORE", () => "AFTER").with("AFTER", () => "BEFORE").with("EQUALS", () => "AFTER").exhaustive();
  })();
  const updatedActiveFilter = {
    type: "dateCustom",
    paramName,
    date,
    operator: operatorToUse
  };
  return {
    ...state,
    activeFilters: [
      ...state.activeFilters.map((activeFilter) => {
        if (activeFilter.paramName === paramName && activeFilter.type === "datePreset") {
          return updatedActiveFilter;
        }
        if (activeFilter.paramName === paramName && activeFilter.type === "dateCustom" && activeFilter.operator === "EQUALS") {
          return { ...activeFilter, operator: "BEFORE" };
        }
        return activeFilter;
      }),
      /**
       * when replacing an existing filter, append it to the end of the row
       * of active filters
       */
      ...hasExistingPresetFilter ? [] : [updatedActiveFilter]
    ]
  };
}).with(
  { type: "updateDateCustomOperator" },
  ({ paramName, prevOperator, nextOperator }) => {
    let activeFiltersNext = [...state.activeFilters];
    const indexCurrent = activeFiltersNext.findIndex(
      (activeFilter) => activeFilter.paramName === paramName && activeFilter.type === "dateCustom" && activeFilter.operator === prevOperator
    );
    const indexOpposite = getActiveFilterDateCustomOppositeIndex(
      paramName,
      activeFiltersNext,
      prevOperator
    );
    match3({ prevOperator, nextOperator }).with(
      { prevOperator: "BEFORE", nextOperator: "AFTER" },
      { prevOperator: "AFTER", nextOperator: "BEFORE" },
      () => {
        activeFiltersNext = updateDateCustomOperator(
          activeFiltersNext,
          indexCurrent,
          nextOperator
        );
        if (typeof indexOpposite !== "undefined") {
          activeFiltersNext = updateDateCustomOperator(
            activeFiltersNext,
            indexOpposite,
            prevOperator
          );
        }
      }
    ).with(
      { prevOperator: "BEFORE", nextOperator: "EQUALS" },
      { prevOperator: "AFTER", nextOperator: "EQUALS" },
      () => {
        activeFiltersNext = updateDateCustomOperator(
          activeFiltersNext,
          indexCurrent,
          nextOperator
        );
        if (typeof indexOpposite !== "undefined") {
          activeFiltersNext = removeActiveFilterAtIndex(
            activeFiltersNext,
            indexOpposite
          );
        }
      }
    ).with(
      { prevOperator: "EQUALS", nextOperator: "BEFORE" },
      { prevOperator: "EQUALS", nextOperator: "AFTER" },
      () => {
        activeFiltersNext = updateDateCustomOperator(
          activeFiltersNext,
          indexCurrent,
          nextOperator
        );
      }
    ).with(
      { prevOperator: "BEFORE", nextOperator: "BEFORE" },
      { prevOperator: "AFTER", nextOperator: "AFTER" },
      { prevOperator: "EQUALS", nextOperator: "EQUALS" },
      () => {
      }
    ).exhaustive();
    return {
      ...state,
      activeFilters: activeFiltersNext
    };
  }
).with(
  { type: "updateDateCustomDate" },
  ({ paramName, operator, date }) => ({
    ...state,
    activeFilters: state.activeFilters.map((activeFilter) => {
      if (activeFilter.type === "dateCustom" && activeFilter.paramName === paramName && activeFilter.operator === operator) {
        return { ...activeFilter, date };
      }
      return activeFilter;
    })
  })
).with({ type: "tidyEmptyFilters" }, () => ({
  ...state,
  activeFilters: state.activeFilters.filter((activeFilter) => {
    if (activeFilter.type !== "multiSelect") {
      return true;
    }
    return activeFilter.values.length !== 0;
  })
})).with(
  { type: "addQueryParamsDatePreset" },
  ({ paramName, preset, operator }) => ({
    ...state,
    activeFilters: [
      ...state.activeFilters,
      {
        type: "datePreset",
        paramName,
        preset,
        operator
      }
    ]
  })
).with(
  { type: "addQueryParamsDateCustom" },
  ({ paramName, date, operator }) => ({
    ...state,
    activeFilters: [
      ...state.activeFilters,
      {
        type: "dateCustom",
        paramName,
        date,
        operator
      }
    ]
  })
).exhaustive();

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/hooks/useMagicTableToolbarV3Queries.tsx
import { useCallback as useCallback3 } from "react";
var useMagicTableToolbarV3Queries = ({
  data,
  stateActiveFilters: state,
  customColumns,
  totalResultSize,
  onSaveFilters,
  onUpdateSavedFilters,
  lockedControls
}) => {
  const canDisplayAddFiltersMenu = useCallback3(
    () => data.menuFilters.length > 0,
    [data.menuFilters]
  );
  const canChangeFilters = useCallback3(() => {
    if (lockedControls) {
      return false;
    }
    return state.activeFilters.length === 0 && totalResultSize > 0 || state.activeFilters.length > 0;
  }, [state.activeFilters, totalResultSize, lockedControls]);
  const canClearAllFilters = useCallback3(() => {
    const visible = state.activeFilters.filter((activeFilter) => {
      if (activeFilter.type !== "multiSelect") {
        return true;
      }
      return activeFilter.values.length !== 0;
    }).filter((activeFilter) => {
      const menuFilter = data.menuFilters.find(
        (menuFilter2) => menuFilter2.paramName === activeFilter.paramName
      );
      return menuFilter && !menuFilter.disabled;
    }).length > 0;
    const enabled = typeof lockedControls === "undefined" ? true : !lockedControls;
    return { visible, enabled };
  }, [data.menuFilters, state.activeFilters, lockedControls]);
  const useSmallAddFilterButton = useCallback3(
    () => state.activeFilters.filter((activeFilter) => {
      if (activeFilter.type !== "multiSelect") {
        return true;
      }
      return activeFilter.values.length !== 0;
    }).filter(
      (activeFilter) => data.menuFilters.find(
        (menuFilter) => menuFilter.paramName === activeFilter.paramName
      )
    ).length > 0,
    [data.menuFilters, state.activeFilters]
  );
  const canAddCustomColumns = useCallback3(
    () => customColumns.isEnabled && customColumns.available.length !== customColumns.selected.length,
    [customColumns]
  );
  const canSaveFilter = useCallback3(() => {
    const visible = state.activeFilters.length > 0 && (!!onSaveFilters || !!onUpdateSavedFilters);
    const enabled = typeof lockedControls === "undefined" ? true : !lockedControls;
    return { visible, enabled };
  }, [state.activeFilters, onSaveFilters, onUpdateSavedFilters, lockedControls]);
  return {
    canDisplayAddFiltersMenu,
    canChangeFilters,
    canClearAllFilters,
    useSmallAddFilterButton,
    canAddCustomColumns,
    canSaveFilter
  };
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/hooks/useMagicTableToolbarV3Functions.tsx
import { useCallback as useCallback4 } from "react";

// src/components/MagicTable/constants.ts
var COLUMN_ID_EXPAND = "expand";
var COLUMN_ID_CHECKBOX = "select";
var COLUMN_ID_ADD_COLUMN = "addColumn";
var MAGIC_TABLE_SPECIAL_COLUMNS = [
  COLUMN_ID_EXPAND,
  COLUMN_ID_CHECKBOX,
  COLUMN_ID_ADD_COLUMN
];
var CUSTOM_EVENT_COLUMN_PREFIX = "eventProperty_";
var DEFAULT_PAGE_SIDEBAR_WIDTH = 206;
var DEFAULT_COLUMN_WIDTH_EXTRA_RIGHT_PADDING = 40;
var HEADER_ROW_HEIGHT = 41;
var COLUMN_DEFAULT_WIDTH_EXPAND = 52;
var COLUMN_DEFAULT_WIDTH_CHECKBOX = 52;
var COLUMN_DEFAULT_WIDTH_CHECKBOX_WITH_EXPAND = 40;
var COLUMN_DEFAULT_WIDTH_ADD_COLUMN = 40;
var COLUMN_MIN_SIZE = 100;
var DND_DEFAULT_ACTIVATION_DELAY = 100;
var DND_DEFAULT_ACTIVATION_TOLERANCE = 10;
var VIRTUAL_TABLE_ROW_HEIGHT = 40;
var VIRTUAL_TABLE_DEFAULT_INITIAL_RESULTS_SIZE = 10;

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/hooks/useMagicTableToolbarV3Functions.tsx
var useMagicTableToolbarV3Functions = ({
  dispatchActiveFilters: dispatch,
  getTableState,
  getTableAllFlatColumns,
  setColumnOrder,
  customColumns,
  setAddFilterMenuWidth: setAddFilterMenuWidthProp
}) => {
  const setAddFilterMenuWidth = useCallback4(
    (newWidth) => {
      setAddFilterMenuWidthProp(newWidth);
    },
    [setAddFilterMenuWidthProp]
  );
  const clearAllFilters = useCallback4(() => {
    dispatch({ type: "clearAll" });
  }, [dispatch]);
  const removeFilter = useCallback4(
    ({
      paramName,
      dateCustomOperator
    }) => {
      dispatch({ type: "removeFilter", paramName, dateCustomOperator });
    },
    [dispatch]
  );
  const tidyEmptyFilters = useCallback4(() => {
    dispatch({ type: "tidyEmptyFilters" });
  }, [dispatch]);
  const setDatePreset = useCallback4(
    ({
      paramName,
      preset,
      operator
    }) => {
      dispatch({
        type: "setDatePreset",
        paramName,
        preset,
        operator
      });
    },
    [dispatch]
  );
  const addDateCustom = useCallback4(
    ({ paramName, date }) => {
      dispatch({
        type: "addDateCustom",
        paramName,
        date
      });
    },
    [dispatch]
  );
  const updateDateCustomOperator2 = useCallback4(
    ({
      paramName,
      prevOperator,
      nextOperator
    }) => {
      dispatch({
        type: "updateDateCustomOperator",
        paramName,
        prevOperator,
        nextOperator
      });
    },
    [dispatch]
  );
  const updateDateCustomDate = useCallback4(
    ({
      paramName,
      operator,
      date
    }) => {
      dispatch({
        type: "updateDateCustomDate",
        paramName,
        operator,
        date
      });
    },
    [dispatch]
  );
  const toggleMultiSelectOption = useCallback4(
    ({ paramName, value }) => {
      dispatch({ type: "toggleMultiSelectOption", paramName, value });
    },
    [dispatch]
  );
  const bulkSetMultiSelectOptions = useCallback4(
    ({ paramName, values }) => {
      dispatch({
        type: "bulkSetMultiSelect",
        paramName,
        values
      });
    },
    [dispatch]
  );
  const switchToggleOption = useCallback4(
    ({ paramName, value }) => {
      dispatch({ type: "switchToggleOption", paramName, value });
    },
    [dispatch]
  );
  const setTextFilter = useCallback4(
    ({ paramName, value }) => {
      dispatch({ type: "setTextFilter", paramName, value });
    },
    [dispatch]
  );
  const addCustomColumn = useCallback4(
    (columnId) => {
      customColumns.setSelected([...customColumns.selected, columnId]);
    },
    [customColumns]
  );
  const removeCustomColumn = useCallback4(
    (columnId) => {
      const columnIdWithoutPrefix = columnId.replace(
        CUSTOM_EVENT_COLUMN_PREFIX,
        ""
      );
      customColumns.setSelected(
        customColumns.selected.filter(
          (selectedColId) => selectedColId !== columnIdWithoutPrefix
        )
      );
    },
    [customColumns]
  );
  return {
    setAddFilterMenuWidth,
    clearAllFilters,
    removeFilter,
    tidyEmptyFilters,
    setDatePreset,
    addDateCustom,
    updateDateCustomOperator: updateDateCustomOperator2,
    updateDateCustomDate,
    toggleMultiSelectOption,
    bulkSetMultiSelectOptions,
    switchToggleOption,
    setTextFilter,
    addCustomColumn,
    removeCustomColumn,
    /**
     * react-table functions
     */
    getTableState,
    getTableAllFlatColumns,
    setColumnOrder
  };
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarV3Provider.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var MagicTableToolbarV3Context = createContext(INITIAL_STATE);
var MagicTableToolbarV3Provider = ({
  children,
  activeFilters,
  onChangeActiveFilters,
  ...props
}) => {
  const allFilters = props.filters ?? [];
  const menuFilters = allFilters.filter(
    (filter) => !["toggle"].includes(filter.type)
  );
  const viewSettingsFilters = allFilters.filter(
    (filter) => filter.type === "toggle" && Boolean(filter.hidden) === false
  );
  const [stateActiveFilters, dispatchActiveFilters] = useReducer((_state, action) => activeFiltersReducer(_state, action, menuFilters), {
    activeFilters
  });
  const [stateOptionsCache, dispatchOptionsCache] = useReducer(optionsCacheReducer, {});
  const [addFilterMenuWidth, setAddFilterMenuWidth] = useState4(
    INITIAL_STATE.ui.addFilterMenuWidth
  );
  useOptionsCache({ menuFilters, dispatch: dispatchOptionsCache });
  useEffect3(() => {
    onChangeActiveFilters(stateActiveFilters.activeFilters);
  }, [onChangeActiveFilters, stateActiveFilters.activeFilters]);
  const data = useMemo5(
    () => ({
      columnOrder: props.columnOrder,
      activeFilters: stateActiveFilters.activeFilters,
      menuFilters,
      viewSettingsFilters,
      loading: props.loading,
      customColumns: {
        available: props.customColumns.available,
        selected: props.customColumns.selected
      },
      grouping: {
        groupBy: props.groupBy,
        groupableColumns: props.groupableColumns,
        onGroupBy: props.onGroupBy
      },
      optionsCache: stateOptionsCache
    }),
    [
      menuFilters,
      props.columnOrder,
      props.customColumns.available,
      props.customColumns.selected,
      props.groupBy,
      props.groupableColumns,
      props.onGroupBy,
      props.loading,
      stateActiveFilters.activeFilters,
      stateOptionsCache,
      viewSettingsFilters
    ]
  );
  const queries = useMagicTableToolbarV3Queries({
    data,
    stateActiveFilters,
    customColumns: props.customColumns,
    totalResultSize: props.totalResultSize,
    onSaveFilters: props.onSaveFilters,
    onUpdateSavedFilters: props.onUpdateSavedFilters,
    lockedControls: props.lockedControls
  });
  const functions = useMagicTableToolbarV3Functions({
    dispatchActiveFilters,
    getTableState: props.getTableState,
    getTableAllFlatColumns: props.getTableAllFlatColumns,
    setColumnOrder: props.setColumnOrder,
    customColumns: props.customColumns,
    setAddFilterMenuWidth
  });
  useEffect3(() => {
    props.refClearFilters.current = () => {
      functions.clearAllFilters();
    };
  }, []);
  const ui = {
    addFilterMenuWidth,
    viewSettingsHeader: props.viewSettingsHeader
  };
  return /* @__PURE__ */ jsx15(
    MagicTableToolbarV3Context.Provider,
    {
      value: { data, queries, functions, ui },
      children
    }
  );
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/hooks/useMagicTableToolbarContext.tsx
import { useContext } from "react";
var useMagicTableToolbarContext = () => useContext(MagicTableToolbarV3Context);

// src/components/MagicTable/FiltersV3/utils/useSimpleSearch.tsx
import { useCallback as useCallback5, useMemo as useMemo6, useState as useState5 } from "react";
var useSimpleSearch = ({
  items,
  searchOn
}) => {
  const [query, setQuery] = useState5("");
  const results = useMemo6(() => {
    return items.filter((item) => {
      if (typeof item[searchOn] !== "string") {
        return false;
      }
      const itemVal = item[searchOn];
      return itemVal.toLowerCase().includes(query.toLowerCase());
    });
  }, [items, query, searchOn]);
  const reset = useCallback5(() => {
    setQuery("");
  }, []);
  return {
    results,
    input: {
      value: query,
      onChange: (newValue) => setQuery(newValue)
    },
    reset
  };
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuMultiSelect/useMenuMultiSelect.tsx
var useMenuMultiSelect = ({
  paramName,
  type,
  activeFilter
}) => {
  const {
    data: { activeFilters, menuFilters, optionsCache }
  } = useMagicTableToolbarContext();
  const thisFilter = useMemo7(() => {
    const result = menuFilters.find(
      (filter) => filter.paramName === paramName && filter.type === type
    );
    if (!result) {
      return void 0;
    }
    if (result.type !== "multiSelect" && result.type !== "multiSelectAliased") {
      return void 0;
    }
    return result;
  }, [menuFilters, paramName, type]);
  const options = useMemo7(() => {
    if (!thisFilter) {
      return [];
    }
    if (thisFilter.optionsFunc) {
      return optionsCache[paramName] || [];
    }
    return thisFilter.options;
  }, [optionsCache, paramName, thisFilter]);
  const { results: resultsUngrouped, input } = useSimpleSearch({
    items: options,
    searchOn: "label"
  });
  const [pinnedValues, setPinnedValues] = useState6([]);
  useEffect4(() => {
    if (!activeFilter || activeFilter.type !== "multiSelect") {
      return;
    }
    setPinnedValues(activeFilter.values);
  }, []);
  const results = useMemo7(() => {
    return resultsUngrouped.map((result) => {
      const isSelected = activeFilters.some(
        (filter) => filter.paramName === paramName && filter.type === "multiSelect" && filter.values.includes(result.value)
      );
      const isDisabled = thisFilter?.optionDisabledFn ? thisFilter.optionDisabledFn(activeFilters, result) : false;
      return {
        ...result,
        isSelected,
        isPinned: pinnedValues.includes(result.value),
        isDisabled
      };
    });
  }, [activeFilters, paramName, pinnedValues, resultsUngrouped, thisFilter]);
  const defaultSortFn = useCallback6(
    (a, b) => a.label.localeCompare(b.label),
    []
  );
  const sortFn = useMemo7(
    () => thisFilter && thisFilter.optionsSortFn ? thisFilter.optionsSortFn : defaultSortFn,
    [defaultSortFn, thisFilter]
  );
  const optionsPinned = useMemo7(
    () => results.filter((result) => result.isPinned).sort(sortFn),
    [results, sortFn]
  );
  const optionsUnpinned = useMemo7(
    () => results.filter((result) => !result.isPinned).sort(sortFn),
    [results, sortFn]
  );
  return {
    optionsPinned,
    optionsUnpinned,
    searchInput: {
      ...input,
      placeholder: thisFilter?.label || ""
    },
    isLoading: Boolean(thisFilter?.optionsFunc) && typeof optionsCache[paramName] === "undefined"
  };
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuMultiSelect/MenuMultiSelect.tsx
import { SimpleSearchMenuInput } from "@sequencehq/core-components";
import { Fragment as Fragment6, jsx as jsx16, jsxs as jsxs9 } from "react/jsx-runtime";
var MenuMultiSelect = ({
  paramName,
  type,
  activeFilter
}) => {
  const { optionsPinned, optionsUnpinned, searchInput, isLoading } = useMenuMultiSelect({
    paramName,
    type,
    activeFilter
  });
  const { functions } = useMagicTableToolbarContext();
  return /* @__PURE__ */ jsxs9(Fragment6, { children: [
    /* @__PURE__ */ jsx16(
      SimpleSearchMenuInput,
      {
        value: searchInput.value,
        onChange: searchInput.onChange,
        placeholder: searchInput.placeholder,
        showDivider: optionsUnpinned.length > 0 || optionsPinned.length > 0
      }
    ),
    (isLoading || optionsPinned.length > 0 || optionsUnpinned.length > 0) && /* @__PURE__ */ jsx16(Box7, { height: "4px" }),
    isLoading && /* @__PURE__ */ jsx16(Center, { p: "4px", children: /* @__PURE__ */ jsx16(Spinner, { boxSize: "16px", color: GreyGrey50 }) }),
    optionsPinned.map(({ label, value, isSelected, isDisabled }) => /* @__PURE__ */ jsxs9(
      MenuItem,
      {
        onClick: () => {
          functions.toggleMultiSelectOption({ paramName, value });
        },
        gap: "8px",
        isDisabled,
        children: [
          /* @__PURE__ */ jsx16(Checkbox4, { pointerEvents: "none", isChecked: isSelected }),
          /* @__PURE__ */ jsx16(Text7, { ...Lato13Regular, color: "inherit", wordBreak: "break-word", children: label })
        ]
      },
      value
    )),
    optionsPinned.length > 0 && optionsUnpinned.length > 0 && /* @__PURE__ */ jsx16(MenuDivider, {}),
    optionsUnpinned.map(({ label, value, isSelected, isDisabled }) => /* @__PURE__ */ jsxs9(
      MenuItem,
      {
        onClick: () => {
          functions.toggleMultiSelectOption({ paramName, value });
        },
        gap: "8px",
        isDisabled,
        children: [
          /* @__PURE__ */ jsx16(Checkbox4, { pointerEvents: "none", isChecked: isSelected }),
          /* @__PURE__ */ jsx16(Text7, { ...Lato13Regular, color: "inherit", wordBreak: "break-word", children: label })
        ]
      },
      value
    ))
  ] });
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuText/MenuText.tsx
import { Flex as Flex5, Input as Input2, Text as Text8, Button as Button2 } from "@chakra-ui/react";
import { GreyGrey80, Lato13Bold } from "@sequencehq/design-tokens";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuText/useMenuText.ts
import { useCallback as useCallback7, useEffect as useEffect5, useMemo as useMemo8, useState as useState7 } from "react";
var useMenuText = ({ paramName, menuOnClose }) => {
  const { data, functions } = useMagicTableToolbarContext();
  const thisFilter = useMemo8(
    () => data.menuFilters.find((filter) => filter.paramName === paramName),
    [data.menuFilters, paramName]
  );
  const [value, setValue] = useState7("");
  useEffect5(() => {
    functions.setAddFilterMenuWidth("400px");
  }, []);
  useEffect5(() => {
    const initialValue = data.activeFilters.find(
      (activeFilter) => activeFilter.paramName === paramName
    );
    if (initialValue && initialValue.type === "text") {
      setValue(initialValue.value);
    }
  }, []);
  const buttonOnApply = useCallback7(() => {
    if (value === "") {
      return;
    }
    functions.setTextFilter({ paramName, value });
    menuOnClose();
  }, [functions, menuOnClose, paramName, value]);
  const buttonOnCancel = useCallback7(() => {
    menuOnClose();
  }, [menuOnClose]);
  return {
    title: thisFilter?.label ?? "",
    input: {
      value,
      onChange: (newValue) => {
        setValue(newValue);
      },
      placeholder: thisFilter?.label ?? ""
    },
    buttons: {
      apply: {
        onClick: buttonOnApply,
        disabled: value === ""
      },
      cancel: {
        onClick: buttonOnCancel
      }
    }
  };
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuText/MenuText.tsx
import { jsx as jsx17, jsxs as jsxs10 } from "react/jsx-runtime";
var MenuText = ({
  paramName,
  type,
  menuOnClose
}) => {
  const { title, input, buttons } = useMenuText({
    paramName,
    type,
    menuOnClose
  });
  return /* @__PURE__ */ jsxs10(Flex5, { padding: "12px", paddingTop: "16px", gap: "16px", flexDirection: "column", children: [
    /* @__PURE__ */ jsxs10(Flex5, { gap: "8px", flexDirection: "column", children: [
      /* @__PURE__ */ jsx17(Text8, { ...Lato13Bold, color: GreyGrey80, children: title }),
      /* @__PURE__ */ jsx17(
        Input2,
        {
          variant: "component-library",
          value: input.value,
          onChange: (e) => input.onChange(e.target.value),
          placeholder: input.placeholder
        }
      )
    ] }),
    /* @__PURE__ */ jsxs10(Flex5, { gap: "8px", justifyContent: "flex-end", children: [
      /* @__PURE__ */ jsx17(
        Button2,
        {
          variant: "component-library-secondary",
          onClick: buttons.cancel.onClick,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ jsx17(
        Button2,
        {
          variant: "component-library-primary",
          onClick: buttons.apply.onClick,
          isDisabled: buttons.apply.disabled,
          children: "Apply"
        }
      )
    ] })
  ] });
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuDate/MenuDate.tsx
import { Box as Box8, MenuItem as MenuItem2, Flex as Flex6, Text as Text9, Center as Center2 } from "@chakra-ui/react";
import { CheckIcon } from "@heroicons/react/16/solid";
import { Lato13Regular as Lato13Regular2 } from "@sequencehq/design-tokens";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuDate/Calendar.tsx
import { useDayzed as useDayzed2 } from "dayzed";
import { CalendarView as CalendarView2 } from "@sequencehq/forms";
import { dayzedAdapter as dayzedAdapter2 } from "@sequencehq/core-components";
import { jsx as jsx18 } from "react/jsx-runtime";
var Calendar = ({ onSelect, selectedDate }) => {
  const { calendars, getDateProps, getBackProps, getForwardProps } = useDayzed2({
    selected: selectedDate && dayzedAdapter2.toDayzed(selectedDate),
    date: dayzedAdapter2.toDayzed(selectedDate ?? /* @__PURE__ */ new Date()),
    monthsToDisplay: 1,
    firstDayOfWeek: 1,
    onDateSelected: ({ date }) => {
      onSelect(dayzedAdapter2.fromDayzed(date));
    }
  });
  return /* @__PURE__ */ jsx18(
    CalendarView2,
    {
      calendar: calendars[0],
      getDateProps,
      getBackProps,
      getForwardProps,
      selectedDate: selectedDate ?? /* @__PURE__ */ new Date(),
      type: "single"
    }
  );
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuDate/useMenuDate.tsx
import { useMemo as useMemo9, useState as useState8 } from "react";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilters/ActiveFilters.constants.ts
var DATE_PRESETS = {
  TODAY: "Today",
  "1_WEEK": "1 week ago",
  "1_MONTH": "1 month ago",
  "3_MONTHS": "3 months ago"
};
var DATE_PRESET_OPERATOR_LABELS = {
  EQUALS: "Is",
  LESS_THAN: "Less than",
  MORE_THAN: "More than"
};
var DATE_TODAY_OPERATOR_LABELS = {
  EQUALS: "Is",
  LESS_THAN: "Before",
  MORE_THAN: "After"
};
var DATE_CUSTOM_OPERATOR_LABELS = {
  BEFORE: "Before",
  AFTER: "After",
  EQUALS: "Is"
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuDate/useMenuDate.tsx
var useMenuDate = ({
  paramName,
  type,
  menuOnClose,
  activeFilter: activeFilterProp
}) => {
  const {
    data: { menuFilters, activeFilters },
    functions
  } = useMagicTableToolbarContext();
  const [showCalendar, setShowCalendar] = useState8(false);
  const thisFilter = useMemo9(() => {
    const result = menuFilters.find(
      (filter) => filter.paramName === paramName && filter.type === type
    );
    if (!result || result && result.type !== "date") {
      return void 0;
    }
    return result;
  }, [menuFilters, paramName, type]);
  const options = useMemo9(() => {
    if (!thisFilter) {
      return [];
    }
    const presetOptions = Object.entries(DATE_PRESETS).map(
      ([preset, label]) => {
        const activePreset = activeFilters.find(
          (activeFilter) => activeFilter.type === "datePreset" && activeFilter.paramName === paramName
        );
        return {
          label,
          onClick: () => {
            functions.setDatePreset({
              paramName: thisFilter.paramName,
              preset,
              operator: activePreset && activePreset.type === "datePreset" ? activePreset.operator : preset === "TODAY" ? "EQUALS" : "LESS_THAN"
            });
          },
          closeOnSelect: true,
          isSelected: Boolean(
            activePreset && activePreset.paramName === paramName && activePreset.type === "datePreset" && activePreset.preset === preset
          )
        };
      }
    );
    const showPresetOptions = activeFilters.some(
      (activeFilter) => activeFilter.paramName === paramName && activeFilter.type === "dateCustom"
    ) === false;
    return [
      ...showPresetOptions ? presetOptions : [],
      {
        label: "Custom date...",
        onClick: () => {
          functions.setAddFilterMenuWidth("298px");
          setShowCalendar(true);
        },
        closeOnSelect: false,
        isSelected: Boolean(
          activeFilterProp && activeFilterProp.type === "dateCustom"
        )
      }
    ];
  }, [activeFilterProp, activeFilters, functions, paramName, thisFilter]);
  const { results, input } = useSimpleSearch({
    items: options,
    searchOn: "label"
  });
  return {
    options: results,
    searchInput: {
      ...input,
      placeholder: thisFilter?.label ?? ""
    },
    calendar: {
      showCalendar,
      onSelect: (date) => {
        if (activeFilterProp && activeFilterProp.type === "dateCustom") {
          functions.updateDateCustomDate({
            paramName,
            date,
            operator: activeFilterProp.operator
          });
        } else {
          functions.addDateCustom({ paramName, date });
        }
        menuOnClose();
      }
    },
    selectedDate: activeFilterProp && activeFilterProp.type === "dateCustom" ? activeFilterProp.date : void 0
  };
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuDate/MenuDate.tsx
import { SimpleSearchMenuInput as SimpleSearchMenuInput2 } from "@sequencehq/core-components";
import { Fragment as Fragment7, jsx as jsx19, jsxs as jsxs11 } from "react/jsx-runtime";
var MenuDate = ({
  paramName,
  type,
  menuOnClose,
  activeFilter
}) => {
  const { options, searchInput, calendar, selectedDate } = useMenuDate({
    paramName,
    type,
    menuOnClose,
    activeFilter
  });
  if (calendar.showCalendar) {
    return /* @__PURE__ */ jsx19(Center2, { p: "4px", paddingTop: "8px", children: /* @__PURE__ */ jsx19(Calendar, { onSelect: calendar.onSelect, selectedDate }) });
  }
  return /* @__PURE__ */ jsxs11(Fragment7, { children: [
    /* @__PURE__ */ jsx19(
      SimpleSearchMenuInput2,
      {
        value: searchInput.value,
        onChange: searchInput.onChange,
        placeholder: searchInput.placeholder,
        showDivider: options.length > 0
      }
    ),
    options.length > 0 && /* @__PURE__ */ jsx19(Box8, { height: "4px" }),
    options.map(({ label, onClick, closeOnSelect, isSelected }) => /* @__PURE__ */ jsx19(MenuItem2, { onClick, closeOnSelect, children: /* @__PURE__ */ jsxs11(Flex6, { justifyContent: "space-between", alignItems: "center", width: "100%", children: [
      /* @__PURE__ */ jsx19(Text9, { ...Lato13Regular2, color: "inherit", children: label }),
      isSelected && /* @__PURE__ */ jsx19(CheckIcon, { width: "16px", height: "16px", color: "inherit" })
    ] }) }, label))
  ] });
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuSelectedFilter.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var MenuSelectedFilter = (props) => match4(props.type).with("multiSelect", "multiSelectAliased", () => /* @__PURE__ */ jsx20(MenuMultiSelect, { ...props })).with("text", () => /* @__PURE__ */ jsx20(MenuText, { ...props })).with("date", () => /* @__PURE__ */ jsx20(MenuDate, { ...props })).with("toggle", () => null).with("boolean", "checkbox", () => null).exhaustive();

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/utils/fixChakraMenuPosition.ts
var getMenuParent = (uuidMenu) => {
  const menu = document.querySelector(`#menu-list-${uuidMenu}`);
  if (!menu) {
    return;
  }
  const menuParent = menu.parentElement;
  if (!menuParent) {
    return;
  }
  return menuParent;
};
var fixMenuPosition = (uuidMenu) => {
  const menuParent = getMenuParent(uuidMenu);
  if (!menuParent) {
    return;
  }
  const menuParentTransform = window.getComputedStyle(menuParent).getPropertyValue("transform");
  const style = document.createElement("style");
  style.id = `menu-list-fix-style-${uuidMenu}`;
  const css = `.menu-list-fix-${uuidMenu} { transform: ${menuParentTransform} !important }`;
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
  menuParent.classList.add(`menu-list-fix-${uuidMenu}`);
};
var unfixMenuPosition = (uuidMenu) => {
  setTimeout(() => {
    const menuParent = getMenuParent(uuidMenu);
    if (!menuParent) {
      return;
    }
    menuParent.classList.remove(`menu-list-fix-${uuidMenu}`);
    const style = document.querySelector(`#menu-list-fix-style-${uuidMenu}`);
    if (!style) {
      return;
    }
    style.remove();
  }, 150);
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilters/ActiveFilterPill/ActiveFilterPillMenuButton.tsx
import { MenuButton, Text as Text10 } from "@chakra-ui/react";
import { GreyGrey20, GreyGrey30, Lato13Bold as Lato13Bold2 } from "@sequencehq/design-tokens";
import { jsx as jsx21 } from "react/jsx-runtime";
var ActiveFilterPillMenuButton = ({ label, isDisabled }) => {
  const extraProps = isDisabled ? { cursor: "default" } : {
    _hover: { background: GreyGrey30 },
    _active: { background: GreyGrey30 }
  };
  return /* @__PURE__ */ jsx21(
    MenuButton,
    {
      background: GreyGrey20,
      py: "4px",
      px: "6px",
      borderRadius: "4px",
      height: "24px",
      maxWidth: "200px",
      _focus: { appearance: "none" },
      ...extraProps,
      children: /* @__PURE__ */ jsx21(Text10, { ...Lato13Bold2, color: "inherit", noOfLines: 1, children: label })
    }
  );
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilters/ActiveFilterPill/ActiveFilterPill.tsx
import { jsx as jsx22, jsxs as jsxs12 } from "react/jsx-runtime";
var ActiveFilterPill = ({
  icon: Icon,
  label,
  operatorLabel,
  operatorOptions,
  value,
  onRemove,
  paramName,
  type,
  isHidden,
  activeFilter,
  isDisabled
}) => {
  const { functions, ui } = useMagicTableToolbarContext();
  const uuidMenu = useRef2(uuidv4());
  const {
    isOpen: menuValueIsOpen,
    onOpen: menuValueOnOpen,
    onClose: menuValueOnClose
  } = useDisclosure();
  useEffect6(() => {
    if (menuValueIsOpen) {
      fixMenuPosition(uuidMenu.current);
    } else {
      unfixMenuPosition(uuidMenu.current);
    }
  }, [menuValueIsOpen]);
  const menuValueOnCloseCallback = useCallback8(() => {
    menuValueOnClose();
    setTimeout(() => {
      functions.setAddFilterMenuWidth(INITIAL_STATE.ui.addFilterMenuWidth);
      functions.tidyEmptyFilters();
    }, 150);
  }, [functions, menuValueOnClose]);
  return /* @__PURE__ */ jsxs12(
    Flex7,
    {
      background: GreyWhite,
      borderRadius: "8px",
      border: `${GreyGrey404} 1px solid`,
      color: isDisabled ? GreyGrey502 : GreyGrey70,
      width: "fit-content",
      boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.08), 0px 0px 5px 0px rgba(0, 0, 0, 0.03)",
      display: isHidden ? "none" : void 0,
      pr: isDisabled ? "3px" : void 0,
      children: [
        /* @__PURE__ */ jsxs12(Flex7, { gap: "5px", p: "7px", alignItems: "center", children: [
          Icon && /* @__PURE__ */ jsx22(Icon, { color: "inherit", width: "16px", height: "16px" }),
          /* @__PURE__ */ jsx22(Text11, { ...Lato13Bold3, color: "inherit", children: label })
        ] }),
        /* @__PURE__ */ jsxs12(Flex7, { py: "3px", gap: "4px", children: [
          /* @__PURE__ */ jsxs12(Menu, { variant: "component-library", isLazy: true, children: [
            /* @__PURE__ */ jsx22(
              ActiveFilterPillMenuButton,
              {
                label: operatorLabel,
                isDisabled
              }
            ),
            !isDisabled && /* @__PURE__ */ jsx22(Portal, { children: /* @__PURE__ */ jsx22(MenuList, { children: operatorOptions.map((option) => /* @__PURE__ */ jsx22(
              MenuItem3,
              {
                icon: option.icon,
                iconSpacing: "8px",
                onClick: option.onClick,
                children: /* @__PURE__ */ jsxs12(Flex7, { justifyContent: "space-between", alignItems: "center", children: [
                  /* @__PURE__ */ jsx22(Text11, { ...Lato13Regular3, color: "inherit", children: option.label }),
                  option.isSelected && /* @__PURE__ */ jsx22(CheckIcon2, { width: "16px", height: "16px", color: "inherit" })
                ] })
              },
              option.label
            )) }) })
          ] }),
          /* @__PURE__ */ jsxs12(
            Menu,
            {
              id: uuidMenu.current,
              variant: "component-library",
              isOpen: !isDisabled && menuValueIsOpen,
              onOpen: isDisabled ? noop : menuValueOnOpen,
              onClose: isDisabled ? noop : menuValueOnCloseCallback,
              closeOnSelect: false,
              isLazy: true,
              children: [
                /* @__PURE__ */ jsx22(ActiveFilterPillMenuButton, { label: value, isDisabled }),
                /* @__PURE__ */ jsx22(Portal, { children: /* @__PURE__ */ jsx22(
                  MenuList,
                  {
                    width: ui.addFilterMenuWidth,
                    maxHeight: "500px",
                    overflowY: "scroll",
                    paddingTop: "0px !important",
                    children: /* @__PURE__ */ jsx22(
                      MenuSelectedFilter,
                      {
                        paramName,
                        type,
                        menuOnClose: menuValueOnCloseCallback,
                        activeFilter
                      }
                    )
                  }
                ) })
              ]
            }
          )
        ] }),
        !isDisabled && /* @__PURE__ */ jsx22(Flex7, { p: "3px", children: /* @__PURE__ */ jsx22(
          Button3,
          {
            onClick: onRemove,
            variant: "unstyled",
            minWidth: "initial",
            height: "initial",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "4px",
            boxSize: "24px",
            color: GreyGrey604,
            _hover: { color: GreyGrey802, background: GreyGrey302 },
            children: /* @__PURE__ */ jsx22(XMarkIcon, { width: "16px", height: "16px", color: "inherit" })
          }
        ) })
      ]
    }
  );
};
var noop = () => {
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilters/useActiveFilters.tsx
import { useCallback as useCallback9, useMemo as useMemo10 } from "react";
import { match as match5 } from "ts-pattern";
import {
  ArrowLongLeftIcon,
  ArrowLongRightIcon,
  PlusIcon
} from "@heroicons/react/16/solid";
import { dateTimeWithFormat } from "@sequencehq/formatters";
import { jsx as jsx23 } from "react/jsx-runtime";
var useActiveFilters = () => {
  const { data, functions } = useMagicTableToolbarContext();
  const getOperatorLabel = useCallback9(
    (activeFilter) => match5(activeFilter.type).with("multiSelect", () => {
      if (activeFilter.type !== "multiSelect") {
        return "";
      }
      if (activeFilter.values.length >= 2) {
        return "is any of";
      }
      return "is";
    }).with("text", () => "contains").with("datePreset", () => {
      if (activeFilter.type !== "datePreset") {
        return "";
      }
      if (activeFilter.preset === "TODAY") {
        return DATE_TODAY_OPERATOR_LABELS[activeFilter.operator].toLowerCase();
      }
      return DATE_PRESET_OPERATOR_LABELS[activeFilter.operator].toLowerCase();
    }).with("dateCustom", () => {
      if (activeFilter.type !== "dateCustom") {
        return "";
      }
      return DATE_CUSTOM_OPERATOR_LABELS[activeFilter.operator].toLowerCase();
    }).with("toggle", () => "").exhaustive(),
    []
  );
  const getOperatorOptions = useCallback9(
    (activeFilter) => match5(activeFilter.type).with("multiSelect", () => {
      if (activeFilter.type !== "multiSelect") {
        return [];
      }
      return [
        {
          label: activeFilter.values.length >= 2 ? "Is any of" : "Is",
          icon: /* @__PURE__ */ jsx23(PlusIcon, { width: "16px", height: "16px", color: "inherit" }),
          onClick: () => {
          },
          isSelected: true
        }
      ];
    }).with("text", () => [
      {
        label: "Contains",
        icon: /* @__PURE__ */ jsx23(PlusIcon, { width: "16px", height: "16px", color: "inherit" }),
        onClick: () => {
        },
        isSelected: true
      }
    ]).with("datePreset", () => {
      if (activeFilter.type !== "datePreset") {
        return [];
      }
      return [
        {
          label: activeFilter.preset === "TODAY" ? DATE_TODAY_OPERATOR_LABELS["LESS_THAN"] : DATE_PRESET_OPERATOR_LABELS["LESS_THAN"],
          icon: /* @__PURE__ */ jsx23(ArrowLongLeftIcon, { width: "16px", height: "16px", color: "inherit" }),
          onClick: () => {
            functions.setDatePreset({
              paramName: activeFilter.paramName,
              preset: activeFilter.preset,
              operator: "LESS_THAN"
            });
          },
          isSelected: activeFilter.operator === "LESS_THAN"
        },
        {
          label: activeFilter.preset === "TODAY" ? DATE_TODAY_OPERATOR_LABELS["MORE_THAN"] : DATE_PRESET_OPERATOR_LABELS["MORE_THAN"],
          icon: /* @__PURE__ */ jsx23(
            ArrowLongRightIcon,
            {
              width: "16px",
              height: "16px",
              color: "inherit"
            }
          ),
          onClick: () => {
            functions.setDatePreset({
              paramName: activeFilter.paramName,
              preset: activeFilter.preset,
              operator: "MORE_THAN"
            });
          },
          isSelected: activeFilter.operator === "MORE_THAN"
        },
        {
          label: activeFilter.preset === "TODAY" ? DATE_TODAY_OPERATOR_LABELS["EQUALS"] : DATE_PRESET_OPERATOR_LABELS["EQUALS"],
          icon: /* @__PURE__ */ jsx23(PlusIcon, { width: "16px", height: "16px", color: "inherit" }),
          onClick: () => {
            functions.setDatePreset({
              paramName: activeFilter.paramName,
              preset: activeFilter.preset,
              operator: "EQUALS"
            });
          },
          isSelected: activeFilter.operator === "EQUALS"
        }
      ];
    }).with("dateCustom", () => {
      if (activeFilter.type !== "dateCustom") {
        return [];
      }
      return [
        {
          label: DATE_CUSTOM_OPERATOR_LABELS["BEFORE"],
          icon: /* @__PURE__ */ jsx23(ArrowLongLeftIcon, { width: "16px", height: "16px", color: "inherit" }),
          onClick: () => {
            functions.updateDateCustomOperator({
              paramName: activeFilter.paramName,
              prevOperator: activeFilter.operator,
              nextOperator: "BEFORE"
            });
          },
          isSelected: activeFilter.operator === "BEFORE"
        },
        {
          label: DATE_CUSTOM_OPERATOR_LABELS["AFTER"],
          icon: /* @__PURE__ */ jsx23(
            ArrowLongRightIcon,
            {
              width: "16px",
              height: "16px",
              color: "inherit"
            }
          ),
          onClick: () => {
            functions.updateDateCustomOperator({
              paramName: activeFilter.paramName,
              prevOperator: activeFilter.operator,
              nextOperator: "AFTER"
            });
          },
          isSelected: activeFilter.operator === "AFTER"
        },
        {
          label: DATE_CUSTOM_OPERATOR_LABELS["EQUALS"],
          icon: /* @__PURE__ */ jsx23(PlusIcon, { width: "16px", height: "16px", color: "inherit" }),
          onClick: () => {
            functions.updateDateCustomOperator({
              paramName: activeFilter.paramName,
              prevOperator: activeFilter.operator,
              nextOperator: "EQUALS"
            });
          },
          isSelected: activeFilter.operator === "EQUALS"
        }
      ];
    }).with("toggle", () => []).exhaustive(),
    [functions]
  );
  const getValue = useCallback9(
    ({
      thisFilter,
      activeFilter
    }) => match5(activeFilter.type).with("multiSelect", () => {
      if (activeFilter.type !== "multiSelect") {
        return "";
      }
      if (activeFilter.values.length === 1) {
        const thisOptionStatic = thisFilter.type === "multiSelect" && thisFilter.options.find(
          (option) => option.value === activeFilter.values[0]
        );
        if (thisOptionStatic) {
          return thisOptionStatic.label;
        }
        const thisOptionAsync = data.optionsCache[thisFilter.paramName]?.find((option) => option.value === activeFilter.values[0]);
        if (thisOptionAsync) {
          return thisOptionAsync.label;
        }
        return "1 option";
      }
      return `${activeFilter.values.length} options`;
    }).with("text", () => {
      if (activeFilter.type !== "text") {
        return "";
      }
      return activeFilter.value;
    }).with("datePreset", () => {
      if (activeFilter.type !== "datePreset") {
        return "";
      }
      return DATE_PRESETS[activeFilter.preset];
    }).with("dateCustom", () => {
      if (activeFilter.type !== "dateCustom") {
        return "";
      }
      return dateTimeWithFormat(
        new Date(activeFilter.date).toISOString(),
        "d MMM yyyy"
      );
    }).with("toggle", () => "").exhaustive(),
    [data.optionsCache]
  );
  const activeFilters = useMemo10(
    () => data.activeFilters.reduce(
      (acc, activeFilter) => {
        const thisFilter = data.menuFilters?.find(
          (filter) => filter.paramName === activeFilter.paramName
        );
        if (!thisFilter) {
          return [...acc];
        }
        const { paramName, icon, label, type } = thisFilter;
        return [
          ...acc,
          {
            paramName,
            icon,
            label,
            type,
            operatorLabel: getOperatorLabel(activeFilter),
            operatorOptions: getOperatorOptions(activeFilter),
            value: getValue({ thisFilter, activeFilter }),
            onRemove: () => {
              functions.removeFilter({
                paramName,
                dateCustomOperator: activeFilter.type === "dateCustom" ? activeFilter.operator : void 0
              });
            },
            isHidden: activeFilter.type === "multiSelect" && activeFilter.values.length === 0,
            isDisabled: !!thisFilter.disabled,
            activeFilter
          }
        ];
      },
      []
    ),
    [
      data.activeFilters,
      data.menuFilters,
      functions,
      getOperatorLabel,
      getOperatorOptions,
      getValue
    ]
  );
  return {
    activeFilters
  };
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilters/ActiveFilters.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var ActiveFilters = () => {
  const { activeFilters } = useActiveFilters();
  const { queries } = useMagicTableToolbarContext();
  const canChangeFilters = queries.canChangeFilters();
  return activeFilters.map((activeFilter) => /* @__PURE__ */ jsx24(
    ActiveFilterPill,
    {
      ...activeFilter,
      isDisabled: !canChangeFilters || activeFilter.isDisabled
    },
    activeFilter.paramName
  ));
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/DropdownAddFilter.tsx
import { useCallback as useCallback10, useEffect as useEffect8, useRef as useRef4 } from "react";
import { Menu as Menu2, MenuList as MenuList2, Portal as Portal2, useDisclosure as useDisclosure2 } from "@chakra-ui/react";
import { v4 as uuidv43 } from "uuid";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/DropdownAddFilterMenuButton.tsx
import { Button as Button4, IconButton, MenuButton as MenuButton2 } from "@chakra-ui/react";
import AdjustmentsHorizontalIcon from "@heroicons/react/16/solid/AdjustmentsHorizontalIcon";
import { jsx as jsx25 } from "react/jsx-runtime";
var DropdownAddFilterMenuButton = ({
  useSmallVersion,
  isDisabled
}) => {
  if (useSmallVersion) {
    return /* @__PURE__ */ jsx25(
      MenuButton2,
      {
        as: IconButton,
        variant: "component-library-secondary",
        icon: /* @__PURE__ */ jsx25(
          AdjustmentsHorizontalIcon,
          {
            color: "inherit",
            width: "16px",
            height: "16px"
          }
        ),
        minWidth: "initial",
        width: "32px",
        padding: "8px",
        isDisabled
      }
    );
  }
  return /* @__PURE__ */ jsx25(
    MenuButton2,
    {
      as: Button4,
      leftIcon: /* @__PURE__ */ jsx25(AdjustmentsHorizontalIcon, { color: "inherit", width: "16px", height: "16px" }),
      iconSpacing: "4px",
      variant: "component-library-secondary",
      isDisabled,
      children: "Filters"
    }
  );
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/useDropdownAddFilter.tsx
import { useMemo as useMemo11, useState as useState9 } from "react";
import { v4 as uuidv42 } from "uuid";
import { jsx as jsx26 } from "react/jsx-runtime";
var useDropdownAddFilter = () => {
  const { data, queries, ui, functions } = useMagicTableToolbarContext();
  const [selectedFilter, setSelectedFilter] = useState9();
  const filtersWithUuid = useMemo11(
    () => data.menuFilters.map((filter) => ({
      ...filter,
      uuid: uuidv42()
    })).filter((filter) => {
      if (filter.type === "date") {
        const hasPresetFilter = data.activeFilters.find(
          (activeFilter) => activeFilter.type === "datePreset" && activeFilter.paramName === filter.paramName
        );
        if (hasPresetFilter) {
          return false;
        }
        const hasBefore = data.activeFilters.find(
          (activeFilter) => activeFilter.type === "dateCustom" && activeFilter.paramName === filter.paramName && activeFilter.operator === "BEFORE"
        );
        const hasAfter = data.activeFilters.find(
          (activeFilter) => activeFilter.type === "dateCustom" && activeFilter.paramName === filter.paramName && activeFilter.operator === "AFTER"
        );
        return !(hasBefore && hasAfter);
      }
      return !data.activeFilters.some(
        (activeFilter) => activeFilter.paramName === filter.paramName
      );
    }),
    [data.activeFilters, data.menuFilters]
  );
  const {
    results: searchResults,
    input: searchInput,
    reset: searchReset
  } = useSimpleSearch({
    items: filtersWithUuid,
    searchOn: "label"
  });
  const displayedFilters = useMemo11(
    () => searchResults.map((filter) => ({
      paramName: filter.paramName,
      label: filter.label,
      uuid: filter.uuid,
      icon: (() => {
        if (!filter.icon) {
          return void 0;
        }
        const Icon = filter.icon;
        return /* @__PURE__ */ jsx26(Icon, { width: "16px", height: "16px", color: "inherit" });
      })(),
      type: filter.type
    })),
    [searchResults]
  );
  return {
    displayedFilters,
    searchInput,
    selectedFilter: {
      filter: selectedFilter,
      onSelect: ({ paramName, type }) => {
        setSelectedFilter({ paramName, type });
      }
    },
    ui: {
      isAddFilterButtonVisible: queries.canDisplayAddFiltersMenu(),
      isAddFilterButtonEnabled: queries.canChangeFilters(),
      useSmallAddFilterButton: queries.useSmallAddFilterButton(),
      menuWidth: ui.addFilterMenuWidth,
      reset: () => {
        searchReset();
        functions.setAddFilterMenuWidth(INITIAL_STATE.ui.addFilterMenuWidth);
        setSelectedFilter(void 0);
      }
    }
  };
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/MenuItemsAddFilter.tsx
import { Box as Box9, MenuItem as MenuItem4 } from "@chakra-ui/react";
import { SimpleSearchMenuInput as SimpleSearchMenuInput3 } from "@sequencehq/core-components";
import { useEffect as useEffect7, useRef as useRef3 } from "react";
import { Fragment as Fragment8, jsx as jsx27, jsxs as jsxs13 } from "react/jsx-runtime";
var MenuItemsAddFilter = ({
  hook: { searchInput, displayedFilters, selectedFilter }
}) => {
  const refInput = useRef3(null);
  useEffect7(() => {
    setTimeout(() => {
      refInput.current?.focus();
    }, 150);
  }, []);
  return /* @__PURE__ */ jsxs13(Fragment8, { children: [
    /* @__PURE__ */ jsx27(
      SimpleSearchMenuInput3,
      {
        ref: refInput,
        value: searchInput.value,
        onChange: searchInput.onChange,
        placeholder: "Search filters",
        showDivider: displayedFilters.length > 0
      }
    ),
    displayedFilters.length > 0 && /* @__PURE__ */ jsx27(Box9, { height: "4px" }),
    displayedFilters.map(({ uuid, label, icon, paramName, type }) => /* @__PURE__ */ jsx27(
      MenuItem4,
      {
        icon,
        iconSpacing: "8px",
        onClick: () => selectedFilter.onSelect({ paramName, type }),
        children: label
      },
      uuid
    ))
  ] });
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/DropdownAddFilter/DropdownAddFilter.tsx
import { jsx as jsx28, jsxs as jsxs14 } from "react/jsx-runtime";
var DropdownAddFilter = () => {
  const uuidMenu = useRef4(uuidv43());
  const { functions } = useMagicTableToolbarContext();
  const hook = useDropdownAddFilter();
  const { selectedFilter, ui } = hook;
  const { isOpen, onOpen, onClose: onCloseProp } = useDisclosure2();
  const onClose = useCallback10(() => {
    onCloseProp();
    setTimeout(() => {
      functions.tidyEmptyFilters();
      ui.reset();
    }, 150);
  }, [functions, onCloseProp, ui]);
  useEffect8(() => {
    if (isOpen) {
      fixMenuPosition(uuidMenu.current);
    } else {
      unfixMenuPosition(uuidMenu.current);
    }
  }, [isOpen]);
  if (!ui.isAddFilterButtonVisible) {
    return null;
  }
  return /* @__PURE__ */ jsxs14(
    Menu2,
    {
      id: uuidMenu.current,
      variant: "component-library",
      isOpen,
      closeOnSelect: false,
      offset: [0, 4],
      onOpen,
      onClose,
      autoSelect: false,
      isLazy: true,
      children: [
        /* @__PURE__ */ jsx28(
          DropdownAddFilterMenuButton,
          {
            useSmallVersion: ui.useSmallAddFilterButton,
            isDisabled: !ui.isAddFilterButtonEnabled
          }
        ),
        /* @__PURE__ */ jsx28(Portal2, { children: /* @__PURE__ */ jsx28(
          MenuList2,
          {
            width: ui.menuWidth,
            maxHeight: "500px",
            overflowY: "scroll",
            paddingTop: "0px !important",
            children: typeof selectedFilter.filter === "undefined" ? /* @__PURE__ */ jsx28(MenuItemsAddFilter, { hook }) : /* @__PURE__ */ jsx28(
              MenuSelectedFilter,
              {
                ...selectedFilter.filter,
                menuOnClose: onClose
              }
            )
          }
        ) })
      ]
    }
  );
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/MagicTableFiltersLoading.tsx
import { Spinner as Spinner2, Center as Center3 } from "@chakra-ui/react";
import { GreyGrey50 as GreyGrey503 } from "@sequencehq/design-tokens";
import { jsx as jsx29 } from "react/jsx-runtime";
var MagicTableFiltersLoading = () => {
  const { data } = useMagicTableToolbarContext();
  return /* @__PURE__ */ jsx29(Center3, { boxSize: "20px", children: data.loading && /* @__PURE__ */ jsx29(Spinner2, { boxSize: "16px", color: GreyGrey503 }) });
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarViewSettings/MagicTableToolbarViewSettings.tsx
import {
  Button as Button6,
  Flex as Flex9,
  FormLabel,
  Menu as Menu3,
  MenuButton as MenuButton3,
  MenuDivider as MenuDivider2,
  MenuItem as MenuItem8,
  MenuList as MenuList4,
  Portal as Portal3,
  Text as Text14
} from "@chakra-ui/react";
import Cog6ToothIcon from "@heroicons/react/16/solid/Cog6ToothIcon";
import PlusCircleIcon2 from "@heroicons/react/16/solid/PlusCircleIcon";
import {
  DndContext,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors
} from "@dnd-kit/core";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarViewSettings/ViewSettingsMenuItem.tsx
import { DragHandleIcon } from "@chakra-ui/icons";
import { Button as Button5, MenuItem as MenuItem5, Text as Text12, Flex as Flex8, Center as Center4, Box as Box10 } from "@chakra-ui/react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import MinusCircleIcon from "@heroicons/react/16/solid/MinusCircleIcon";
import PlusCircleIcon from "@heroicons/react/16/solid/PlusCircleIcon";
import { GreyGrey50 as GreyGrey504, Lato13Regular as Lato13Regular4 } from "@sequencehq/design-tokens";
import { jsx as jsx30, jsxs as jsxs15 } from "react/jsx-runtime";
var ViewSettingsMenuItem = ({
  id,
  label,
  type,
  onColumnToggleVisibility,
  canToggleColumnVisibility,
  enableColumnReordering
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  return /* @__PURE__ */ jsx30(
    MenuItem5,
    {
      as: Box10,
      onClick: () => {
        if (type === "invisible") {
          onColumnToggleVisibility(id);
        }
      },
      _active: type === "visible" ? {} : void 0,
      ref: setNodeRef,
      style: {
        transform: CSS.Transform.toString(transform),
        transition
      },
      children: /* @__PURE__ */ jsxs15(Flex8, { width: "100%", gap: "8px", children: [
        type === "visible" && enableColumnReordering && /* @__PURE__ */ jsx30(Center4, { ...listeners, ...attributes, cursor: "move", children: /* @__PURE__ */ jsx30(DragHandleIcon, { boxSize: "10px", color: GreyGrey504 }) }),
        /* @__PURE__ */ jsx30(
          Text12,
          {
            ...Lato13Regular4,
            color: "inherit",
            flex: "1",
            overflow: "hidden",
            display: "-webkit-box",
            sx: {
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1,
              lineBreak: "anywhere"
            },
            children: label
          }
        ),
        /* @__PURE__ */ jsxs15(
          Button5,
          {
            variant: "unstyled",
            minWidth: "initial",
            height: "initial",
            borderRadius: "0px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            onClick: () => {
              if (type === "visible" && canToggleColumnVisibility) {
                onColumnToggleVisibility(id);
              }
            },
            children: [
              type === "visible" && canToggleColumnVisibility && /* @__PURE__ */ jsx30(MinusCircleIcon, { width: "16px", height: "16px", color: "inherit" }),
              type === "invisible" && /* @__PURE__ */ jsx30(PlusCircleIcon, { width: "16px", height: "16px", color: "inherit" })
            ]
          }
        )
      ] })
    }
  );
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarViewSettings/useViewSettings.tsx
import { useCallback as useCallback11, useMemo as useMemo12, useState as useState10 } from "react";

// src/components/MagicTable/utils/index.ts
var parseTableState = (table) => {
  const state = table.getState();
  const allColumns = table.getAllFlatColumns();
  const allColumnIds = allColumns.map((v) => v.id).filter((v) => !MAGIC_TABLE_SPECIAL_COLUMNS.includes(v));
  const allVisibleColumnIds = allColumnIds.filter((id) => {
    return typeof state.columnVisibility[id] === "undefined" || typeof state.columnVisibility[id] !== "undefined" && Boolean(state.columnVisibility[id]);
  });
  const allInvisibleColumnIds = allColumnIds.filter((id) => {
    return typeof state.columnVisibility[id] !== "undefined" && !state.columnVisibility[id];
  });
  return {
    allColumns,
    allColumnIds,
    allVisibleColumnIds,
    allInvisibleColumnIds
  };
};
var getColumnById = (columns, id) => {
  return columns.find((c) => c.id === id);
};
var reorderTableMagicColumn = (draggedColumnId, targetColumnId, columnOrder) => {
  if (typeof draggedColumnId !== "string" || typeof targetColumnId !== "string") {
    return [...columnOrder];
  }
  columnOrder.splice(
    columnOrder.indexOf(targetColumnId),
    0,
    columnOrder.splice(columnOrder.indexOf(draggedColumnId), 1)[0]
  );
  return [...columnOrder];
};
var shouldHandleDndEvent = (element) => {
  let cur = element;
  while (cur) {
    if (cur.dataset && cur.dataset.noDnd) {
      return false;
    }
    cur = cur.parentElement;
  }
  return true;
};
var getDefaultColumnWidth = ({
  columns,
  containerWidth = 0,
  showCheckboxes,
  showExpandButtons,
  showAddColumn
}) => {
  const columnWidthExpandButton = showExpandButtons ? COLUMN_DEFAULT_WIDTH_EXPAND : 0;
  const columnWidthCheckbox = showCheckboxes ? showExpandButtons ? COLUMN_DEFAULT_WIDTH_CHECKBOX_WITH_EXPAND : COLUMN_DEFAULT_WIDTH_CHECKBOX : 0;
  const singleColumnWidth = (containerWidth - columnWidthCheckbox - columnWidthExpandButton - (showAddColumn ? COLUMN_DEFAULT_WIDTH_ADD_COLUMN : 0) - DEFAULT_COLUMN_WIDTH_EXTRA_RIGHT_PADDING) / columns.length;
  return columns.map((c) => ({ [c.id || ""]: singleColumnWidth })).reduce((acc, obj) => ({ ...acc, ...obj }), {});
};
var isFirstExpandedRowId = (rowId) => {
  return rowId.endsWith(".0");
};
var isSubRowId = (rowId) => {
  return rowId.includes(".");
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarViewSettings/useViewSettings.tsx
import isEmpty from "lodash/isEmpty";
var isTableState = (obj) => {
  return "columnVisibility" in obj;
};
var useViewSettings = () => {
  const { data, functions, ui, queries } = useMagicTableToolbarContext();
  const tableState = functions.getTableState();
  const tableAllFlatColumns = functions.getTableAllFlatColumns();
  const visibleColumns = useMemo12(() => {
    if (!isTableState(tableState)) {
      return [];
    }
    const unorderedVisibleColumns = Object.entries(tableState.columnVisibility).filter(([, isVisible]) => isVisible).filter(([columnId]) => !MAGIC_TABLE_SPECIAL_COLUMNS.includes(columnId)).reduce((acc, [id]) => {
      const column = getColumnById(tableAllFlatColumns, id);
      if (!column) {
        return [...acc];
      }
      return [
        ...acc,
        {
          id,
          label: column.columnDef.header?.toString() || ""
        }
      ];
    }, []);
    const unorderedVisibleCustomColumns = data.customColumns.selected.map(
      (customColumn) => ({
        id: `${CUSTOM_EVENT_COLUMN_PREFIX}${customColumn}`,
        label: customColumn
      })
    );
    const allUnorderedVisibleColumns = [
      ...unorderedVisibleColumns,
      ...unorderedVisibleCustomColumns
    ];
    return data.columnOrder.map(
      (orderedColumnId) => allUnorderedVisibleColumns.find(({ id }) => id === orderedColumnId)
    ).filter(Boolean);
  }, [data.columnOrder, data.customColumns, tableAllFlatColumns, tableState]);
  const invisibleColumns = useMemo12(() => {
    const visibleColumnIds = visibleColumns.map(({ id }) => id);
    return tableAllFlatColumns.filter(
      (column) => !visibleColumnIds.includes(column.id) && !MAGIC_TABLE_SPECIAL_COLUMNS.includes(column.id) && !column.id.startsWith(CUSTOM_EVENT_COLUMN_PREFIX)
    ).reduce(
      (acc, column) => [
        ...acc,
        {
          id: column.id,
          label: column.columnDef.header?.toString() || ""
        }
      ],
      []
    );
  }, [visibleColumns, tableAllFlatColumns]);
  const onColumnToggleVisibility = useCallback11(
    (columnId) => {
      const column = getColumnById(tableAllFlatColumns, columnId);
      if (!column) {
        return;
      }
      column.toggleVisibility();
      const isCustomColumn = columnId.startsWith(CUSTOM_EVENT_COLUMN_PREFIX);
      if (isCustomColumn) {
        functions.removeCustomColumn(columnId);
      }
    },
    [functions, tableAllFlatColumns]
  );
  const showVisibleInvisibleDivider = useMemo12(
    () => invisibleColumns.length > 0 || queries.canAddCustomColumns(),
    [invisibleColumns.length, queries]
  );
  const onColumnDragEnd = useCallback11(
    ({ active, over }) => {
      if (!over) {
        return;
      }
      functions.setColumnOrder(
        reorderTableMagicColumn(active.id, over.id, data.columnOrder)
      );
    },
    [data.columnOrder, functions]
  );
  const toggles = useMemo12(
    () => data.viewSettingsFilters.map((filter) => {
      const thisFilter = data.activeFilters.find(
        (activeFilter) => activeFilter.paramName === filter.paramName
      );
      const isChecked = (() => {
        if (!thisFilter || thisFilter && thisFilter.type != "toggle") {
          return false;
        }
        return thisFilter.value;
      })();
      return {
        paramName: filter.paramName,
        label: filter.label,
        isChecked,
        onChange: () => {
          functions.switchToggleOption({
            paramName: filter.paramName,
            value: !isChecked
          });
        }
      };
    }),
    [data.activeFilters, data.viewSettingsFilters, functions]
  );
  const showTogglesDivider = useMemo12(() => toggles.length > 0, [toggles.length]);
  const [showCustomColumnsMenu, setShowCustomColumnsMenu] = useState10(false);
  const canRemoveColumns = useMemo12(
    () => visibleColumns.length > 1,
    [visibleColumns]
  );
  return {
    toggles,
    grouping: {
      enabled: !isEmpty(data.grouping?.groupableColumns),
      options: [
        {
          label: "No grouping",
          value: ""
        },
        ...data.grouping?.groupableColumns?.map((columnId) => ({
          label: tableAllFlatColumns.find((c) => c.id === columnId)?.columnDef.header?.toString() || "",
          value: columnId
        })) || []
      ],
      onChange: (value) => {
        data.grouping?.onGroupBy?.(value);
      },
      value: data.grouping?.groupBy || ""
    },
    columns: {
      visible: visibleColumns,
      invisible: invisibleColumns,
      canRemoveColumns
    },
    actions: {
      onColumnToggleVisibility,
      onColumnDragEnd
    },
    ui: {
      buttonEnabled: queries.canChangeFilters(),
      viewSettingsHeader: ui.viewSettingsHeader,
      showViewSettingsHeaderDivider: Boolean(ui.viewSettingsHeader),
      showTogglesDivider,
      showVisibleInvisibleDivider,
      reset: () => {
        setShowCustomColumnsMenu(false);
      }
    },
    customColumns: {
      enabled: queries.canAddCustomColumns(),
      onToggleMenu: () => {
        setShowCustomColumnsMenu(true);
      },
      showMenu: showCustomColumnsMenu
    }
  };
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarViewSettings/MagicTableToolbarViewSettings.tsx
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import {
  GreyGrey80 as GreyGrey803,
  Lato13Bold as Lato13Bold4,
  Lato13Regular as Lato13Regular6
} from "@sequencehq/design-tokens";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/MenuCustomColumns/MenuCustomColumns.tsx
import { Box as Box11, MenuItem as MenuItem6, MenuList as MenuList3 } from "@chakra-ui/react";
import { SimpleSearchMenuInput as SimpleSearchMenuInput4 } from "@sequencehq/core-components";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/MenuCustomColumns/useMenuCustomColumns.tsx
import { useCallback as useCallback12, useMemo as useMemo13 } from "react";
var useMenuCustomColumns = () => {
  const { data, functions } = useMagicTableToolbarContext();
  const availableOptions = useMemo13(
    () => data.customColumns.available.filter((column) => !data.customColumns.selected.includes(column)).map((column) => ({
      label: column,
      value: column
    })),
    [data.customColumns]
  );
  const { results, input } = useSimpleSearch({
    items: availableOptions,
    searchOn: "label"
  });
  const onSelectOption = useCallback12(
    (columnId) => {
      functions.addCustomColumn(columnId);
    },
    [functions]
  );
  return {
    options: results,
    onSelectOption,
    searchInput: {
      ...input,
      placeholder: "Event property"
    }
  };
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/MenuCustomColumns/MenuCustomColumns.tsx
import { jsx as jsx31, jsxs as jsxs16 } from "react/jsx-runtime";
var MenuCustomColumns = () => {
  const { options, onSelectOption, searchInput } = useMenuCustomColumns();
  return /* @__PURE__ */ jsxs16(
    MenuList3,
    {
      width: "216px",
      maxHeight: "500px",
      overflowY: "scroll",
      paddingTop: "0px !important",
      children: [
        /* @__PURE__ */ jsx31(
          SimpleSearchMenuInput4,
          {
            value: searchInput.value,
            onChange: searchInput.onChange,
            placeholder: searchInput.placeholder,
            showDivider: options.length > 0
          }
        ),
        options.length > 0 && /* @__PURE__ */ jsx31(Box11, { height: "4px" }),
        options.map(({ label, value }) => /* @__PURE__ */ jsx31(
          MenuItem6,
          {
            onClick: () => {
              setTimeout(() => {
                onSelectOption(value);
              }, 1);
            },
            closeOnSelect: true,
            children: label
          },
          value
        ))
      ]
    }
  );
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarViewSettings/MagicTableToolbarViewSettings.tsx
import { InputSelectControl, Switch } from "@sequencehq/core-components";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarViewSettings/CopyTableResults.tsx
import { MenuItem as MenuItem7, Text as Text13, useToast } from "@chakra-ui/react";
import { DocumentDuplicateIcon } from "@heroicons/react/16/solid";
import { Lato13Regular as Lato13Regular5 } from "@sequencehq/design-tokens";
import { Toast } from "@sequencehq/core-components";
import { jsx as jsx32 } from "react/jsx-runtime";
function formatCellValue(value) {
  if (value === null || value === void 0)
    return "";
  if (value instanceof Date)
    return value.toISOString();
  if (typeof value === "object")
    return JSON.stringify(value);
  return String(value);
}
function showToast(toast, type) {
  const messages = {
    success: {
      title: "Table copied to clipboard",
      description: "You can now paste it into a spreadsheet"
    },
    error: {
      title: "Failed to copy table",
      description: "Please try again"
    }
  };
  toast.closeAll();
  toast({
    position: "bottom",
    duration: 3e3,
    render: () => /* @__PURE__ */ jsx32(
      Toast,
      {
        type,
        title: messages[type].title,
        description: messages[type].description,
        isClosable: true
      }
    )
  });
}
function CopyTableResults({
  table,
  isEnabled = true
}) {
  const toast = useToast();
  const handleCopy = async () => {
    try {
      const columns = table.getAllColumns().filter(
        (column) => !MAGIC_TABLE_SPECIAL_COLUMNS.includes(column.id) && column.getIsVisible() && !column.id.startsWith(CUSTOM_EVENT_COLUMN_PREFIX) && !column.id.includes("eventProperties")
      );
      const hasEventProperties = table.getRowModel().rows.some((row) => row.original.eventProperties);
      const headers = hasEventProperties ? [
        ...columns.map((column) => column.columnDef.header?.toString() || ""),
        "Event Properties"
      ] : columns.map((column) => column.columnDef.header?.toString() || "");
      const dataRows = table.getRowModel().rows.map((row) => {
        const standardColumns = columns.map(
          (column) => formatCellValue(row.getValue(column.id))
        );
        if (!hasEventProperties)
          return standardColumns;
        const eventPropertiesStr = formatCellValue(row.original.eventProperties);
        return [...standardColumns, eventPropertiesStr];
      });
      const tsv = [headers, ...dataRows].map((row) => row.join("	")).join("\n");
      await navigator.clipboard.writeText(tsv);
      showToast(toast, "success");
    } catch (error) {
      showToast(toast, "error");
    }
  };
  return /* @__PURE__ */ jsx32(
    MenuItem7,
    {
      onClick: handleCopy,
      isDisabled: !isEnabled,
      icon: /* @__PURE__ */ jsx32(DocumentDuplicateIcon, { width: 16, height: 16, color: "inherit" }),
      children: /* @__PURE__ */ jsx32(Text13, { ...Lato13Regular5, color: "inherit", children: "Copy results" })
    }
  );
}

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarViewSettings/MagicTableToolbarViewSettings.tsx
import { Fragment as Fragment9, jsx as jsx33, jsxs as jsxs17 } from "react/jsx-runtime";
var MagicTableToolbarViewSettings = ({
  enableColumnReordering,
  table,
  enableCopyResults = false
}) => {
  const { toggles, columns, actions, ui, customColumns, grouping } = useViewSettings();
  const sensors = useSensors(useSensor(PointerSensor, {}));
  const menuListViewSetings = /* @__PURE__ */ jsxs17(MenuList4, { width: "250px", children: [
    ui.viewSettingsHeader,
    ui.showViewSettingsHeaderDivider && /* @__PURE__ */ jsx33(MenuDivider2, {}),
    enableCopyResults && /* @__PURE__ */ jsxs17(Fragment9, { children: [
      /* @__PURE__ */ jsx33(CopyTableResults, { table }),
      /* @__PURE__ */ jsx33(MenuDivider2, {})
    ] }),
    grouping.enabled && /* @__PURE__ */ jsxs17(Fragment9, { children: [
      /* @__PURE__ */ jsxs17(
        Flex9,
        {
          p: "8px",
          gap: "8px",
          justifyContent: "space-between",
          alignItems: "center",
          alignContent: "center",
          flexDirection: "row",
          children: [
            /* @__PURE__ */ jsx33(FormLabel, { children: /* @__PURE__ */ jsx33(Text14, { ...Lato13Bold4, color: GreyGrey803, children: "Grouping" }) }),
            /* @__PURE__ */ jsx33(
              InputSelectControl,
              {
                options: grouping.options,
                onChange: grouping.onChange,
                initialValue: grouping.value,
                placeholder: "No grouping"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx33(MenuDivider2, {})
    ] }),
    toggles.map(({ paramName, label, isChecked, onChange }) => /* @__PURE__ */ jsxs17(
      Flex9,
      {
        p: "8px",
        gap: "8px",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ jsx33(FormLabel, { htmlFor: `switch-${paramName}`, children: /* @__PURE__ */ jsx33(Text14, { ...Lato13Bold4, color: GreyGrey803, children: label }) }),
          /* @__PURE__ */ jsx33(
            Switch,
            {
              id: `switch-${paramName}`,
              isChecked,
              onChange
            }
          )
        ]
      },
      paramName
    )),
    ui.showTogglesDivider && /* @__PURE__ */ jsx33(MenuDivider2, {}),
    !enableColumnReordering ? columns.visible.map((column) => /* @__PURE__ */ jsx33(
      ViewSettingsMenuItem,
      {
        type: "visible",
        onColumnToggleVisibility: actions.onColumnToggleVisibility,
        canToggleColumnVisibility: columns.canRemoveColumns,
        enableColumnReordering,
        ...column
      },
      column.id
    )) : /* @__PURE__ */ jsx33(
      DndContext,
      {
        sensors,
        collisionDetection: closestCenter,
        onDragEnd: actions.onColumnDragEnd,
        children: /* @__PURE__ */ jsx33(
          SortableContext,
          {
            items: columns.visible,
            strategy: verticalListSortingStrategy,
            children: columns.visible.map((column) => /* @__PURE__ */ jsx33(
              ViewSettingsMenuItem,
              {
                type: "visible",
                onColumnToggleVisibility: actions.onColumnToggleVisibility,
                canToggleColumnVisibility: columns.canRemoveColumns,
                enableColumnReordering,
                ...column
              },
              column.id
            ))
          }
        )
      }
    ),
    ui.showVisibleInvisibleDivider && /* @__PURE__ */ jsx33(MenuDivider2, {}),
    columns.invisible.map((column) => /* @__PURE__ */ jsx33(
      ViewSettingsMenuItem,
      {
        type: "invisible",
        onColumnToggleVisibility: actions.onColumnToggleVisibility,
        canToggleColumnVisibility: true,
        ...column
      },
      column.id
    )),
    customColumns.enabled && /* @__PURE__ */ jsx33(MenuItem8, { onClick: customColumns.onToggleMenu, children: /* @__PURE__ */ jsxs17(Flex9, { justifyContent: "space-between", alignItems: "center", width: "100%", children: [
      /* @__PURE__ */ jsx33(Text14, { ...Lato13Regular6, color: "inherit", children: "Event property" }),
      /* @__PURE__ */ jsx33(PlusCircleIcon2, { width: "16px", height: "16px", color: "inherit" })
    ] }) })
  ] });
  return /* @__PURE__ */ jsxs17(
    Menu3,
    {
      variant: "component-library",
      closeOnSelect: false,
      offset: [0, 4],
      autoSelect: false,
      onClose: () => {
        setTimeout(() => {
          ui.reset();
        }, 150);
      },
      isLazy: true,
      children: [
        /* @__PURE__ */ jsx33(
          MenuButton3,
          {
            as: Button6,
            leftIcon: /* @__PURE__ */ jsx33(Cog6ToothIcon, { color: "inherit", width: "16px", height: "16px" }),
            iconSpacing: "4px",
            variant: "component-library-secondary",
            isDisabled: !ui.buttonEnabled,
            children: "View settings"
          }
        ),
        /* @__PURE__ */ jsx33(Portal3, { children: customColumns.showMenu ? /* @__PURE__ */ jsx33(MenuCustomColumns, {}) : menuListViewSetings })
      ]
    }
  );
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilterControlButtons.tsx
import { Center as Center5, Divider as Divider2 } from "@chakra-ui/react";
import { GreyGrey30 as GreyGrey303 } from "@sequencehq/design-tokens";

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ButtonClearAllFilters.tsx
import { Button as Button7 } from "@sequencehq/core-components";
import { jsx as jsx34 } from "react/jsx-runtime";
var ButtonClearAllFilters = () => {
  const { queries, functions } = useMagicTableToolbarContext();
  const { visible, enabled } = queries.canClearAllFilters();
  if (!visible) {
    return null;
  }
  return /* @__PURE__ */ jsx34(
    Button7,
    {
      variant: "ghost",
      onClick: () => {
        functions.clearAllFilters();
      },
      disabled: !enabled,
      children: "Clear"
    }
  );
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ButtonSaveFilters.tsx
import { Button as Button8, SequenceMenu } from "@sequencehq/core-components";
import { ChevronDownIcon as ChevronDownIcon2 } from "@heroicons/react/16/solid";
import { jsx as jsx35 } from "react/jsx-runtime";
var ButtonSaveFilters = ({ onSaveFilters, onUpdateSavedFilters }) => {
  const { queries } = useMagicTableToolbarContext();
  const { visible, enabled } = queries.canSaveFilter();
  if (!visible) {
    return null;
  }
  if (onUpdateSavedFilters) {
    return /* @__PURE__ */ jsx35(
      SequenceMenu,
      {
        width: 195,
        alignment: "bottom-right",
        items: [
          {
            label: "Save to this view",
            onClick: () => {
              onUpdateSavedFilters();
            }
          },
          ...onSaveFilters ? [
            {
              label: "Create new view...",
              onClick: () => {
                onSaveFilters();
              }
            }
          ] : []
        ],
        menuButton: /* @__PURE__ */ jsx35(
          Button8,
          {
            variant: "secondary",
            trailingIcon: /* @__PURE__ */ jsx35(ChevronDownIcon2, { width: "16px", height: "16px" }),
            disabled: !enabled,
            children: "Save filter"
          }
        )
      }
    );
  }
  return /* @__PURE__ */ jsx35(Button8, { variant: "secondary", onClick: onSaveFilters, disabled: !enabled, children: "Save filter" });
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarFilters/ActiveFilterControlButtons.tsx
import { Fragment as Fragment10, jsx as jsx36, jsxs as jsxs18 } from "react/jsx-runtime";
var ActiveFilterControlButtons = ({
  onSaveFilters,
  onUpdateSavedFilters
}) => {
  const { queries, data } = useMagicTableToolbarContext();
  return /* @__PURE__ */ jsxs18(Fragment10, { children: [
    /* @__PURE__ */ jsx36(ButtonClearAllFilters, {}),
    /* @__PURE__ */ jsx36(
      ButtonSaveFilters,
      {
        onSaveFilters,
        onUpdateSavedFilters
      }
    ),
    data.activeFilters.length > 0 && /* @__PURE__ */ jsx36(Center5, { height: "24px", px: 1, children: /* @__PURE__ */ jsx36(Divider2, { orientation: "vertical", color: GreyGrey303 }) })
  ] });
};

// src/components/MagicTable/FiltersV3/MagicTableToolbarV3/MagicTableToolbarV3.tsx
import { jsx as jsx37, jsxs as jsxs19 } from "react/jsx-runtime";
var MagicTableToolbarV3 = (props) => {
  return /* @__PURE__ */ jsx37(MagicTableToolbarV3Provider, { ...props, children: /* @__PURE__ */ jsxs19(
    Flex10,
    {
      borderBottom: `${GreyGrey304} 1px solid`,
      px: "16px",
      py: "8px",
      width: "100%",
      gap: "8px",
      justifyContent: "space-between",
      alignItems: "start",
      children: [
        /* @__PURE__ */ jsxs19(Flex10, { gap: "8px", flexWrap: "wrap", children: [
          props.additionalToolbarComponentsV3?.start && props.additionalToolbarComponentsV3.start,
          /* @__PURE__ */ jsxs19(Flex10, { gap: "8px", flexWrap: "wrap", children: [
            /* @__PURE__ */ jsx37(ActiveFilters, {}),
            /* @__PURE__ */ jsx37(DropdownAddFilter, {})
          ] })
        ] }),
        /* @__PURE__ */ jsxs19(Flex10, { gap: "8px", alignItems: "center", children: [
          /* @__PURE__ */ jsx37(MagicTableFiltersLoading, {}),
          /* @__PURE__ */ jsx37(
            ActiveFilterControlButtons,
            {
              onSaveFilters: props.onSaveFilters,
              onUpdateSavedFilters: props.onUpdateSavedFilters
            }
          ),
          props.additionalToolbarComponentsV3?.end && props.additionalToolbarComponentsV3.end,
          /* @__PURE__ */ jsx37(
            MagicTableToolbarViewSettings,
            {
              enableColumnReordering: props.enableColumnReordering,
              table: props.table,
              enableCopyResults: props.enableCopyResults
            }
          )
        ] })
      ]
    }
  ) });
};

// src/components/MagicTable/MagicTableBody/MagicTableAddColumnButtonV3.tsx
import {
  Box as Box12,
  Center as Center6,
  IconButton as IconButton2,
  Menu as Menu4,
  MenuButton as MenuButton4,
  MenuItem as MenuItem9,
  MenuList as MenuList5,
  Portal as Portal4
} from "@chakra-ui/react";
import PlusIcon2 from "@heroicons/react/16/solid/PlusIcon";

// src/components/MagicTable/MagicTableBody/useMagicTableAddColumnButton.tsx
import { useMemo as useMemo14, useState as useState11 } from "react";
var useAddColumnButton = (props) => {
  const [showCustomColumnsMenu, setShowCustomColumnsMenu] = useState11(false);
  const tableState = props.getTableState();
  const tableAllFlatColumns = props.getTableAllFlatColumns();
  const invisibleColumns = useMemo14(() => {
    const visibleColumnIds = Object.entries(tableState.columnVisibility).filter(([, value]) => value).filter(([columnId]) => !MAGIC_TABLE_SPECIAL_COLUMNS.includes(columnId)).map(([columnId]) => columnId);
    return tableAllFlatColumns.filter(
      (column) => !visibleColumnIds.includes(column.id) && !MAGIC_TABLE_SPECIAL_COLUMNS.includes(column.id) && !column.id.startsWith(CUSTOM_EVENT_COLUMN_PREFIX)
    );
  }, [tableAllFlatColumns, tableState.columnVisibility]);
  const menuItems = useMemo14(() => {
    const invisibleColumnMenuItems = invisibleColumns.reduce(
      (acc, column) => [
        ...acc,
        {
          id: column.id,
          label: column.columnDef.header?.toString() || "",
          onClick: () => {
            column.toggleVisibility();
          },
          closeOnSelect: true
        }
      ],
      []
    );
    const customColumnsMenuItem = props.customColumns.isEnabled && props.customColumns.available.length !== props.customColumns.selected.length ? [
      {
        id: "custom-columns",
        label: "Event property",
        onClick: () => {
          setShowCustomColumnsMenu(true);
        },
        closeOnSelect: false
      }
    ] : [];
    return [...invisibleColumnMenuItems, ...customColumnsMenuItem];
  }, [
    invisibleColumns,
    props.customColumns.available.length,
    props.customColumns.isEnabled,
    props.customColumns.selected.length
  ]);
  const isButtonDisabled = useMemo14(() => {
    const canAddCustomColumns = props.customColumns.isEnabled && props.customColumns.available.length !== props.customColumns.selected.length;
    return invisibleColumns.length === 0 && !canAddCustomColumns;
  }, [
    invisibleColumns.length,
    props.customColumns.available.length,
    props.customColumns.isEnabled,
    props.customColumns.selected.length
  ]);
  const customColumnMenuItems = useMemo14(() => {
    return props.customColumns.available.filter((column) => !props.customColumns.selected.includes(column)).map((column) => {
      return {
        id: column,
        label: column,
        onClick: () => {
          props.customColumns.setSelected([
            ...props.customColumns.selected,
            column
          ]);
        },
        closeOnSelect: true
      };
    });
  }, [props.customColumns]);
  const { results: searchResults, input: searchInput } = useSimpleSearch({
    items: customColumnMenuItems,
    searchOn: "label"
  });
  return {
    menuItems,
    button: {
      disabled: isButtonDisabled
    },
    customColumns: {
      showMenu: showCustomColumnsMenu,
      menuItems: searchResults,
      searchInput
    },
    ui: {
      reset: () => {
        setShowCustomColumnsMenu(false);
      }
    }
  };
};

// src/components/MagicTable/MagicTableBody/MagicTableAddColumnButtonV3.tsx
import { SimpleSearchMenuInput as SimpleSearchMenuInput5 } from "@sequencehq/core-components";
import { jsx as jsx38, jsxs as jsxs20 } from "react/jsx-runtime";
var MagicTableAddColumnButtonV3 = ({
  customColumns: customColumnsProp,
  getTableState,
  getTableAllFlatColumns
}) => {
  const { menuItems, button, customColumns, ui } = useAddColumnButton({
    getTableState,
    getTableAllFlatColumns,
    customColumns: customColumnsProp
  });
  const menuListDefault = /* @__PURE__ */ jsx38(MenuList5, { children: menuItems.map(({ id, label, onClick, closeOnSelect }) => /* @__PURE__ */ jsx38(MenuItem9, { onClick, closeOnSelect, children: label }, id)) });
  const menuListCustomColumns = /* @__PURE__ */ jsxs20(MenuList5, { maxHeight: "500px", overflowY: "scroll", paddingTop: "0px !important", children: [
    /* @__PURE__ */ jsx38(
      SimpleSearchMenuInput5,
      {
        value: customColumns.searchInput.value,
        onChange: customColumns.searchInput.onChange,
        placeholder: "Event property",
        showDivider: customColumns.menuItems.length > 0
      }
    ),
    customColumns.menuItems.length > 0 && /* @__PURE__ */ jsx38(Box12, { height: "4px" }),
    customColumns.menuItems.map(({ id, label, onClick, closeOnSelect }) => /* @__PURE__ */ jsx38(MenuItem9, { onClick, closeOnSelect, children: label }, id))
  ] });
  return /* @__PURE__ */ jsx38(Center6, { height: "100%", children: /* @__PURE__ */ jsxs20(
    Menu4,
    {
      variant: "component-library",
      closeOnSelect: false,
      offset: [0, 4],
      autoSelect: false,
      onClose: () => {
        setTimeout(() => {
          ui.reset();
        }, 150);
      },
      isLazy: true,
      children: [
        /* @__PURE__ */ jsx38(
          MenuButton4,
          {
            as: IconButton2,
            variant: "component-library-secondary",
            icon: /* @__PURE__ */ jsx38(PlusIcon2, { color: "inherit", width: "16px", height: "16px" }),
            minWidth: "initial",
            width: "24px",
            height: "24px",
            padding: "4px",
            borderRadius: "6px",
            isDisabled: button.disabled
          }
        ),
        /* @__PURE__ */ jsx38(Portal4, { children: customColumns.showMenu ? menuListCustomColumns : menuListDefault })
      ]
    }
  ) });
};

// src/components/MagicTable/MagicTableBody/MagicTableBody.tsx
import { Box as Box19, Flex as Flex15 } from "@chakra-ui/react";
import {
  createElement,
  useEffect as useEffect10,
  useRef as useRef5,
  useState as useState13
} from "react";

// src/components/MagicTable/MagicTableBody/MagicTableHeader/MagicTableHeader.tsx
import {
  DndContext as DndContext2,
  closestCenter as closestCenter2,
  useSensor as useSensor2,
  useSensors as useSensors2
} from "@dnd-kit/core";
import {
  SortableContext as SortableContext2,
  horizontalListSortingStrategy
} from "@dnd-kit/sortable";
import { useState as useState12, useEffect as useEffect9, Fragment as Fragment12 } from "react";
import { Flex as Flex12 } from "@chakra-ui/react";
import { GreyGrey30 as GreyGrey306 } from "@sequencehq/design-tokens";

// src/components/MagicTable/utils/SmartPointerSensor.ts
import { PointerSensor as PointerSensor2 } from "@dnd-kit/core";
var SmartPointerSensor = class extends PointerSensor2 {
};
__publicField(SmartPointerSensor, "activators", [
  {
    eventName: "onPointerDown",
    handler: ({ nativeEvent: event }) => {
      return shouldHandleDndEvent(event.target);
    }
  }
]);

// src/components/MagicTable/MagicTableBody/MagicTableHeader/MagicTableHeaderCell.tsx
import { useDisclosure as useDisclosure3 } from "@chakra-ui/react";

// src/components/MagicTable/MagicTableBody/MagicTableHeader/MagicTableHeaderCellContent.tsx
import { Box as Box14, Text as Text15, PopoverAnchor } from "@chakra-ui/react";
import { useSortable as useSortable2 } from "@dnd-kit/sortable";
import { CSS as CSS2 } from "@dnd-kit/utilities";
import {
  GreyGrey20 as GreyGrey202,
  GreyGrey30 as GreyGrey305,
  GreyGrey60 as GreyGrey605,
  Lato12Bold
} from "@sequencehq/design-tokens";
import { flexRender } from "@tanstack/react-table";

// src/components/MagicTable/MagicTableBody/MagicTableHeader/MagicTableColumnResizeHandle.tsx
import { Box as Box13 } from "@chakra-ui/react";
import { IndigoIndigo50 as IndigoIndigo504 } from "@sequencehq/design-tokens";
import { jsx as jsx39 } from "react/jsx-runtime";
var MagicTableColumnResizeHandle = ({
  header,
  isSpecialColumn,
  isSorting,
  setIsColumnsResizing
}) => {
  if (isSpecialColumn || isSorting) {
    return null;
  }
  const activeAreaWidthPx = 16;
  const resizeHandler = header.getResizeHandler();
  return /* @__PURE__ */ jsx39(
    Box13,
    {
      "data-no-dnd": "true",
      userSelect: "none",
      position: "absolute",
      top: "0",
      height: "100%",
      width: `${activeAreaWidthPx}px`,
      right: `-${activeAreaWidthPx / 2}px`,
      cursor: "col-resize",
      zIndex: "2",
      opacity: header.column.getIsResizing() ? "1" : "0",
      _hover: { opacity: "1" },
      onMouseDown: (e) => {
        resizeHandler(e);
        setIsColumnsResizing(true);
      },
      onMouseUp: () => {
        setIsColumnsResizing(false);
      },
      children: /* @__PURE__ */ jsx39(
        Box13,
        {
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          top: "0",
          height: "100%",
          width: "2px",
          background: IndigoIndigo504
        }
      )
    }
  );
};

// src/components/MagicTable/MagicTableBody/MagicTableHeader/MagicTableHeaderCellContent.tsx
import { jsx as jsx40, jsxs as jsxs21 } from "react/jsx-runtime";
var MagicTableHeaderCellContent = ({
  header,
  column,
  isSpecialColumn,
  isSorting,
  activeId,
  isColumnsResizing,
  setIsColumnsResizing,
  onMenuOpen,
  enableColumnReordering,
  showPaddingLeft
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable2({
    id: header.id,
    disabled: !enableColumnReordering || isSpecialColumn
  });
  const isAddColumn = header.id === COLUMN_ID_ADD_COLUMN;
  const textAlign = column?.columnDef.meta?.textAlign;
  const propsTh = !isSpecialColumn ? {
    ref: setNodeRef,
    style: {
      transform: CSS2.Translate.toString(transform),
      transition,
      width: header.getSize()
    },
    ...attributes,
    ...listeners
  } : {
    style: {
      width: header.getSize()
    }
  };
  return /* @__PURE__ */ jsxs21(
    Box14,
    {
      padding: isSpecialColumn ? "0px" : "12px",
      paddingLeft: showPaddingLeft ? "24px" : void 0,
      position: "relative",
      borderLeft: isAddColumn ? "1px" : "0px",
      borderColor: GreyGrey305,
      ...propsTh,
      onMouseUp: () => {
        if (header.column.getIsResizing() || isSorting || isSpecialColumn) {
          return;
        }
        onMenuOpen();
      },
      zIndex: activeId === header.id ? "1" : void 0,
      children: [
        header.isPlaceholder ? null : isSpecialColumn ? flexRender(header.column.columnDef.header, header.getContext()) : /* @__PURE__ */ jsx40(PopoverAnchor, { children: /* @__PURE__ */ jsxs21(Box14, { children: [
          /* @__PURE__ */ jsx40(
            Text15,
            {
              color: GreyGrey605,
              textTransform: "uppercase",
              overflow: "hidden",
              display: "-webkit-box",
              sx: {
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
                lineBreak: "anywhere"
              },
              textAlign,
              position: "relative",
              zIndex: "1",
              pointerEvents: "none",
              ...Lato12Bold,
              children: flexRender(header.column.columnDef.header, header.getContext())
            }
          ),
          !isColumnsResizing && /* @__PURE__ */ jsx40(
            Box14,
            {
              width: "100%",
              height: "100%",
              position: "absolute",
              top: "0",
              right: "0",
              _hover: { background: GreyGrey202 }
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx40(
          MagicTableColumnResizeHandle,
          {
            header,
            isSpecialColumn,
            isSorting,
            setIsColumnsResizing
          }
        )
      ]
    }
  );
};

// src/components/MagicTable/MagicTableBody/MagicTableHeader/MagicTableHeaderMenu.tsx
import {
  Text as Text16,
  Popover as Popover2,
  PopoverContent as PopoverContent2,
  List as List3,
  ListItem as ListItem3,
  Flex as Flex11
} from "@chakra-ui/react";
import {
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  XCircleIcon
} from "@heroicons/react/20/solid";
import EyeSlashIcon from "@heroicons/react/24/outline/EyeSlashIcon";
import {
  GreyGrey10,
  GreyGrey80 as GreyGrey804,
  Lato14Regular
} from "@sequencehq/design-tokens";
import { internalBorder } from "@sequencehq/core-theme";
import { Fragment as Fragment11, jsx as jsx41, jsxs as jsxs22 } from "react/jsx-runtime";
var MagicTableHeaderMenu = ({
  table,
  header,
  column,
  columnOrder,
  setColumnOrder,
  isMenuOpen,
  onMenuOpen,
  onMenuClose,
  children,
  setEventPropertyColumns,
  sortBy,
  onChangeSortBy,
  enableColumnReordering,
  onGroupBy,
  isGrouped,
  isGroupable
}) => {
  const { allColumnIds, allVisibleColumnIds, allInvisibleColumnIds } = parseTableState(table);
  const isSingleColumnVisible = allColumnIds.length - allInvisibleColumnIds.length === 1;
  const columnOrderWithoutSpecial = columnOrder.filter(
    (c) => !MAGIC_TABLE_SPECIAL_COLUMNS.includes(c)
  );
  const visibleColumnOrder = columnOrderWithoutSpecial.filter(
    (id) => allVisibleColumnIds.includes(id)
  );
  const enableMoveLeft = visibleColumnOrder.indexOf(header.id) !== 0;
  const enableMoveRight = visibleColumnOrder.indexOf(header.id) !== visibleColumnOrder.length - 1 && !isSingleColumnVisible;
  const enableSorting = Boolean(column?.columnDef.enableSorting);
  const handleSort = (sortName, sortDirection2) => {
    if (!sortName) {
      return;
    }
    onChangeSortBy(
      sortDirection2 === "NONE" ? null : `${sortName}_${sortDirection2.toLowerCase()}`
    );
  };
  const sortDirection = getSortOrder(sortBy, header.id);
  const listItemProps = (disabled) => ({
    padding: "8px",
    display: "flex",
    alignItems: "center",
    borderRadius: "6px",
    _hover: { background: GreyGrey10 },
    transition: "background 250ms",
    cursor: "pointer",
    gap: "8px",
    style: disabled ? { opacity: 0.45, pointerEvents: "none" } : {}
  });
  const showSortingAndReorderingSection = enableColumnReordering || enableSorting || isGroupable;
  return /* @__PURE__ */ jsxs22(
    Popover2,
    {
      isOpen: isMenuOpen,
      onOpen: onMenuOpen,
      onClose: onMenuClose,
      placement: "bottom-start",
      children: [
        children,
        /* @__PURE__ */ jsxs22(
          PopoverContent2,
          {
            width: "200px",
            boxShadow: "0px 16px 24px 0px rgba(20, 23, 28, 0.08)",
            borderRadius: "8px",
            zIndex: "3",
            children: [
              showSortingAndReorderingSection && /* @__PURE__ */ jsxs22(List3, { p: "4px 4px 4px 4px", children: [
                isGroupable ? /* @__PURE__ */ jsx41(
                  ListItem3,
                  {
                    ...listItemProps(),
                    onClick: () => {
                      onGroupBy?.();
                      onMenuClose();
                    },
                    children: /* @__PURE__ */ jsx41(Text16, { color: GreyGrey804, ...Lato14Regular, children: isGrouped ? "Ungroup" : "Group by column" })
                  }
                ) : null,
                enableSorting && /* @__PURE__ */ jsxs22(Fragment11, { children: [
                  sortDirection !== "NONE" && /* @__PURE__ */ jsxs22(
                    ListItem3,
                    {
                      ...listItemProps(),
                      onClick: () => {
                        handleSort(header.id, "NONE");
                        onMenuClose();
                      },
                      children: [
                        /* @__PURE__ */ jsx41(
                          XCircleIcon,
                          {
                            width: "20px",
                            height: "20px",
                            color: GreyGrey804
                          }
                        ),
                        /* @__PURE__ */ jsx41(Text16, { color: GreyGrey804, ...Lato14Regular, children: "Reset sort" })
                      ]
                    }
                  ),
                  sortDirection !== "ASC" && /* @__PURE__ */ jsxs22(
                    ListItem3,
                    {
                      ...listItemProps(),
                      onClick: () => {
                        handleSort(header.id, "ASC");
                        onMenuClose();
                      },
                      children: [
                        /* @__PURE__ */ jsx41(
                          ArrowUpIcon,
                          {
                            width: "20px",
                            height: "20px",
                            color: GreyGrey804
                          }
                        ),
                        /* @__PURE__ */ jsx41(Text16, { color: GreyGrey804, ...Lato14Regular, children: "Sort ascending" })
                      ]
                    }
                  ),
                  sortDirection !== "DESC" && /* @__PURE__ */ jsxs22(
                    ListItem3,
                    {
                      ...listItemProps(),
                      onClick: () => {
                        handleSort(header.id, "DESC");
                        onMenuClose();
                      },
                      children: [
                        /* @__PURE__ */ jsx41(
                          ArrowDownIcon,
                          {
                            width: "20px",
                            height: "20px",
                            color: GreyGrey804
                          }
                        ),
                        /* @__PURE__ */ jsx41(Text16, { color: GreyGrey804, ...Lato14Regular, children: "Sort descending" })
                      ]
                    }
                  )
                ] }),
                enableColumnReordering && /* @__PURE__ */ jsxs22(Fragment11, { children: [
                  /* @__PURE__ */ jsxs22(
                    ListItem3,
                    {
                      ...listItemProps(!enableMoveLeft),
                      onClick: () => {
                        if (!enableMoveLeft) {
                          return;
                        }
                        setColumnOrder(
                          reorderTableMagicColumn(
                            header.id,
                            columnOrderWithoutSpecial[columnOrderWithoutSpecial.indexOf(header.id) - 1],
                            columnOrder
                          )
                        );
                        onMenuClose();
                      },
                      children: [
                        /* @__PURE__ */ jsx41(
                          ArrowLeftIcon,
                          {
                            width: "20px",
                            height: "20px",
                            color: GreyGrey804
                          }
                        ),
                        /* @__PURE__ */ jsx41(Text16, { color: GreyGrey804, ...Lato14Regular, children: "Move left" })
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxs22(
                    ListItem3,
                    {
                      ...listItemProps(!enableMoveRight),
                      onClick: () => {
                        if (!enableMoveRight) {
                          return;
                        }
                        setColumnOrder(
                          reorderTableMagicColumn(
                            header.id,
                            columnOrderWithoutSpecial[columnOrderWithoutSpecial.indexOf(header.id) + 1],
                            columnOrder
                          )
                        );
                        onMenuClose();
                      },
                      children: [
                        /* @__PURE__ */ jsx41(
                          ArrowRightIcon,
                          {
                            width: "20px",
                            height: "20px",
                            color: GreyGrey804
                          }
                        ),
                        /* @__PURE__ */ jsx41(Text16, { color: GreyGrey804, ...Lato14Regular, children: "Move right" })
                      ]
                    }
                  )
                ] })
              ] }),
              showSortingAndReorderingSection ? /* @__PURE__ */ jsx41(Flex11, { borderBottom: internalBorder, width: "100%" }) : null,
              /* @__PURE__ */ jsx41(List3, { p: "4px 4px 4px 4px", children: /* @__PURE__ */ jsxs22(
                ListItem3,
                {
                  ...listItemProps(isSingleColumnVisible),
                  onClick: () => {
                    if (isSingleColumnVisible) {
                      return;
                    }
                    if (header.id.startsWith(CUSTOM_EVENT_COLUMN_PREFIX)) {
                      setEventPropertyColumns(
                        (prev) => prev.filter(
                          (p) => p !== header.id.replace(CUSTOM_EVENT_COLUMN_PREFIX, "")
                        )
                      );
                    } else {
                      column?.toggleVisibility();
                      onMenuClose();
                    }
                  },
                  children: [
                    /* @__PURE__ */ jsx41(EyeSlashIcon, { width: "20px", height: "20px", color: GreyGrey804 }),
                    /* @__PURE__ */ jsx41(Text16, { color: GreyGrey804, ...Lato14Regular, children: "Hide column" })
                  ]
                }
              ) })
            ]
          }
        )
      ]
    }
  );
};

// src/components/MagicTable/MagicTableBody/MagicTableHeader/MagicTableHeaderCell.tsx
import { jsx as jsx42 } from "react/jsx-runtime";
var MagicTableHeaderCell = ({
  header,
  isSorting,
  table,
  columnOrder,
  setColumnOrder,
  isColumnsResizing,
  setIsColumnsResizing,
  activeId,
  setEventPropertyColumns,
  sortBy,
  onChangeSortBy,
  enableColumnReordering,
  onGroupBy,
  isGrouped,
  isGroupable,
  showPaddingLeft
}) => {
  const column = table.getColumn(header.id);
  const isSpecialColumn = MAGIC_TABLE_SPECIAL_COLUMNS.includes(header.id);
  const { isOpen, onOpen, onClose } = useDisclosure3();
  const content = /* @__PURE__ */ jsx42(
    MagicTableHeaderCellContent,
    {
      header,
      column,
      isSpecialColumn,
      isSorting,
      activeId,
      isColumnsResizing,
      setIsColumnsResizing,
      onMenuOpen: onOpen,
      enableColumnReordering,
      showPaddingLeft
    }
  );
  return isSpecialColumn ? content : /* @__PURE__ */ jsx42(
    MagicTableHeaderMenu,
    {
      table,
      header,
      column,
      columnOrder,
      setColumnOrder,
      isMenuOpen: isOpen,
      onMenuOpen: onOpen,
      onMenuClose: onClose,
      setEventPropertyColumns,
      sortBy,
      onChangeSortBy,
      enableColumnReordering,
      onGroupBy,
      isGrouped,
      isGroupable,
      children: content
    }
  );
};

// src/components/MagicTable/MagicTableBody/MagicTableHeader/MagicTableHeader.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
var MagicTableHeader = ({
  table,
  headerGroups,
  setIsSorting,
  isSorting,
  columnOrder,
  setColumnOrder,
  showCheckboxes = false,
  setEventPropertyColumns,
  showExpandButtons = false,
  sortBy,
  onChangeSortBy,
  onGroupBy,
  groupBy,
  groupableColumns,
  enableColumnReordering
}) => {
  const [activeId, setActiveId] = useState12(null);
  const sensors = useSensors2(
    useSensor2(SmartPointerSensor, {
      activationConstraint: {
        delay: DND_DEFAULT_ACTIVATION_DELAY,
        tolerance: DND_DEFAULT_ACTIVATION_TOLERANCE
      }
    })
  );
  const handleDragStart = (event) => {
    if (!enableColumnReordering)
      return;
    setActiveId(event.active.id);
    setIsSorting(true);
  };
  const handleDragEnd = (event) => {
    if (!enableColumnReordering)
      return;
    const { active, over } = event;
    if (!over) {
      setActiveId(null);
      setIsSorting(false);
      return;
    }
    setColumnOrder(reorderTableMagicColumn(active.id, over.id, columnOrder));
    setActiveId(null);
    setIsSorting(false);
  };
  const [delayedIsSorting, setDelayedIsSorting] = useState12(false);
  useEffect9(() => {
    setTimeout(() => {
      setDelayedIsSorting(isSorting);
    }, 1);
  }, [isSorting]);
  const [isColumnsResizing, setIsColumnsResizing] = useState12(false);
  const showPaddingLeft = !showCheckboxes && !showExpandButtons;
  const DndContextProvider = enableColumnReordering ? DndContext2 : Fragment12;
  return /* @__PURE__ */ jsx43(
    Flex12,
    {
      role: "rowheader",
      position: "sticky",
      top: "0px",
      background: "#FFF",
      borderBottom: "1px",
      borderColor: GreyGrey306,
      zIndex: "2",
      children: headerGroups.map((headerGroup) => {
        const headers = headerGroup.headers;
        return /* @__PURE__ */ jsx43(Flex12, { children: /* @__PURE__ */ jsx43(
          DndContextProvider,
          {
            sensors,
            collisionDetection: closestCenter2,
            onDragStart: handleDragStart,
            onDragEnd: handleDragEnd,
            children: /* @__PURE__ */ jsx43(
              SortableContext2,
              {
                items: headers,
                strategy: horizontalListSortingStrategy,
                children: headers.map((header, index) => /* @__PURE__ */ jsx43(
                  MagicTableHeaderCell,
                  {
                    header,
                    isSorting: delayedIsSorting,
                    table,
                    columnOrder,
                    setColumnOrder,
                    isColumnsResizing,
                    setIsColumnsResizing,
                    activeId,
                    setEventPropertyColumns,
                    sortBy,
                    onChangeSortBy,
                    enableColumnReordering,
                    onGroupBy: () => {
                      if (groupBy === header.id) {
                        return onGroupBy?.(void 0);
                      }
                      return onGroupBy?.(header.id);
                    },
                    isGroupable: groupableColumns?.includes(header.id),
                    isGrouped: groupBy === header.id,
                    showPaddingLeft: showPaddingLeft && index === 0
                  },
                  header.id
                ))
              }
            )
          }
        ) }, headerGroup.id);
      })
    }
  );
};

// src/components/MagicTable/MagicTableBody/MagicTableRow/MagicTableRow.tsx
import { Box as Box17, Flex as Flex14 } from "@chakra-ui/react";
import { GreyGrey10 as GreyGrey102, GreyGrey30 as GreyGrey309 } from "@sequencehq/design-tokens";

// src/components/MagicTable/MagicTableBody/MagicTableRow/MagicTableCellRenderer.tsx
import { Box as Box15, Center as Center7, Link as ChakraLink, Flex as Flex13 } from "@chakra-ui/react";
import { GreyGrey30 as GreyGrey307, GreyGrey60 as GreyGrey606 } from "@sequencehq/design-tokens";
import {
  flexRender as flexRender2
} from "@tanstack/react-table";
import { memo as memo3 } from "react";
import { Link as ReactRouterDomLink } from "react-router-dom";
import { dequal as dequal2 } from "dequal";
import { ChevronDownIcon as ChevronDownIcon3, ChevronRightIcon } from "@heroicons/react/20/solid";
import { Fragment as Fragment13, jsx as jsx44, jsxs as jsxs23 } from "react/jsx-runtime";
var shouldRenderCell = (cellGroupInfo) => {
  if (!cellGroupInfo) {
    return true;
  }
  return cellGroupInfo.isCollapsed ? cellGroupInfo.togglableColumn : true;
};
var MagicTableCellRendererComponent = ({
  cell,
  width,
  isOverflowing,
  rowPath,
  cellGroupInfo,
  showPaddingLeft
}) => {
  const { column, row } = cell;
  const { columnDef, id } = column;
  const isAddColumn = id === COLUMN_ID_ADD_COLUMN;
  const hasLink = "hasLink" in columnDef && columnDef.hasLink;
  const renderAsLink = rowPath && !MAGIC_TABLE_SPECIAL_COLUMNS.includes(id) && !hasLink;
  const hasGrouping = cellGroupInfo !== void 0;
  const isTogglableColumn = cellGroupInfo?.togglableColumn;
  const toggleCollapsed = cellGroupInfo?.toggleCollapsed;
  const isCollapsed = cellGroupInfo?.isCollapsed;
  const shouldRenderContent = hasGrouping ? cellGroupInfo?.isFirstInGroup && shouldRenderCell(cellGroupInfo) : true;
  const shouldShowTopBorder = hasGrouping && row.index !== 0 && cellGroupInfo.isFirstInGroup;
  const cellContentWithExpander = /* @__PURE__ */ jsxs23(
    Flex13,
    {
      height: "100%",
      alignItems: "center",
      onClick: (e) => {
        if (toggleCollapsed) {
          e.stopPropagation();
          toggleCollapsed();
        }
      },
      children: [
        /* @__PURE__ */ jsx44(Expander, { isCollapsed: isCollapsed ?? false }),
        flexRender2(columnDef.cell, cell.getContext())
      ]
    }
  );
  const content = /* @__PURE__ */ jsxs23(Fragment13, { children: [
    isAddColumn && /* @__PURE__ */ jsx44(Box15, { width: "1px", height: "100%", background: GreyGrey307 }),
    /* @__PURE__ */ jsxs23(
      Box15,
      {
        style: isAddColumn ? {} : { width },
        position: isAddColumn ? "sticky" : void 0,
        right: isAddColumn && isOverflowing ? "20px" : isAddColumn && !isOverflowing ? "0px" : void 0,
        transition: isAddColumn ? "right 150ms" : void 0,
        borderTop: shouldShowTopBorder ? `1px solid ${GreyGrey307}` : void 0,
        flexGrow: isAddColumn ? 1 : void 0,
        paddingLeft: showPaddingLeft ? "12px" : "0px",
        children: [
          shouldRenderContent && !isTogglableColumn ? flexRender2(columnDef.cell, cell.getContext()) : null,
          isTogglableColumn && cellContentWithExpander
        ]
      }
    )
  ] });
  return renderAsLink ? /* @__PURE__ */ jsx44(
    ChakraLink,
    {
      as: ReactRouterDomLink,
      to: rowPath,
      _hover: { textDecoration: "none" },
      children: content
    }
  ) : content;
};
var Expander = ({ isCollapsed }) => /* @__PURE__ */ jsx44(Center7, { zIndex: 1, as: "button", height: "100%", width: "fit-content", children: isCollapsed ? /* @__PURE__ */ jsx44(ChevronRightIcon, { width: "20px", fill: GreyGrey606 }) : /* @__PURE__ */ jsx44(ChevronDownIcon3, { width: "20px", fill: GreyGrey606 }) });
var MagicTableCellRenderer = memo3(
  MagicTableCellRendererComponent,
  (prev, next) => {
    const isWidthSame = prev.width === next.width;
    const isSelectedSame = prev.isSelected === next.isSelected;
    const isValueSame = dequal2(prev.value, next.value);
    const isColumnOrderSame = dequal2(prev.columnOrder, next.columnOrder);
    const isColumnVisibilitySame = dequal2(
      prev.columnVisibility,
      next.columnVisibility
    );
    const isOverflowingSame = prev.isOverflowing === next.isOverflowing;
    const isExpandedSame = prev.isExpanded === next.isExpanded;
    const isCanExpandSame = prev.canExpand === next.canExpand;
    const isRowPathSame = prev.rowPath === next.rowPath;
    const isCellSame = prev.cell === next.cell;
    const isFirstInGroupSame = prev.cellGroupInfo?.isFirstInGroup === next.cellGroupInfo?.isFirstInGroup;
    const isTogglableColumnSame = prev.cellGroupInfo?.togglableColumn === next.cellGroupInfo?.togglableColumn;
    const isShowPaddingLeftSame = prev.showPaddingLeft === next.showPaddingLeft;
    return isWidthSame && isValueSame && isSelectedSame && isColumnOrderSame && isColumnVisibilitySame && isOverflowingSame && isExpandedSame && isCanExpandSame && isRowPathSame && isCellSame && isFirstInGroupSame && isTogglableColumnSame && isShowPaddingLeftSame;
  }
);

// src/components/MagicTable/MagicTableBody/MagicTableRow/MagicTableCellLoading.tsx
import { Box as Box16 } from "@chakra-ui/react";
import { GreyGrey30 as GreyGrey308 } from "@sequencehq/design-tokens";
import { jsx as jsx45 } from "react/jsx-runtime";
var MagicTableCellLoading = ({
  index,
  showCheckboxes,
  showExpandButtons,
  column,
  visibleColumns
}) => {
  const showLoading = getShowLoading({
    index,
    showCheckboxes,
    showExpandButtons,
    visibleColsLength: visibleColumns.length
  });
  return /* @__PURE__ */ jsx45(
    Box16,
    {
      style: { width: column.getSize() },
      padding: "8px 12px",
      borderLeft: column.id === COLUMN_ID_ADD_COLUMN ? "1px" : "0px",
      borderColor: GreyGrey308,
      children: showLoading && /* @__PURE__ */ jsx45(Loading, {})
    }
  );
};
var getShowLoading = ({
  index,
  showCheckboxes,
  showExpandButtons,
  visibleColsLength
}) => {
  if (index === visibleColsLength - 1) {
    return false;
  }
  if (showExpandButtons && showCheckboxes && [0, 1].includes(index)) {
    return false;
  }
  if (showExpandButtons !== showCheckboxes && index === 0) {
    return false;
  }
  return true;
};

// src/components/MagicTable/MagicTableBody/MagicTableRow/MagicTableRow.tsx
import { useLocation } from "react-router-dom";
import { useMemo as useMemo15, useCallback as useCallback13 } from "react";
import { jsx as jsx46, jsxs as jsxs24 } from "react/jsx-runtime";
var getCellGroupInfo = (rowGroupInfo, columnId) => {
  return rowGroupInfo?.[columnId] ?? {
    togglableColumn: false,
    isFirstInGroup: true,
    isLastInGroup: true,
    isInSameGroupAsNextRow: false
  };
};
var MagicTableRow = ({
  row,
  virtualRow,
  showCheckboxes = false,
  table,
  columnOrder,
  columnVisibility,
  forceRowBorderBottom,
  rowPath,
  onRowClick,
  isOverflowing,
  showExpandButtons = false,
  highlightRowGroup
}) => {
  const { pathname } = useLocation();
  const isRowLoaded = Boolean(row);
  const visibleColumns = table.getVisibleFlatColumns();
  const visibleCells = row ? row.getVisibleCells() : [];
  const isSelected = row ? row.getIsSelected() : false;
  const hasRowClick = row && onRowClick;
  const showPaddingLeft = !showCheckboxes && !showExpandButtons;
  const showExpandedRowShadow = Boolean(row) && isFirstExpandedRowId(row.id);
  const activeRow = row && rowPath?.(row.original, isSubRowId(row.id)) === pathname;
  const showBorder = forceRowBorderBottom || row?.original && !("_groupInfo" in row.original);
  const rowGroupId = useMemo15(() => {
    if (row && highlightRowGroup) {
      const groupId = highlightRowGroup(row.original);
      return groupId !== null ? String(groupId) : void 0;
    }
    return void 0;
  }, [row, highlightRowGroup]);
  const handleRowClick = useCallback13(() => {
    const rowGroupInfos = Object.values(row?.original?._groupInfo ?? {});
    if (rowGroupInfos && rowGroupInfos.length > 0) {
      const isCollapsed = rowGroupInfos.some((groupInfo) => groupInfo.isCollapsed);
      if (isCollapsed && rowGroupInfos[0]?.toggleCollapsed) {
        rowGroupInfos[0].toggleCollapsed();
        return;
      }
    }
    if (row && onRowClick) {
      onRowClick(row.original);
    }
  }, [row, onRowClick]);
  return /* @__PURE__ */ jsxs24(
    Flex14,
    {
      height: `${virtualRow.size}px`,
      padding: "0",
      borderBottom: showBorder ? "1px" : "0px",
      borderColor: GreyGrey309,
      background: isSelected || activeRow ? GreyGrey102 : "#FFF",
      role: "row",
      "data-group": "true",
      "data-row-group-id": rowGroupId,
      _hover: {
        [`~ [data-row-group-id="${rowGroupId}"]`]: {
          background: GreyGrey102
        },
        background: GreyGrey102
      },
      css: {
        [`:has(~ [data-row-group-id="${rowGroupId}"]:hover)`]: {
          background: GreyGrey102
        }
      },
      position: "relative",
      onClick: hasRowClick ? handleRowClick : void 0,
      cursor: hasRowClick ? "pointer" : void 0,
      children: [
        showExpandedRowShadow && /* @__PURE__ */ jsx46(
          Box17,
          {
            width: "100%",
            height: "8px",
            background: "linear-gradient(180deg, rgba(20,23,28,0.03) 0%, rgba(255,255,255,0) 100%)",
            position: "absolute",
            pointerEvents: "none"
          }
        ),
        isRowLoaded ? visibleCells.map((cell, index) => {
          const width = cell.column.getSize();
          const value = cell.getValue();
          const isExpanded = cell.row.getIsExpanded();
          const canExpand = cell.row.getCanExpand();
          const resolvedRowPath = rowPath?.(row.original, isSubRowId(row.id));
          const cellGroupInfo = row.original && "_groupInfo" in row.original ? getCellGroupInfo(row.original._groupInfo, cell.column.id) : void 0;
          return /* @__PURE__ */ jsx46(
            MagicTableCellRenderer,
            {
              cell,
              width,
              value,
              isSelected,
              columnOrder,
              columnVisibility,
              isOverflowing,
              rowPath: resolvedRowPath,
              isExpanded,
              canExpand,
              cellGroupInfo,
              showPaddingLeft: showPaddingLeft && index === 0
            },
            cell.id
          );
        }) : visibleColumns.map((column, index) => /* @__PURE__ */ jsx46(
          MagicTableCellLoading,
          {
            index,
            showCheckboxes,
            showExpandButtons,
            column,
            visibleColumns
          },
          column.id
        ))
      ]
    }
  );
};

// src/components/MagicTable/MagicTableBody/MagicTableOverflowEffect.tsx
import { useMemo as useMemo16 } from "react";
import { Box as Box18 } from "@chakra-ui/react";
import { GreyGrey30 as GreyGrey3010 } from "@sequencehq/design-tokens";
import { jsx as jsx47 } from "react/jsx-runtime";
var MagicTableOverflowEffect = ({
  isOverflowing,
  numRows,
  containerHeight
}) => {
  const height = useMemo16(() => {
    const actualHeight = numRows * VIRTUAL_TABLE_ROW_HEIGHT + HEADER_ROW_HEIGHT - 1;
    return typeof containerHeight === "number" && actualHeight >= containerHeight ? "100%" : actualHeight;
  }, [containerHeight, numRows]);
  if (!isOverflowing) {
    return null;
  }
  return /* @__PURE__ */ jsx47(
    Box18,
    {
      width: "8px",
      height,
      position: "absolute",
      top: "0px",
      right: "0",
      zIndex: "1",
      pointerEvents: "none",
      background: "#fff",
      boxShadow: "0px 0px 16px 0px rgba(20, 23, 28, 0.08)",
      borderLeft: "1px",
      borderLeftColor: GreyGrey3010,
      transform: "translateZ(0)"
    }
  );
};

// src/components/MagicTable/MagicTableBody/MagicTableBody.tsx
import { match as match6 } from "ts-pattern";
import { Fragment as Fragment14, jsx as jsx48, jsxs as jsxs25 } from "react/jsx-runtime";
var MagicTableBody = (props) => {
  const {
    table,
    refContainer,
    rowVirtualizer,
    showCheckboxes = false,
    columnOrder,
    setColumnOrder,
    emptyStateUnfiltered,
    emptyStateFiltered,
    containerWidth,
    containerHeight,
    columnVisibility,
    rowPath,
    onRowClick,
    entityNamePlural,
    setEventPropertyColumns,
    showExpandButtons = false,
    clearFilters,
    totalResultSize,
    sortBy,
    onChangeSortBy,
    groupableColumns,
    enableColumnReordering,
    onGroupBy,
    groupBy,
    highlightRowGroup
  } = props;
  const viewState = match6(props).with(
    { totalResultSize: 0, hasFilters: false, loading: false },
    () => "EMPTY"
  ).with(
    { totalResultSize: 0, hasFilters: true, loading: false },
    () => "FILTERED_EMPTY"
  ).otherwise(() => "TABLE");
  const [isSorting, setIsSorting] = useState13(false);
  const { rows: tableRows } = table.getRowModel();
  const virtualRows = rowVirtualizer.getVirtualItems();
  const paddingTop = virtualRows.length > 0 ? virtualRows?.[0]?.start || 0 : 0;
  const paddingBottom = virtualRows.length > 0 ? rowVirtualizer.getTotalSize() - (virtualRows?.[virtualRows.length - 1]?.end || 0) : 0;
  const [isOverflowing, setIsOverflowing] = useState13(false);
  const refOverflowTrigger = useRef5(null);
  useEffect10(() => {
    if (!refOverflowTrigger.current) {
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        setIsOverflowing(!entry.isIntersecting);
      }
    });
    observer.observe(refOverflowTrigger.current);
    return () => {
      observer.disconnect();
    };
  }, [refOverflowTrigger.current]);
  return /* @__PURE__ */ jsxs25(Box19, { position: "relative", flex: "1", overflow: "hidden", children: [
    /* @__PURE__ */ jsxs25(
      Flex15,
      {
        ref: refContainer,
        direction: "row",
        width: "100%",
        height: "100%",
        overflow: isSorting ? "hidden" : "auto",
        children: [
          /* @__PURE__ */ jsx48(
            Box19,
            {
              role: "table",
              width: typeof containerWidth === "number" && table.getTotalSize() > containerWidth ? table.getTotalSize() + (showCheckboxes ? 0 : 12) + 1 : "100%",
              height: viewState === "TABLE" ? rowVirtualizer.getTotalSize() : "100%",
              children: match6(viewState).with(
                "EMPTY",
                () => emptyStateUnfiltered ? emptyStateUnfiltered(entityNamePlural) : null
              ).with(
                "FILTERED_EMPTY",
                () => emptyStateFiltered ? emptyStateFiltered(entityNamePlural, clearFilters) : null
              ).with("TABLE", () => /* @__PURE__ */ jsxs25(Fragment14, { children: [
                /* @__PURE__ */ jsx48(
                  MagicTableHeader,
                  {
                    table,
                    headerGroups: table.getHeaderGroups(),
                    setIsSorting,
                    isSorting,
                    columnOrder,
                    setColumnOrder,
                    showCheckboxes,
                    setEventPropertyColumns,
                    showExpandButtons,
                    sortBy,
                    onChangeSortBy,
                    enableColumnReordering,
                    groupableColumns,
                    onGroupBy,
                    groupBy
                  }
                ),
                /* @__PURE__ */ jsx48(Box19, { position: "sticky", top: "41px", width: "100%", zIndex: 3, children: props.additionalTableHeaderRow && createElement(props.additionalTableHeaderRow, {
                  visibleTableWidth: containerWidth
                }) }),
                /* @__PURE__ */ jsxs25(Box19, { children: [
                  paddingTop > 0 && /* @__PURE__ */ jsx48(Box19, { height: paddingTop }),
                  virtualRows.map((virtualRow) => {
                    return /* @__PURE__ */ jsx48(
                      MagicTableRow,
                      {
                        row: tableRows[virtualRow.index],
                        virtualRow,
                        showCheckboxes,
                        table,
                        columnOrder,
                        columnVisibility,
                        forceRowBorderBottom: virtualRow.index === tableRows.length - 1,
                        rowPath,
                        onRowClick,
                        isOverflowing,
                        showExpandButtons,
                        highlightRowGroup
                      },
                      virtualRow.key
                    );
                  }),
                  paddingBottom > 0 && /* @__PURE__ */ jsx48(Box19, { height: paddingBottom })
                ] })
              ] })).exhaustive()
            }
          ),
          /* @__PURE__ */ jsx48(
            Box19,
            {
              ref: refOverflowTrigger,
              display: viewState !== "TABLE" ? "none" : void 0,
              visibility: "hidden",
              width: "1px",
              flexShrink: "0",
              height: viewState === "TABLE" ? rowVirtualizer.getTotalSize() : "100%"
            }
          )
        ]
      }
    ),
    totalResultSize && totalResultSize > 0 && /* @__PURE__ */ jsx48(
      MagicTableOverflowEffect,
      {
        isOverflowing,
        numRows: virtualRows.length,
        containerHeight
      }
    )
  ] });
};

// src/components/MagicTable/MagicTableBody/MagicTableRow/MagicTableCheckbox.tsx
import { Flex as Flex16 } from "@chakra-ui/react";
import { Checkbox as Checkbox5 } from "@sequencehq/core-components";
import { jsx as jsx49 } from "react/jsx-runtime";
var MagicTableCheckbox = ({
  checked,
  disabled,
  indeterminate,
  onChange,
  showExpandButtons,
  ["data-testId"]: dataTestId
}) => {
  return /* @__PURE__ */ jsx49(
    Flex16,
    {
      paddingLeft: showExpandButtons ? "12px" : "24px",
      paddingRight: "12px",
      height: "100%",
      width: "fit-content",
      onClick: (e) => e.stopPropagation(),
      alignItems: "center",
      "data-testId": dataTestId,
      children: /* @__PURE__ */ jsx49(
        Checkbox5,
        {
          isChecked: checked,
          disabled,
          onChange,
          isIndeterminate: indeterminate,
          onClick: (e) => e.stopPropagation()
        }
      )
    }
  );
};

// src/components/MagicTable/MagicTableBody/MagicTableRow/MagicTableExpandToggle.tsx
import { Center as Center8 } from "@chakra-ui/react";
import { ChevronDownIcon as ChevronDownIcon4, ChevronUpIcon as ChevronUpIcon2 } from "@heroicons/react/20/solid";
import { GreyGrey60 as GreyGrey607 } from "@sequencehq/design-tokens";
import { jsx as jsx50 } from "react/jsx-runtime";
var MagicTableExpandToggle = ({
  row
}) => {
  if (!row.getCanExpand()) {
    return null;
  }
  const isExpanded = row.getIsExpanded();
  return /* @__PURE__ */ jsx50(
    Center8,
    {
      as: "button",
      paddingLeft: "24px",
      paddingRight: "12px",
      height: "100%",
      width: "fit-content",
      onClick: (e) => {
        e.stopPropagation();
        row.toggleExpanded();
      },
      children: isExpanded ? /* @__PURE__ */ jsx50(ChevronUpIcon2, { width: "20px", fill: GreyGrey607 }) : /* @__PURE__ */ jsx50(ChevronDownIcon4, { width: "20px", fill: GreyGrey607 })
    }
  );
};

// src/components/MagicTable/MagicTableBody/MagicTableRow/MagicTableRowActionCell.tsx
import { Center as Center9 } from "@chakra-ui/react";
import { useState as useState14 } from "react";
import { jsx as jsx51 } from "react/jsx-runtime";
var MagicTableRowActionCell = ({
  row,
  kebabMenu
}) => {
  const [showButton, setShowButton] = useState14(false);
  return /* @__PURE__ */ jsx51(
    Center9,
    {
      height: "100%",
      opacity: showButton ? "1" : "0",
      _groupHover: { opacity: "1" },
      children: kebabMenu(row.original, {
        onOpen: () => setShowButton(true),
        onClose: () => setShowButton(false),
        stopPropogation: true,
        useMagicTableStyle: true
      })
    }
  );
};

// src/components/MagicTable/MagicTableStatusBar/MagicTableStatusBarV3.tsx
import { Flex as Flex17, Text as Text17 } from "@chakra-ui/react";
import { GreyGrey70 as GreyGrey702, Lato13Regular as Lato13Regular7 } from "@sequencehq/design-tokens";
import { useMemo as useMemo17 } from "react";
import { Fragment as Fragment15, jsx as jsx52, jsxs as jsxs26 } from "react/jsx-runtime";
var MagicTableStatusBarV3 = ({
  totalResultSize,
  bulkActions,
  rows,
  rowSelection,
  setRowSelection,
  additionalComponents
}) => {
  const selectedRows = useMemo17(() => {
    const rowSelectionIndexes = Object.keys(rowSelection).map(Number);
    return rowSelectionIndexes.map((index) => rows[index]).filter((row) => Boolean(row));
  }, [rowSelection, rows]);
  if (rows.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxs26(
    Flex17,
    {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      position: "relative",
      padding: "10px 16px",
      children: [
        typeof totalResultSize !== "undefined" ? /* @__PURE__ */ jsxs26(Fragment15, { children: [
          /* @__PURE__ */ jsxs26(Text17, { ...Lato13Regular7, minWidth: "100px", color: GreyGrey702, children: [
            rows.length,
            " displayed (",
            totalResultSize,
            " total)"
          ] }),
          /* @__PURE__ */ jsx52(Flex17, { flexGrow: "1" }),
          /* @__PURE__ */ jsx52(Text17, { ...Lato13Regular7, color: GreyGrey702, children: additionalComponents })
        ] }) : /* @__PURE__ */ jsx52(Loading, { height: "16px", width: "100px" }),
        bulkActions && bulkActions(selectedRows, () => setRowSelection({}))
      ]
    }
  );
};

// src/components/MagicTable/hooks/useCustomEventPropertyColumns.tsx
import { useEffect as useEffect11, useRef as useRef6, useState as useState15 } from "react";
var useCustomEventPropertyColumns = ({
  setColumnOrder,
  setColumnSizing,
  setColumnVisibility
}) => {
  const [eventPropertyColumns, setEventPropertyColumns] = useState15([]);
  const refUpdateEventPropertyColumns = useRef6(0);
  const prevEventPropertyColumns = useRef6([]);
  const isEventPropertyColumnsReady = useRef6(false);
  useEffect11(() => {
    if (!isEventPropertyColumnsReady.current) {
      prevEventPropertyColumns.current = eventPropertyColumns;
      isEventPropertyColumnsReady.current = true;
      return;
    }
    const addedCustomColumn = eventPropertyColumns.find(
      (item) => !prevEventPropertyColumns.current.includes(item)
    );
    const removedCustomColumn = prevEventPropertyColumns.current.find(
      (item) => !eventPropertyColumns.includes(item)
    );
    if (addedCustomColumn) {
      setColumnOrder((prev) => [
        ...prev.filter(
          (p) => p !== COLUMN_ID_ADD_COLUMN && p !== `${CUSTOM_EVENT_COLUMN_PREFIX}${addedCustomColumn}`
        ),
        `${CUSTOM_EVENT_COLUMN_PREFIX}${addedCustomColumn}`,
        COLUMN_ID_ADD_COLUMN
      ]);
    }
    if (removedCustomColumn) {
      setColumnSizing((prev) => {
        const next = { ...prev };
        delete next[`${CUSTOM_EVENT_COLUMN_PREFIX}${removedCustomColumn}`];
        return next;
      });
      setColumnOrder(
        (prev) => prev.filter(
          (id) => id !== `${CUSTOM_EVENT_COLUMN_PREFIX}${removedCustomColumn}`
        )
      );
      setColumnVisibility((prev) => {
        const next = { ...prev };
        delete next[`${CUSTOM_EVENT_COLUMN_PREFIX}${removedCustomColumn}`];
        return next;
      });
    }
    if (addedCustomColumn || removedCustomColumn) {
      prevEventPropertyColumns.current = eventPropertyColumns;
      refUpdateEventPropertyColumns.current = refUpdateEventPropertyColumns.current + 1;
    }
  }, [eventPropertyColumns]);
  return {
    eventPropertyColumns,
    setEventPropertyColumns,
    refUpdateEventPropertyColumns
  };
};

// src/components/MagicTable/hooks/useDimensions.tsx
import { useEffect as useEffect12, useState as useState16 } from "react";
var useDimensions = ({
  refContainer,
  initialWidth,
  initialHeight
}) => {
  const [width, setWidth] = useState16(initialWidth);
  const [height, setHeight] = useState16(initialHeight);
  useEffect12(() => {
    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        setWidth(entry.contentRect.width);
        setHeight(entry.contentRect.height);
      });
    });
    if (!refContainer.current) {
      return;
    }
    observer.observe(refContainer.current);
    return () => {
      observer.disconnect();
    };
  }, [refContainer.current]);
  return { width, height };
};

// src/components/MagicTable/guards.ts
var isColumnOrderState = (arr) => {
  return Array.isArray(arr) && arr.every((a) => typeof a === "string");
};
var isColumnSizingState = (obj) => {
  return typeof obj === "object" && obj !== null && !Array.isArray(obj) && // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  Object.keys(obj).every((k) => typeof k === "string") && // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  Object.values(obj).every((v) => typeof v === "number");
};
var isColumnVisibilityState = (obj) => {
  return typeof obj === "object" && obj !== null && !Array.isArray(obj) && // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  Object.keys(obj).every((k) => typeof k === "string") && // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  Object.values(obj).every((v) => typeof v === "boolean");
};
var isMagicTableSavedState = (obj) => {
  return "columnOrder" in obj && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument
  isColumnOrderState(obj["columnOrder"]) && "columnVisibility" in obj && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  isColumnVisibilityState(obj["columnVisibility"]) && "columnSizing" in obj && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  isColumnSizingState(obj["columnSizing"]) && "eventPropertyColumns" in obj;
};

// src/components/MagicTable/hooks/useMagicTableSavedState.tsx
import {
  useCallback as useCallback14,
  useEffect as useEffect13,
  useMemo as useMemo18,
  useRef as useRef7
} from "react";
import debounce from "lodash/debounce";
var scrubSavedState = ({
  state,
  columns,
  showCheckboxes,
  objectPropertyColumns,
  showExpandButtons
}) => {
  const { columnOrder, columnVisibility, columnSizing, eventPropertyColumns } = state;
  const validColumnIds = columns.map(
    (c) => c.id
  );
  const validCustomColumnIds = objectPropertyColumns ? objectPropertyColumns.allEventProperties.map(
    (c) => `${CUSTOM_EVENT_COLUMN_PREFIX}${c}`
  ) : [];
  const presentColumnIds = columnOrder.reduce(
    (acc, cur) => validColumnIds.includes(cur) || validCustomColumnIds.includes(cur) ? [...acc, cur] : acc,
    []
  );
  const missingColumnIds = validColumnIds.filter(
    (id) => !presentColumnIds.includes(id)
  );
  const scrubbedColumnOrder = [
    ...showExpandButtons ? [COLUMN_ID_EXPAND] : [],
    ...showCheckboxes ? [COLUMN_ID_CHECKBOX] : [],
    ...presentColumnIds,
    ...missingColumnIds,
    COLUMN_ID_ADD_COLUMN
  ];
  const scrubbedColumnVisibility = Object.keys(columnVisibility).reduce(
    (acc, cur) => validColumnIds.includes(cur) || validCustomColumnIds.includes(cur) ? { ...acc, [cur]: columnVisibility[cur] } : acc,
    {}
  );
  const scrubbedColumnSizing = Object.keys(columnSizing).reduce(
    (acc, cur) => {
      return validColumnIds.includes(cur) || validCustomColumnIds.includes(cur) ? {
        ...acc,
        [cur]: columnSizing[cur] >= COLUMN_MIN_SIZE ? columnSizing[cur] : COLUMN_MIN_SIZE
      } : acc;
    },
    {}
  );
  const scrubbedEventPropertyColumns = objectPropertyColumns ? eventPropertyColumns.filter(
    (c) => objectPropertyColumns.allEventProperties.includes(c)
  ) : [];
  return {
    columnOrder: scrubbedColumnOrder,
    columnVisibility: scrubbedColumnVisibility,
    columnSizing: scrubbedColumnSizing,
    eventPropertyColumns: scrubbedEventPropertyColumns
  };
};
var useMagicTableSavedState = ({
  sequenceUserId,
  entityNamePlural,
  columnOrder,
  setColumnOrder,
  columnVisibility,
  setColumnVisibility,
  columnSizing,
  setColumnSizing,
  columns,
  showCheckboxes,
  eventPropertyColumns,
  setEventPropertyColumns,
  objectPropertyColumns,
  showExpandButtons,
  enableColumnReordering
}) => {
  const isReadyToUpdate = useRef7(false);
  const isStateRestored = useRef7(false);
  const localStorageKey = `${sequenceUserId}:table_${entityNamePlural.replace(
    / /g,
    ""
  )}`;
  const localStorageValue = window.localStorage.getItem(localStorageKey);
  const updateSavedState = useCallback14((props) => {
    if (!isReadyToUpdate.current) {
      isReadyToUpdate.current = true;
      return;
    }
    const payload = {
      columnOrder: enableColumnReordering ? props.columnOrder : [],
      columnVisibility: props.columnVisibility,
      columnSizing: props.columnSizing,
      eventPropertyColumns: props.eventPropertyColumns
    };
    window.localStorage.setItem(localStorageKey, JSON.stringify(payload));
  }, []);
  const getSavedState = useCallback14(() => {
    if (!localStorageValue) {
      return void 0;
    }
    try {
      const parsedLocalStorageValue = JSON.parse(localStorageValue);
      const migratedState = (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        typeof parsedLocalStorageValue.eventPropertyColumns === "undefined" ? { ...parsedLocalStorageValue, eventPropertyColumns: [] } : parsedLocalStorageValue
      );
      if (!isMagicTableSavedState(migratedState)) {
        return void 0;
      }
      const scrubbedSavedState = scrubSavedState({
        state: migratedState,
        columns,
        showCheckboxes,
        objectPropertyColumns,
        showExpandButtons
      });
      updateSavedState({
        columnOrder: scrubbedSavedState.columnOrder,
        columnVisibility: scrubbedSavedState.columnVisibility,
        columnSizing: scrubbedSavedState.columnSizing,
        eventPropertyColumns: scrubbedSavedState.eventPropertyColumns
      });
      return scrubbedSavedState;
    } catch (e) {
      window.localStorage.removeItem(localStorageKey);
      return void 0;
    }
  }, [localStorageValue]);
  const savedState = getSavedState();
  const debouncedUpdateSavedState = useMemo18(
    () => debounce(updateSavedState, 250),
    [updateSavedState]
  );
  useEffect13(() => {
    return () => {
      debouncedUpdateSavedState.cancel();
    };
  }, []);
  useEffect13(() => {
    debouncedUpdateSavedState({
      columnOrder,
      columnVisibility,
      columnSizing,
      eventPropertyColumns
    });
  }, [columnOrder, columnSizing, columnVisibility, eventPropertyColumns]);
  const restoreSavedState = useCallback14(
    (onNoSavedState) => {
      if (isStateRestored.current) {
        return;
      }
      if (savedState) {
        setColumnOrder(savedState.columnOrder);
        setColumnVisibility(savedState.columnVisibility);
        setColumnSizing(savedState.columnSizing);
        setEventPropertyColumns(savedState.eventPropertyColumns);
      } else {
        onNoSavedState();
      }
      isStateRestored.current = true;
    },
    [
      savedState,
      setColumnOrder,
      setColumnSizing,
      setColumnVisibility,
      setEventPropertyColumns
    ]
  );
  return { restoreSavedState, isStateRestored };
};

// src/components/MagicTable/MagicTable.tsx
import { useState as useState20, useMemo as useMemo21, useRef as useRef8 } from "react";

// src/components/MagicTable/hooks/useMagicTable.tsx
import { useVirtualizer as useVirtualizer2 } from "@tanstack/react-virtual";
import { useEffect as useEffect14, useMemo as useMemo19, useState as useState18 } from "react";

// src/components/MagicTable/hooks/useMagicTableInfiniteQuery.ts
import { useSequenceInfiniteQuery } from "@sequencehq/api/utils";

// src/components/MagicTable/hooks/useLinkMagicTableWithSearchParams.ts
import { useSearchParams as useSearchParams11 } from "react-router-dom";

// src/components/MagicTable/utils/parseActiveFiltersFromSearchParams.ts
import { match as match7 } from "ts-pattern";
import { isSameDay as isSameDay2, startOfDay, sub } from "@sequencehq/utils/dates";
function parseActiveFiltersFromSearchParams(allFilters, searchParams = new URLSearchParams(window.location.search)) {
  const queryParams = Array.from(
    searchParams.entries()
  ).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: value
    }),
    {}
  );
  return allFilters.flatMap(
    (thisFilter) => match7(
      thisFilter.type
    ).with("multiSelect", () => {
      if (!queryParams[thisFilter.paramName]) {
        return [];
      }
      return {
        type: "multiSelect",
        paramName: thisFilter.paramName,
        values: queryParams[thisFilter.paramName].split(",")
      };
    }).with("multiSelectAliased", () => {
      if (!queryParams[thisFilter.paramName]) {
        return [];
      }
      return {
        type: "multiSelect",
        paramName: thisFilter.paramName,
        values: queryParams[thisFilter.paramName].split(";")
      };
    }).with("text", () => {
      if (!queryParams[thisFilter.paramName]) {
        return [];
      }
      return {
        type: "text",
        paramName: thisFilter.paramName,
        value: queryParams[thisFilter.paramName]
      };
    }).with("date", () => {
      if (thisFilter.type !== "date") {
        return [];
      }
      const paramBefore = queryParams[thisFilter.paramNameBefore];
      const paramAfter = queryParams[thisFilter.paramNameAfter];
      const hasParams = {
        hasParamBefore: typeof paramBefore !== "undefined",
        hasParamAfter: typeof paramAfter !== "undefined"
      };
      if (!hasParams.hasParamBefore && !hasParams.hasParamAfter) {
        return [];
      }
      const parsedBefore = isIsoDate(paramBefore) ? paramBefore.split("T")[0] : paramBefore;
      const parsedAfter = isIsoDate(paramAfter) ? paramAfter.split("T")[0] : paramAfter;
      return match7(hasParams).with({ hasParamBefore: false, hasParamAfter: false }, () => []).with({ hasParamBefore: true, hasParamAfter: true }, () => {
        if (parsedBefore === parsedAfter) {
          return {
            type: "dateCustom",
            date: new Date(parsedBefore),
            operator: "EQUALS",
            paramName: thisFilter.paramName
          };
        }
        if (isSameDay2(new Date(parsedBefore), getToday())) {
          const matchingPreset = getMatchingPreset(parsedAfter);
          if (matchingPreset) {
            return {
              type: "datePreset",
              paramName: thisFilter.paramName,
              preset: matchingPreset,
              operator: "LESS_THAN"
            };
          }
        }
        return [
          {
            type: "dateCustom",
            date: new Date(parsedBefore),
            operator: "BEFORE",
            paramName: thisFilter.paramName
          },
          {
            type: "dateCustom",
            date: new Date(parsedAfter),
            operator: "AFTER",
            paramName: thisFilter.paramName
          }
        ];
      }).with({ hasParamBefore: true, hasParamAfter: false }, () => {
        const matchingPreset = getMatchingPreset(parsedBefore);
        if (matchingPreset) {
          return {
            type: "datePreset",
            paramName: thisFilter.paramName,
            preset: matchingPreset,
            operator: "MORE_THAN"
          };
        }
        return {
          type: "dateCustom",
          date: new Date(parsedBefore),
          operator: "BEFORE",
          paramName: thisFilter.paramName
        };
      }).with({ hasParamBefore: false, hasParamAfter: true }, () => {
        return {
          type: "dateCustom",
          date: new Date(parsedAfter),
          operator: "AFTER",
          paramName: thisFilter.paramName
        };
      }).exhaustive();
    }).with("toggle", () => {
      if (!queryParams[thisFilter.paramName]) {
        return [];
      }
      return {
        type: "toggle",
        paramName: thisFilter.paramName,
        value: queryParams[thisFilter.paramName] === "true"
      };
    }).with("boolean", "checkbox", () => []).exhaustive()
  );
}
var getToday = () => {
  const now = /* @__PURE__ */ new Date();
  return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
};
function isIsoDate(str) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str))
    return false;
  const d = new Date(str);
  return !isNaN(d.getTime()) && d.toISOString() === str;
}
function getMatchingPreset(dateAsString) {
  const date = new Date(dateAsString);
  if (isSameDay2(date, getToday())) {
    return "TODAY";
  }
  if (isSameDay2(date, startOfDay(sub(getToday(), { weeks: 1 })))) {
    return "1_WEEK";
  }
  if (isSameDay2(date, startOfDay(sub(getToday(), { months: 1 })))) {
    return "1_MONTH";
  }
  if (isSameDay2(date, startOfDay(sub(getToday(), { months: 3 })))) {
    return "3_MONTHS";
  }
}

// src/components/MagicTable/hooks/useLinkMagicTableWithSearchParams.ts
import { match as match8 } from "ts-pattern";
import { startOfDay as startOfDay2, sub as sub2 } from "@sequencehq/utils/dist/dates";
import { useCallback as useCallback15, useState as useState17 } from "react";
var useLinkMagicTableWithSearchParams = (allFilters, preserveParams) => {
  const [, setSearchParams] = useSearchParams11();
  const searchParams = new URLSearchParams(window.location.search);
  const [activeFilters, setActiveFilters] = useState17(
    parseActiveFiltersFromSearchParams(allFilters, searchParams)
  );
  const sortBy = searchParams.get(SORT_BY_KEY);
  const onChangeActiveFilters = useCallback15(
    (activeFilters2) => {
      const searchParams2 = new URLSearchParams(window.location.search);
      setActiveFilters(activeFilters2);
      const newParams = activeFiltersToSearchParams(allFilters, activeFilters2);
      preserveParams?.forEach((param) => {
        const value = searchParams2.get(param);
        if (value) {
          newParams.set(param, value);
        }
      });
      if (searchParams2.get(SORT_BY_KEY)) {
        newParams.set(SORT_BY_KEY, searchParams2.get(SORT_BY_KEY));
      }
      if (newParams.toString() !== window.location.search.toString().replace("?", "")) {
        setSearchParams(newParams.toString());
      }
    },
    [preserveParams]
  );
  const onChangeSortBy = useCallback15(
    (sortBy2) => {
      setSearchParams((searchParams2) => {
        if (sortBy2) {
          searchParams2.set(SORT_BY_KEY, sortBy2);
        } else {
          searchParams2.delete(SORT_BY_KEY);
        }
        return searchParams2;
      });
    },
    [setSearchParams]
  );
  return {
    activeFilters,
    onChangeActiveFilters,
    sortBy,
    onChangeSortBy
  };
};
var activeFiltersToSearchParams = (allFilters, activeFilters) => {
  const searchParams = new URLSearchParams();
  activeFilters.forEach((activeFilter) => {
    const thisFilter = allFilters.find(
      (filter) => filter.paramName === activeFilter.paramName
    );
    if (!thisFilter) {
      return;
    }
    match8(activeFilter.type).with("multiSelect", () => {
      if (activeFilter.type !== "multiSelect" || activeFilter.values.length === 0) {
        return;
      }
      if (thisFilter.type === "multiSelect") {
        if (thisFilter.setQueryParamsFn) {
          thisFilter.setQueryParamsFn(
            thisFilter,
            activeFilter,
            searchParams
          );
          return;
        }
        searchParams.set(thisFilter.paramName, activeFilter.values.join(","));
        return;
      }
      if (thisFilter.type === "multiSelectAliased") {
        searchParams.set(thisFilter.paramName, activeFilter.values.join(";"));
        return;
      }
    }).with("text", () => {
      if (activeFilter.type !== "text") {
        return;
      }
      searchParams.set(activeFilter.paramName, activeFilter.value);
    }).with("datePreset", () => {
      if (activeFilter.type !== "datePreset" || !thisFilter || thisFilter.type !== "date") {
        return;
      }
      const targetDate = match8(activeFilter.preset).with("TODAY", () => startOfDay2(getToday())).with("1_WEEK", () => startOfDay2(sub2(getToday(), { weeks: 1 }))).with("1_MONTH", () => startOfDay2(sub2(getToday(), { months: 1 }))).with("3_MONTHS", () => startOfDay2(sub2(getToday(), { months: 3 }))).exhaustive();
      match8(activeFilter.operator).with("LESS_THAN", () => {
        if (activeFilter.preset === "TODAY") {
          searchParams.set(
            thisFilter.paramNameBefore,
            thisFilter.stringifyDate(
              startOfDay2(sub2(getToday(), { days: 1 }))
            )
          );
          searchParams.delete(thisFilter.paramNameAfter);
          return;
        }
        searchParams.set(
          thisFilter.paramNameBefore,
          thisFilter.stringifyDate(getToday())
        );
        searchParams.set(
          thisFilter.paramNameAfter,
          thisFilter.stringifyDate(targetDate)
        );
      }).with("MORE_THAN", () => {
        if (activeFilter.preset === "TODAY") {
          searchParams.set(
            thisFilter.paramNameAfter,
            thisFilter.stringifyDate(targetDate)
          );
          searchParams.delete(thisFilter.paramNameBefore);
          return;
        }
        searchParams.set(
          thisFilter.paramNameBefore,
          thisFilter.stringifyDate(targetDate)
        );
        searchParams.delete(thisFilter.paramNameAfter);
      }).with("EQUALS", () => {
        searchParams.set(
          thisFilter.paramNameBefore,
          thisFilter.stringifyDate(targetDate)
        );
        searchParams.set(
          thisFilter.paramNameAfter,
          thisFilter.stringifyDate(targetDate)
        );
      }).exhaustive();
    }).with("dateCustom", () => {
      if (activeFilter.type !== "dateCustom" || !thisFilter || thisFilter.type !== "date") {
        return;
      }
      match8(activeFilter.operator).with("BEFORE", () => {
        searchParams.set(
          thisFilter.paramNameBefore,
          thisFilter.stringifyDate(activeFilter.date)
        );
      }).with("AFTER", () => {
        searchParams.set(
          thisFilter.paramNameAfter,
          thisFilter.stringifyDate(activeFilter.date)
        );
      }).with("EQUALS", () => {
        searchParams.set(
          thisFilter.paramNameBefore,
          thisFilter.stringifyDateBefore ? thisFilter.stringifyDateBefore(activeFilter.date) : thisFilter.stringifyDate(activeFilter.date)
        );
        searchParams.set(
          thisFilter.paramNameAfter,
          thisFilter.stringifyDateAfter ? thisFilter.stringifyDateAfter(activeFilter.date) : thisFilter.stringifyDate(activeFilter.date)
        );
      }).exhaustive();
    }).with("toggle", () => {
      if (activeFilter.type !== "toggle") {
        return;
      }
      searchParams.set(
        activeFilter.paramName,
        activeFilter.value ? "true" : "false"
      );
    }).exhaustive();
  });
  return searchParams;
};

// src/components/MagicTable/hooks/useMagicTableInfiniteQuery.ts
var MAX_PAGES = useSequenceInfiniteQuery.MAX_PAGES;
var useMagicTableInfiniteQuery = (apiFn, filters = [], activeFilters = [], sortBy = null, limit, maxPages = MAX_PAGES, params) => {
  const queryParams = magicTableToApiQueryParams(filters, activeFilters, sortBy);
  const { infiniteQuery } = useSequenceInfiniteQuery(
    apiFn,
    {
      ...queryParams,
      ...params,
      limit
    },
    {
      maxPages
    }
  );
  return { infiniteQuery };
};
var scrubFilters2 = (searchParams, filters) => {
  const filterConfig = filters ?? [];
  const filterValues = filterConfig.reduce((acc, filter) => {
    if (filter.type === "date") {
      const filterValueBefore = searchParams.get(filter.paramNameBefore);
      const filterValueAfter = searchParams.get(filter.paramNameAfter);
      return {
        ...acc,
        ...filterValueBefore ? { [filter.paramNameBefore]: filterValueBefore } : {},
        ...filterValueAfter ? { [filter.paramNameAfter]: filterValueAfter } : {}
      };
    } else {
      const filterValue = searchParams.get(filter.paramName);
      return filterValue ? { ...acc, [filter.paramName]: filterValue } : acc;
    }
  }, {});
  return deduplicateAliasedFilters({ filterValues, filterConfig });
};
var deduplicateAliasedFilters = ({
  filterValues,
  filterConfig
}) => {
  const filterValuesFinal = filterValues ? Object.keys(filterValues).reduce(
    (acc, filterKey) => {
      const configForFilterKey = filterConfig.find(
        (config) => config.paramName === filterKey
      );
      const valueForFilterKey = acc[filterKey] && typeof acc[filterKey] === "string" ? acc[filterKey] : filterValues[filterKey];
      if (!configForFilterKey || configForFilterKey.type !== "multiSelectAliased" || typeof valueForFilterKey !== "string") {
        return {
          ...acc,
          [filterKey]: valueForFilterKey
        };
      }
      const { paramNameAliasOf } = configForFilterKey;
      const flatValueForFilterKey = valueForFilterKey.split(";").reduce(
        (flatAcc, curr) => [
          ...flatAcc,
          ...curr.split(",")
        ],
        []
      );
      const valueForAlias = filterValues[paramNameAliasOf];
      if (!valueForAlias || typeof valueForAlias !== "string") {
        return {
          ...acc,
          [paramNameAliasOf]: flatValueForFilterKey.join(",")
        };
      }
      return {
        ...acc,
        [paramNameAliasOf]: Array.from([
          .../* @__PURE__ */ new Set([
            ...valueForAlias.split(","),
            ...flatValueForFilterKey
          ])
        ]).join(",")
      };
    },
    {}
  ) : filterValues;
  return filterValuesFinal ?? {};
};
var magicTableToApiQueryParams = (filters, activeFilters, sortBy) => {
  const queryParams = scrubFilters2(
    activeFiltersToSearchParams(filters, activeFilters),
    filters
  );
  return { ...sortByToParams(sortBy), ...queryParams };
};
function sortByToParams(sortBy) {
  if (!sortBy) {
    return {};
  }
  const [field, order] = sortBy.split("_");
  return { sortBy: field, sortOrder: order.toUpperCase() };
}

// src/components/MagicTable/hooks/useMagicTable.tsx
import isEmpty2 from "lodash/isEmpty";

// src/components/MagicTable/utils/enhanceRowsWithGroupInfo.ts
function enhanceRowsWithGroupInfo({
  items,
  rowSpanningRules,
  getGroupKey,
  groupBy,
  isCollapsed,
  toggleCollapsed
}) {
  if (!rowSpanningRules) {
    return items;
  }
  const enhancedItems = items.map((item, index) => {
    const groupInfo = {};
    rowSpanningRules.forEach(({ columnId, spanBy }) => {
      const nextItem = items[index + 1];
      const prevItem = index > 0 ? items[index - 1] : void 0;
      const isInSameGroupAsNextRow = nextItem ? spanBy(item, nextItem) : false;
      const isInSameGroupAsPrevRow = prevItem ? spanBy(prevItem, item) : false;
      const groupKey = getGroupKey?.(item);
      const togglableColumn = groupBy === columnId && (prevItem ? getGroupKey?.(prevItem) !== groupKey : true);
      groupInfo[columnId] = {
        togglableColumn,
        groupKey: getGroupKey?.(item),
        isFirstInGroup: !isInSameGroupAsPrevRow,
        isLastInGroup: !isInSameGroupAsNextRow,
        isInSameGroupAsNextRow,
        isCollapsed: groupKey ? isCollapsed?.(groupKey) : void 0,
        toggleCollapsed: groupKey ? () => toggleCollapsed?.(groupKey) : void 0
      };
    });
    return {
      ...item,
      _groupInfo: groupInfo
    };
  });
  if (!groupBy) {
    return enhancedItems;
  }
  const itemsWithoutCollapsedRows = enhancedItems.reduce((acc, item) => {
    if (item._groupInfo[groupBy]?.togglableColumn) {
      return [...acc, item];
    }
    if (item._groupInfo[groupBy]?.isCollapsed) {
      return acc;
    }
    return [...acc, item];
  }, []);
  return itemsWithoutCollapsedRows;
}

// src/components/MagicTable/hooks/useMagicTable.tsx
var DEFAULT_ROWS_PER_PAGE = 50;
var useMagicTable = ({
  activeFilters,
  containerHeight,
  refContainer,
  expandedRows,
  getSubRows,
  infiniteQuery,
  rowSpanningRules,
  getGroupKey,
  groupBy,
  transformGroupData,
  resultSizeMultiplier
}) => {
  const [collapsedGroupKeys, setCollapsedGroupKeys] = useState18({});
  const enhancedRows = useMemo19(() => {
    let rawRows = infiniteQuery.data?.pages.flatMap((page) => page.items) ?? [];
    if (transformGroupData) {
      rawRows = transformGroupData(rawRows, groupBy);
    }
    return enhanceRowsWithGroupInfo({
      items: rawRows,
      rowSpanningRules,
      getGroupKey,
      groupBy,
      isCollapsed: (groupKey) => collapsedGroupKeys[groupKey],
      toggleCollapsed: (groupKey) => {
        setCollapsedGroupKeys((prev) => ({
          ...prev,
          [groupKey]: !prev[groupKey]
        }));
      }
    });
  }, [
    infiniteQuery.data?.pages,
    rowSpanningRules,
    collapsedGroupKeys,
    setCollapsedGroupKeys,
    groupBy,
    transformGroupData,
    getGroupKey
  ]);
  const rowsPerPage = infiniteQuery.data?.pages[0]?.items.length ?? DEFAULT_ROWS_PER_PAGE;
  const lastPageWithPagination = infiniteQuery.data?.pages.findLast(
    (page) => !!page.pagination.totalResultSize
  );
  const totalResultSize = (lastPageWithPagination?.pagination.totalResultSize ?? 0) * (resultSizeMultiplier ?? 1);
  const rowCountToFitSpace = containerHeight ? Math.floor(containerHeight / VIRTUAL_TABLE_ROW_HEIGHT) - 1 : VIRTUAL_TABLE_DEFAULT_INITIAL_RESULTS_SIZE;
  const [expandedRowCount, setExpandedRowCount] = useState18(0);
  const rowCountToShow = totalResultSize > 0 || !infiniteQuery.isFetching ? Math.min(MAX_PAGES * rowsPerPage, totalResultSize) + expandedRowCount : rowCountToFitSpace;
  const rowVirtualizer = useVirtualizer2({
    count: Object.keys(collapsedGroupKeys).length > 0 ? enhancedRows.length : rowCountToShow,
    getScrollElement: () => refContainer.current,
    estimateSize: () => VIRTUAL_TABLE_ROW_HEIGHT,
    overscan: OVERSCAN,
    getItemKey: (index) => enhancedRows[index] ? String(index) : `LOADING-${index}`
  });
  const lastItem = rowVirtualizer.getVirtualItems().slice().pop();
  const scrolledToEnd = !lastItem || lastItem?.index + 5 > enhancedRows.length;
  useEffect14(() => {
    if (scrolledToEnd) {
      infiniteQuery.hasNextPage && !infiniteQuery.isFetchingNextPage && void infiniteQuery.fetchNextPage();
    }
  }, [scrolledToEnd, infiniteQuery]);
  useEffect14(() => {
    if (!getSubRows) {
      return;
    }
    const expandedRowIds = Object.keys(expandedRows).map((id) => Number(id));
    const newExpandedRowCount = expandedRowIds.map((id) => getSubRows(enhancedRows[id], id).length).reduce((prev, curr) => prev + curr, 0);
    setExpandedRowCount(newExpandedRowCount);
  }, [expandedRows, enhancedRows]);
  const hasFilters = !isEmpty2(activeFilters);
  return {
    rowVirtualizer,
    rows: enhancedRows,
    totalResultSize,
    hasFilters,
    loading: infiniteQuery.isFetching
  };
};

// src/components/MagicTable/hooks/useRowSelection.ts
import { useState as useState19, useMemo as useMemo20 } from "react";
import { dequal as dequal3 } from "dequal";
import isFunction from "lodash/isFunction";
var useRowSelection = (props) => {
  const isExternallyControlled = Boolean(
    props.selectedItems && props.onSelectedItemsChange
  );
  const [internalRowSelection, internalSetRowSelection] = useState19({});
  const formattedExternalState = useMemo20(() => {
    const selectedItemDictionary = props.selectedItems?.reduce(
      (acc, item) => ({
        ...acc,
        [item]: item
      }),
      {}
    ) ?? {};
    return props.rows.map((row) => selectedItemDictionary[row.id]).reduce((acc, val) => {
      if (!val)
        return acc;
      return {
        ...acc,
        [props.rows.findIndex((row) => row.id === val)]: val
      };
    }, {});
  }, [props.selectedItems, props.rows]);
  const rowSelection = useMemo20(() => {
    if (!isExternallyControlled) {
      return internalRowSelection;
    }
    return formattedExternalState;
  }, [isExternallyControlled, internalRowSelection, formattedExternalState]);
  const setRowSelection = (rowSelectionState) => {
    if (!isExternallyControlled) {
      internalSetRowSelection(rowSelectionState);
      return;
    }
    const newSelectionState = isFunction(rowSelectionState) ? rowSelectionState(formattedExternalState) : rowSelectionState;
    const selectedItems = Object.entries(newSelectionState).filter(([_key, value]) => value).map(([key]) => {
      return props.rows[Number(key)].id;
    });
    if (dequal3(selectedItems, props.selectedItems)) {
      return;
    }
    props.onSelectedItemsChange?.(selectedItems);
  };
  return {
    rowSelection,
    setRowSelection
  };
};

// src/components/MagicTable/MagicTable.tsx
import { jsx as jsx53, jsxs as jsxs27 } from "react/jsx-runtime";
var MagicTable = (props) => {
  const {
    entityNamePlural,
    additionalHeaderRows,
    columns: columnsProp,
    filters: allFilters,
    emptyStateUnfiltered,
    emptyStateFiltered,
    kebabMenu,
    rowPath,
    onRowClick,
    bulkActions,
    sequenceUserId,
    objectPropertyColumns,
    getSubRows,
    viewSettingsHeader,
    additionalToolbarComponentsV3,
    additionalStatusBarComponents,
    activeFilters = [],
    onChangeActiveFilters = () => {
    },
    sortBy = null,
    onChangeSortBy = () => {
    },
    onSaveFilters,
    onUpdateSavedFilters,
    lockedControls,
    disableCheckboxes,
    grouping,
    enableColumnReordering = true,
    showAddColumn = true,
    enableCopyResults
  } = props;
  const {
    groupableColumns,
    onGroupBy,
    groupBy,
    highlightRowGroup,
    rowSpanningRules,
    getGroupKey,
    transformGroupData,
    resultSizeMultiplier
  } = grouping ?? {};
  const refContainer = useRef8(null);
  const refTableContainer = useRef8(null);
  const { width: containerWidth, height: containerHeight } = useDimensions({
    refContainer,
    initialWidth: window.innerWidth - DEFAULT_PAGE_SIDEBAR_WIDTH
  });
  const [columnOrder, setColumnOrder] = useState20([]);
  const [columnVisibility, setColumnVisibility] = useState20({});
  const [columnSizing, setColumnSizing] = useState20({});
  const [expandedRows, setExpandedRows] = useState20({});
  const { rowVirtualizer, rows, totalResultSize, hasFilters, loading } = useMagicTable({
    ...props,
    containerHeight,
    refContainer,
    expandedRows,
    rowSpanningRules,
    getGroupKey,
    groupBy,
    transformGroupData,
    resultSizeMultiplier
  });
  const { rowSelection, setRowSelection } = useRowSelection({
    rows,
    selectedItems: bulkActions?.selectedItems,
    onSelectedItemsChange: bulkActions?.onSelectedItemsChange
  });
  const {
    eventPropertyColumns,
    setEventPropertyColumns,
    refUpdateEventPropertyColumns
  } = useCustomEventPropertyColumns({
    setColumnOrder,
    setColumnSizing,
    setColumnVisibility
  });
  const enableObjectPropertyColumns = Boolean(objectPropertyColumns);
  const showCheckboxes = Boolean(bulkActions);
  const showExpandButtons = Boolean(getSubRows);
  const { restoreSavedState, isStateRestored } = useMagicTableSavedState({
    sequenceUserId,
    entityNamePlural,
    columnOrder,
    setColumnOrder,
    columnVisibility,
    setColumnVisibility,
    columnSizing,
    setColumnSizing,
    columns: columnsProp,
    showCheckboxes,
    eventPropertyColumns,
    setEventPropertyColumns,
    objectPropertyColumns,
    showExpandButtons,
    enableColumnReordering
  });
  const columns = useMemo21(() => {
    const finalColumns = [
      ...showExpandButtons ? [
        {
          id: COLUMN_ID_EXPAND,
          header: () => null,
          cell: ({ row }) => /* @__PURE__ */ jsx53(MagicTableExpandToggle, { row }),
          size: COLUMN_DEFAULT_WIDTH_EXPAND
        }
      ] : [],
      ...showCheckboxes ? [
        {
          id: COLUMN_ID_CHECKBOX,
          header: ({ table: table2 }) => {
            return /* @__PURE__ */ jsx53(
              MagicTableCheckbox,
              {
                checked: table2.getIsAllRowsSelected(),
                indeterminate: table2.getIsSomeRowsSelected(),
                onChange: table2.getToggleAllRowsSelectedHandler(),
                showExpandButtons,
                disabled: disableCheckboxes,
                "data-testId": "magicTable.header.selectAll"
              }
            );
          },
          cell: ({ row }) => {
            return /* @__PURE__ */ jsx53(
              MagicTableCheckbox,
              {
                "data-testId": `magicTable.row.${row.id}.checkbox`,
                checked: row.getIsSelected(),
                disabled: disableCheckboxes || !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: row.getToggleSelectedHandler(),
                showExpandButtons
              }
            );
          },
          size: showExpandButtons ? COLUMN_DEFAULT_WIDTH_CHECKBOX_WITH_EXPAND : COLUMN_DEFAULT_WIDTH_CHECKBOX
        }
      ] : [],
      ...columnsProp.map((c) => ({
        ...c,
        minSize: COLUMN_MIN_SIZE
      })),
      ...objectPropertyColumns ? eventPropertyColumns.map((eventProperty) => ({
        id: `${CUSTOM_EVENT_COLUMN_PREFIX}${eventProperty}`,
        header: eventProperty,
        cell: ({ row }) => {
          const rowObject = objectPropertyColumns.getObject(row.original);
          const rowObjectValue = rowObject[eventProperty];
          if (typeof rowObjectValue !== "string" && typeof rowObjectValue !== "number") {
            return null;
          }
          return /* @__PURE__ */ jsx53(
            MagicTableCell_default,
            {
              text: String(rowObjectValue),
              fontStyle: "monospace",
              backgroundColor: GreyGrey203
            }
          );
        },
        minSize: COLUMN_MIN_SIZE
      })) : [],
      ...showAddColumn ? [
        {
          id: COLUMN_ID_ADD_COLUMN,
          size: COLUMN_DEFAULT_WIDTH_ADD_COLUMN,
          header: ({ table: table2 }) => {
            return /* @__PURE__ */ jsx53(
              MagicTableAddColumnButtonV3,
              {
                getTableState: table2.getState,
                getTableAllFlatColumns: table2.getAllFlatColumns,
                customColumns: {
                  isEnabled: enableObjectPropertyColumns,
                  available: objectPropertyColumns?.allEventProperties ?? [],
                  selected: eventPropertyColumns,
                  setSelected: setEventPropertyColumns
                }
              }
            );
          },
          cell: ({ row }) => kebabMenu ? /* @__PURE__ */ jsx53(MagicTableRowActionCell, { row, kebabMenu }) : null
        }
      ] : []
    ];
    restoreSavedState(() => {
      setColumnSizing(
        getDefaultColumnWidth({
          columns: columnsProp,
          containerWidth,
          showCheckboxes,
          showExpandButtons,
          showAddColumn
        })
      );
      setColumnOrder(finalColumns.map((column) => column.id));
      const initialColumnVisibility = finalColumns.reduce(
        (acc, finalColumn) => {
          const thisColumn = columnsProp.find(
            (column) => column.id === finalColumn.id
          );
          if (!thisColumn) {
            return { ...acc, [finalColumn.id]: true };
          }
          return {
            ...acc,
            [finalColumn.id]: !thisColumn.hiddenByDefault
          };
        },
        {}
      );
      setColumnVisibility(initialColumnVisibility);
    });
    return finalColumns;
  }, [
    isStateRestored.current,
    refUpdateEventPropertyColumns.current,
    disableCheckboxes
  ]);
  const table = useReactTable({
    data: rows,
    columns,
    state: {
      columnOrder,
      rowSelection,
      columnVisibility,
      columnSizing,
      expanded: expandedRows
    },
    onColumnOrderChange: enableColumnReordering ? setColumnOrder : void 0,
    onColumnVisibilityChange: setColumnVisibility,
    onColumnSizingChange: setColumnSizing,
    getCoreRowModel: getCoreRowModel(),
    columnResizeMode: "onChange",
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    onExpandedChange: setExpandedRows,
    getSubRows,
    getExpandedRowModel: getSubRows ? getExpandedRowModel() : void 0
  });
  const refClearFilters = useRef8(() => {
  });
  return /* @__PURE__ */ jsxs27(
    Grid,
    {
      gridTemplateRows: `auto 1fr auto`,
      overflow: "hidden",
      height: "100%",
      width: "100%",
      role: "table",
      backgroundColor: "white",
      ref: refTableContainer,
      children: [
        /* @__PURE__ */ jsxs27(Box20, { width: "100%", children: [
          /* @__PURE__ */ jsx53(
            MagicTableToolbarV3,
            {
              filters: allFilters,
              getTableState: table.getState,
              getTableAllFlatColumns: table.getAllFlatColumns,
              columnOrder,
              setColumnOrder,
              viewSettingsHeader,
              additionalToolbarComponentsV3,
              loading,
              customColumns: {
                isEnabled: enableObjectPropertyColumns,
                available: objectPropertyColumns?.allEventProperties ?? [],
                selected: eventPropertyColumns,
                setSelected: setEventPropertyColumns
              },
              refClearFilters,
              totalResultSize,
              activeFilters,
              onChangeActiveFilters,
              onSaveFilters,
              onUpdateSavedFilters,
              lockedControls,
              enableColumnReordering,
              groupableColumns,
              groupBy,
              onGroupBy,
              table,
              entityNamePlural,
              enableCopyResults
            }
          ),
          additionalHeaderRows
        ] }),
        /* @__PURE__ */ jsx53(
          MagicTableBody,
          {
            table,
            refContainer,
            rowVirtualizer,
            columnVisibility,
            columnOrder,
            setColumnOrder,
            hasFilters,
            totalResultSize,
            containerWidth,
            containerHeight,
            showCheckboxes,
            entityNamePlural,
            emptyStateFiltered,
            emptyStateUnfiltered,
            rowPath,
            onRowClick,
            setEventPropertyColumns,
            showExpandButtons,
            clearFilters: () => {
              refClearFilters.current();
            },
            loading,
            sortBy,
            onChangeSortBy,
            additionalTableHeaderRow: props.additionalTableHeaderRow,
            enableColumnReordering,
            groupableColumns,
            onGroupBy,
            groupBy,
            highlightRowGroup
          }
        ),
        /* @__PURE__ */ jsx53(
          MagicTableStatusBarV3,
          {
            totalResultSize,
            rows,
            rowSelection,
            setRowSelection,
            bulkActions: bulkActions?.bar,
            additionalComponents: additionalStatusBarComponents
          }
        )
      ]
    }
  );
};

// src/components/MagicTable/types.ts
var MagicTableDateFilterType = /* @__PURE__ */ ((MagicTableDateFilterType2) => {
  MagicTableDateFilterType2["Before"] = "Before";
  MagicTableDateFilterType2["After"] = "After";
  return MagicTableDateFilterType2;
})(MagicTableDateFilterType || {});

// src/components/MagicTable/Cells/MagicTableCell.tsx
import { Box as Box21, Flex as Flex18, Text as Text18 } from "@chakra-ui/react";
import { CopyButton } from "@sequencehq/core-components";
import { Inconsolata14Regular, Lato14Regular as Lato14Regular2 } from "@sequencehq/design-tokens";
import { Fragment as Fragment16, jsx as jsx54, jsxs as jsxs28 } from "react/jsx-runtime";
var MagicTableCell = ({
  icon,
  text,
  textAlign = "left",
  showCopyButton = false,
  withBorder = false,
  borderColor: borderColor7,
  textColor,
  backgroundColor,
  fontStyle = "sans-serif",
  overflow = "hidden",
  "data-testid": testId
}) => {
  if (!text) {
    return null;
  }
  const withBorderProps = withBorder || backgroundColor ? {
    width: "fit-content",
    padding: "3px 6px",
    borderRadius: "6px",
    backgroundColor,
    ...withBorder ? { borderWidth: "1px", borderColor: borderColor7 } : {}
  } : {};
  const font = fontStyle === "sans-serif" ? Lato14Regular2 : Inconsolata14Regular;
  return /* @__PURE__ */ jsx54(
    Box21,
    {
      padding: withBorder || backgroundColor ? "8px 12px" : "12px",
      sx: showCopyButton ? { ".mt-cell:hover .mt-cell-copy": { display: "block" } } : void 0,
      "data-testid": testId,
      children: /* @__PURE__ */ jsxs28(
        Flex18,
        {
          className: showCopyButton ? "mt-cell" : void 0,
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          _hover: showCopyButton ? { paddingRight: "38px" } : void 0,
          ...withBorderProps,
          children: [
            icon && /* @__PURE__ */ jsxs28(Fragment16, { children: [
              icon,
              /* @__PURE__ */ jsx54(Box21, { width: "6px" })
            ] }),
            /* @__PURE__ */ jsx54(
              Text18,
              {
                textAlign,
                width: "100%",
                overflow,
                display: "-webkit-box",
                sx: {
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                  lineBreak: "anywhere"
                },
                color: textColor,
                ...font,
                children: text
              }
            ),
            showCopyButton && typeof text === "string" && /* @__PURE__ */ jsx54(
              Box21,
              {
                boxSize: "24px",
                flexShrink: "0",
                position: "absolute",
                right: "8px",
                display: "none",
                className: "mt-cell-copy",
                children: /* @__PURE__ */ jsx54(CopyButton, { value: text, enableGroupHover: false })
              }
            )
          ]
        }
      )
    }
  );
};
var MagicTableCell_default = MagicTableCell;

// src/components/MagicTable/Cells/MagicTableCellBasic.tsx
import { Box as Box22 } from "@chakra-ui/react";
import { jsx as jsx55 } from "react/jsx-runtime";
var MagicTableCellBasic = ({
  children
}) => /* @__PURE__ */ jsx55(Box22, { padding: "8px 5px", children });

// src/components/MagicTable/Cells/MagicTableCellLink.tsx
import { Box as Box23, Text as Text19, Flex as Flex19, Avatar } from "@chakra-ui/react";
import { IndigoIndigo50 as IndigoIndigo505, Lato14Regular as Lato14Regular3 } from "@sequencehq/design-tokens";
import { useNavigate as useNavigate2 } from "react-router-dom";
import { borderColor as borderColor6 } from "@sequencehq/core-theme";
import { jsx as jsx56, jsxs as jsxs29 } from "react/jsx-runtime";
var MagicTableCellLink = ({
  to,
  label,
  showAvatar = false
}) => {
  const navigate = useNavigate2();
  return /* @__PURE__ */ jsx56(Box23, { padding: "8px 5px", children: /* @__PURE__ */ jsxs29(
    Flex19,
    {
      borderWidth: "1px",
      borderColor: "transparent",
      borderRadius: "8px",
      width: "fit-content",
      alignItems: "center",
      gap: "8px",
      padding: "3px 6px",
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(to);
      },
      color: IndigoIndigo505,
      _hover: { borderColor: borderColor6, cursor: "pointer" },
      children: [
        showAvatar && /* @__PURE__ */ jsx56(Avatar, { name: label, size: "2xs" }),
        /* @__PURE__ */ jsx56(
          Text19,
          {
            overflow: "hidden",
            display: "-webkit-box",
            sx: {
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1,
              lineBreak: "anywhere"
            },
            color: "inherit",
            ...Lato14Regular3,
            children: label
          }
        )
      ]
    }
  ) });
};
var MagicTableCellLink_default = MagicTableCellLink;

// src/components/MagicTable/Cells/MagicTableCellEmpty.tsx
import { Box as Box24 } from "@chakra-ui/react";
import { jsx as jsx57 } from "react/jsx-runtime";
var MagicTableCellEmpty = ({
  children
}) => /* @__PURE__ */ jsx57(Box24, { padding: "8px 12px", children });

// src/components/MagicTable/Cells/MagicTableCellInvoiceStatus.tsx
import { Box as Box25, Flex as Flex20 } from "@chakra-ui/react";
import { Badge } from "@sequencehq/core-components";
import {
  toInvoiceStatusBadgeProps
} from "@sequencehq/core-models";
import {
  GreenGreen80,
  GreyGrey100 as GreyGrey1002,
  GreyGrey20 as GreyGrey204,
  GreyGrey70 as GreyGrey703,
  Lato12UppercaseBold,
  RedRed80,
  YellowYellow80
} from "@sequencehq/design-tokens";
import { toInvoicePaymentStatusBadgeProps } from "@sequencehq/utils";
import { jsx as jsx58, jsxs as jsxs30 } from "react/jsx-runtime";
var sentimentColors = {
  warning: YellowYellow80,
  success: GreenGreen80,
  neutral: GreyGrey703,
  error: RedRed80,
  info: "#5F5CFF",
  highlight: GreyGrey204,
  metric: GreyGrey1002
};
var getColorBySentiment = (sentiment) => sentimentColors[sentiment] || "black";
var MagicTableCellInvoiceStatus = ({
  invoiceStatus,
  paymentStatus
}) => {
  return /* @__PURE__ */ jsx58(Box25, { padding: "8px 12px", children: /* @__PURE__ */ jsxs30(Flex20, { direction: "row", children: [
    /* @__PURE__ */ jsx58(Badge, { ...toInvoiceStatusBadgeProps({ status: invoiceStatus }) }),
    paymentStatus && invoiceStatus === "SENT" && /* @__PURE__ */ jsxs30(Flex20, { direction: "row", children: [
      /* @__PURE__ */ jsx58(Box25, { w: "2", flexShrink: "0" }),
      /* @__PURE__ */ jsx58(
        Badge,
        {
          wrapText: true,
          textStyle: {
            ...Lato12UppercaseBold,
            color: getColorBySentiment(
              toInvoicePaymentStatusBadgeProps({ status: paymentStatus }).sentiment
            ),
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 1,
            lineBreak: "anywhere",
            overflow: "hidden",
            display: "-webkit-box"
          },
          containerStyle: { width: "fit-content" },
          ...toInvoicePaymentStatusBadgeProps({
            status: paymentStatus
          })
        }
      )
    ] })
  ] }) });
};
var MagicTableCellInvoiceStatus_default = MagicTableCellInvoiceStatus;

// src/components/MagicTable/Cells/MagicTableCellProductStatus.tsx
import { Box as Box26 } from "@chakra-ui/react";
import { Badge as Badge2 } from "@sequencehq/core-components";
import {
  toProductStatusBadgeProps
} from "@sequencehq/core-models";
import { jsx as jsx59 } from "react/jsx-runtime";
var MagicTableCellProductStatus = ({ productStatus }) => {
  return /* @__PURE__ */ jsx59(Box26, { padding: "8px 12px", children: /* @__PURE__ */ jsx59(Badge2, { ...toProductStatusBadgeProps({ status: productStatus }) }) });
};
var MagicTableCellProductStatus_default = MagicTableCellProductStatus;

// src/components/MagicTable/Cells/MagicTableCellQuoteStatus.tsx
import { Box as Box27, Flex as Flex21 } from "@chakra-ui/react";
import { Badge as Badge3 } from "@sequencehq/core-components";
import { toQuoteStatusBadgeProps } from "@sequencehq/core-models";
import { jsx as jsx60, jsxs as jsxs31 } from "react/jsx-runtime";
var MagicTableCellQuoteStatus = ({
  status,
  isArchived,
  isPublished,
  isExpired
}) => {
  return /* @__PURE__ */ jsx60(Box27, { padding: "8px 12px", children: /* @__PURE__ */ jsxs31(Flex21, { direction: "row", gap: "8px", children: [
    /* @__PURE__ */ jsx60(
      Badge3,
      {
        ...toQuoteStatusBadgeProps({ status, isPublished, isExpired })
      }
    ),
    isArchived && /* @__PURE__ */ jsx60(Badge3, { sentiment: "neutral", size: "md", children: "Archived" })
  ] }) });
};
var MagicTableCellQuoteStatus_default = MagicTableCellQuoteStatus;

// src/components/MagicTable/Cells/MagicTableCellScheduleStatus.tsx
import { Box as Box28, Flex as Flex22 } from "@chakra-ui/react";
import { Badge as Badge4 } from "@sequencehq/core-components";
import { toBillingScheduleStatusBadgeProps } from "@sequencehq/utils";
import { Fragment as Fragment17, jsx as jsx61, jsxs as jsxs32 } from "react/jsx-runtime";
var MagicTableCellScheduleStatus = ({
  status,
  isArchived
}) => {
  return /* @__PURE__ */ jsx61(Box28, { padding: "8px 12px", children: /* @__PURE__ */ jsxs32(Flex22, { children: [
    /* @__PURE__ */ jsx61(Badge4, { ...toBillingScheduleStatusBadgeProps({ status }) }),
    isArchived && /* @__PURE__ */ jsxs32(Fragment17, { children: [
      /* @__PURE__ */ jsx61(Box28, { width: "8px" }),
      /* @__PURE__ */ jsx61(Badge4, { sentiment: "neutral", size: "md", children: "Archived" })
    ] })
  ] }) });
};
var MagicTableCellScheduleStatus_default = MagicTableCellScheduleStatus;

// src/components/MagicTable/Cells/MagicTableCellAggregationType.tsx
import { Box as Box29 } from "@chakra-ui/react";
import { Badge as Badge5 } from "@sequencehq/core-components";
import { jsx as jsx62 } from "react/jsx-runtime";
var MagicTableCellAggregationType = ({
  aggregationType
}) => {
  return /* @__PURE__ */ jsx62(Box29, { padding: "8px 12px", children: /* @__PURE__ */ jsx62(Badge5, { sentiment: "neutral", size: "md", children: aggregationType }) });
};
var MagicTableCellAggregationType_default = MagicTableCellAggregationType;

// src/components/MagicTable/utils/usePersistMagicTableQueryParams.ts
import { useLocation as useLocation2 } from "react-router-dom";
var usePersistMagicTableQueryParams = () => {
  const { search, pathname } = useLocation2();
  return {
    persistMagicTableQueryParams: (url, isNavLink = false) => {
      if (url !== pathname && isNavLink) {
        return url;
      }
      return `${url}${search}`;
    },
    magicTableQueryParams: search
  };
};
var usePersistMagicTableQueryParams_default = usePersistMagicTableQueryParams;

// src/components/MagicTable/index.tsx
import { SimpleSearchMenuInput as SimpleSearchMenuInput6 } from "@sequencehq/core-components";

// src/components/MagicTable/hooks/useMagicTableQuery.ts
import { useQuery as useQuery2 } from "@sequencehq/api/utils";
var useMagicTableQuery = (apiFn, queryParams = {
  limit: 100
}) => {
  const query = useQuery2(apiFn, queryParams, {
    staleTime: 1e3 * 5,
    // 5s
    select: (data) => {
      return {
        pages: [
          {
            items: data?.items ?? [],
            pagination: {
              totalResultSize: data?.items.length ?? 0,
              after: "",
              before: ""
            }
          }
        ],
        pageParams: []
      };
    }
  });
  return {
    query: {
      ...query,
      fetchNextPage: () => query.data,
      hasNextPage: false,
      isFetchingNextPage: false
    }
  };
};

// src/components/MagicTable/MagicTableBody/MagicTableEmptyState.tsx
import { Center as Center10, Flex as Flex23, Text as Text20, Image, Link, Box as Box30 } from "@chakra-ui/react";
import { PlusIcon as PlusIcon3 } from "@heroicons/react/16/solid";
import {
  GreyGrey0,
  GreyGrey60 as GreyGrey608,
  GreyGrey80 as GreyGrey805,
  IndigoIndigo50 as IndigoIndigo506,
  Lato13Regular as Lato13Regular8,
  Lato14Bold
} from "@sequencehq/design-tokens";
import { Button as Button9 } from "@sequencehq/core-components";
import { jsx as jsx63, jsxs as jsxs33 } from "react/jsx-runtime";
var MagicTableEmptyState = ({
  entityNamePlural,
  imageSrc,
  learnMoreText,
  learnMoreHref,
  buttonNew
}) => {
  return /* @__PURE__ */ jsx63(Center10, { height: "100%", background: GreyGrey0, children: /* @__PURE__ */ jsxs33(
    Flex23,
    {
      width: "280px",
      flexDir: "column",
      gap: "8px",
      position: "relative",
      top: "-100px",
      alignItems: "center",
      children: [
        /* @__PURE__ */ jsx63(Box30, { width: "217px", height: "200px", children: /* @__PURE__ */ jsx63(
          Image,
          {
            src: imageSrc,
            width: "100%",
            height: "100%",
            objectFit: "contain"
          }
        ) }),
        /* @__PURE__ */ jsxs33(
          Flex23,
          {
            flexDir: "column",
            textAlign: "center",
            gap: "16px",
            alignItems: "center",
            children: [
              /* @__PURE__ */ jsxs33(Flex23, { flexDir: "column", gap: "4px", children: [
                /* @__PURE__ */ jsxs33(Text20, { ...Lato14Bold, color: GreyGrey805, children: [
                  "No ",
                  entityNamePlural,
                  " to show"
                ] }),
                /* @__PURE__ */ jsxs33(Text20, { ...Lato13Regular8, color: GreyGrey608, children: [
                  learnMoreText,
                  ", ",
                  /* @__PURE__ */ jsx63(Link, { href: learnMoreHref, color: IndigoIndigo506, children: "learn more" })
                ] })
              ] }),
              buttonNew && /* @__PURE__ */ jsx63(
                Button9,
                {
                  variant: "primary",
                  leadingIcon: /* @__PURE__ */ jsx63(PlusIcon3, { width: 16 }),
                  onClick: buttonNew.onClick,
                  children: buttonNew.label
                }
              )
            ]
          }
        )
      ]
    }
  ) });
};

// src/components/MagicTable/MagicTableBody/MagicTableFilterEmptyState.tsx
import { Box as Box31, Center as Center11 } from "@chakra-ui/react";
import { GreyGrey0 as GreyGrey02 } from "@sequencehq/design-tokens";
import {
  Button as Button10,
  InspectorEmptyState
} from "@sequencehq/core-components";
import { XCircleIcon as XCircleIcon2 } from "@heroicons/react/16/solid";
import { match as match9 } from "ts-pattern";
import { jsx as jsx64, jsxs as jsxs34 } from "react/jsx-runtime";
var MagicTableFilterEmptyState = ({
  entityIcon,
  entityNamePlural,
  actionClearFilters,
  actionViewAll,
  variant
}) => {
  const body = match9(variant).with(
    "TABLE",
    () => `Your filters have not returned any ${entityNamePlural}, try clearing or changing your filters.`
  ).with(
    "SAVED_VIEW",
    () => `Your saved view has not returned any ${entityNamePlural}.`
  ).exhaustive();
  const button = match9(variant).with("TABLE", () => /* @__PURE__ */ jsx64(
    Button10,
    {
      variant: "secondary",
      leadingIcon: /* @__PURE__ */ jsx64(XCircleIcon2, { width: 16 }),
      onClick: actionClearFilters,
      children: "Clear filters"
    }
  )).with("SAVED_VIEW", () => /* @__PURE__ */ jsxs34(Button10, { variant: "secondary", onClick: actionViewAll, children: [
    "View all ",
    entityNamePlural
  ] })).exhaustive();
  return /* @__PURE__ */ jsx64(Center11, { background: GreyGrey02, height: "100%", children: /* @__PURE__ */ jsx64(Box31, { width: "360px", position: "relative", top: "-100px", children: /* @__PURE__ */ jsx64(
    InspectorEmptyState,
    {
      IconComponent: entityIcon,
      title: `No ${entityNamePlural} to show`,
      body,
      button
    }
  ) }) });
};
var MagicTableFilterEmptyState_default = MagicTableFilterEmptyState;
export {
  HEIGHT,
  INCREASED_TABLE_FETCH_LIMIT,
  Loading,
  MAX_PAGES,
  MagicTable,
  MagicTableCell_default as MagicTableCell,
  MagicTableCellAggregationType_default as MagicTableCellAggregationType,
  MagicTableCellBasic,
  MagicTableCellEmpty,
  MagicTableCellInvoiceStatus_default as MagicTableCellInvoiceStatus,
  MagicTableCellLink_default as MagicTableCellLink,
  MagicTableCellProductStatus_default as MagicTableCellProductStatus,
  MagicTableCellQuoteStatus_default as MagicTableCellQuoteStatus,
  MagicTableCellScheduleStatus_default as MagicTableCellScheduleStatus,
  MagicTableDateFilterType,
  MagicTableEmptyState,
  MagicTableFilterEmptyState_default as MagicTableFilterEmptyState,
  MultiSelect,
  OVERSCAN,
  SORT_BY_KEY,
  SimpleSearchMenuInput6 as SimpleSearchMenuInput,
  VIRTUAL_TABLE_FETCH_LIMIT,
  VirtualTable_default as VirtualTable,
  activeFiltersToSearchParams,
  adaptApiToVirtualTable,
  magicTableToApiQueryParams,
  useLinkMagicTableWithSearchParams,
  useMagicTableInfiniteQuery,
  useMagicTableQuery,
  useMagicTableToolbarContext,
  usePersistMagicTableQueryParams_default as usePersistMagicTableQueryParams,
  useSimpleSearch,
  useVirtualTable
};
//# sourceMappingURL=index.js.map